import React from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import TendorLeftMenu from "../Tender/LeftMenu_Tendor";
import { Row, Col } from "react-bootstrap";

//testing

function StatementExpenELe() {
  const tenderJSON = [
    // File storing 2026 folder

     {
      Title: "Notice Inviting Tenders for Supply, Installation of Printers with Buy back of Existing Printers - Tender No. IITT/CC/2026-27/45 dated 19.10.2026.",
    
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2745.pdf",
          LinkName: <>Tender Document <br /></>,
        },

      ],
      eProcurementLinks: [
      {
          Link: "",
          LinkName: <>Bid Download Start Date and Time: 19.10.2026, 18:00 Hrs<br />
          Bid Submission Start Date and Time: 19.10.2026, 18:30 Hrs<br />
            Bid End Date/ Time: 09.11.2026 18:00 Hrs<br />
            Technical Bid Opening Date/ Time: 10.11.2026, 18:30 Hrs<br />
          </>,
        },


      ],
      OpenDate: "19.10.2026, 18:00 Hrs",
      EndDate:  "09.11.2026, 18:00 Hrs",
    },
    {
      Title: "Notice Inviting Tenders for Supply and Installation of Computer Workstation(1 No) CPPP  Tender No. IITT/CO/2026-27/52 dated 16.10.2026.",
    
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCO2026-2752.pdf",
          LinkName: <>Tender Document <br /></>,
        },

      ],
      eProcurementLinks: [
      {
          Link: "",
          LinkName: <>Bid Start Date: 16.10.2020 18:00 Hrs<br />
            Bid End Date/ Time: 07.11.2026 18:00 Hrs<br />
            Bid Opening Date/ Time: 09.11.2026 10:00 Hrs <br />

          </>,
        },


      ],
      OpenDate: "16.10.2026, 18:00 Hrs",
      EndDate:  "07.11.2026, 18:00 Hrs",
    },
      {
      Title: "Notice Inviting Quotation for Supply, Fabrication and Fixing of SS 304 Grade Cycle Parking Railings at IIT Tirupati - NIQ No: IITT/NIQ/2026-27/Civil/009 dated 14.10.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTNIQ2026-27Civil009.pdf",
          LinkName: <>NIQ Document <br /></>,
        },

      ],
      eProcurementLinks: [
      
          {
          Link: "#",
          LinkName: <>NIQ Submission Start date: 16.10.2026 <br />
            Last Date for Submission of Sealed Quotations: 23-10-2026 up to 15.00 PM</>,
        },


      ],
      OpenDate: "16.10.2026, 09:00 Hrs",
      EndDate:  "23.10.2026, 15:00 Hrs",
    },

    {
      Title: "Notice Inviting Expression Of Interest (Eoi) For Empanelment Of E-Rickshaw Service Providers. - EOI Ref No. IITT/GA/2026-27/53 dated 12.10.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTGA2026-2753.pdf",
          LinkName: <>Tender Document <br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>
          Bid Opening Date/Time: 03.11.2026, 15:30 Hrs<br />
          </>,
        },


      ],
      OpenDate: "13.10.2026, 09:00 Hrs",
      EndDate:  "02.11.2026, 15:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Single Crystal X-Ray Diffractometer (SCXRD) - CPPP Tender No: IITT/CIF/2026-27/44 dated 08.10.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCIF2026-2744.pdf",
          LinkName: <>Tender Document <br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>
          Bid Opening Date/Time: 17.11.2026 09:00 Hrs<br />
          </>,
        },


      ],
      OpenDate: "19.10.2026 09:00 Hrs",
      EndDate:  "16.11.2026 09:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning and training of UV Vis Spectrophotometer - CPPP Tender No: IITT/CE/2026-27/46 dated 01.10.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2746.pdf",
          LinkName: <>Tender Document <br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>
          Bid Opening Date/Time: 23.10.2026, 18:30 Hrs<br />
          </>,
        },


      ],
      OpenDate: "01.10.2026, 18:00 Hrs",
      EndDate: " 22.10.2026, 18:00 Hrs",
    },
     
    
    
    {
      Title: "Supply and Installation of Computer Workstations  and Network Attached Storage - CPPP Bid No: IITT/CY/2026-27/48, Dated 29.09.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2748.pdf",
          LinkName: <>Tender Document <br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2748_prebid_minutes.pdf",
          LinkName: <>Pre-bid Minutes<br /></>,
        },
      
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2748_Corrigendum1.pdf",
          LinkName: <>Corrigendum I <br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders: 29.09.2026 18:30 Hrs<br />
          Pre-bid Meeting : 06.10.2026 11:00 Hrs<br />
          Bid submission start date & time : 13.10.2026 09:00 Hrs<br />
          Bid submission close date & time : 03.11.2026 18:00 Hrs<br />
          Opening of Technical bids : 04.11.2026 18:30 Hrs<br />


          </>,
        },


      ],
      OpenDate: "13.10.2026 09:00 Hrs",
      EndDate: " 03.11.2026 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, and Commissioning of Computer Workstations - CPPP Bid No: IITT/CE/2026-27/47, Dated 22.09.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2747_prebid_minutes.pdf",
          LinkName: <>Pre-bid Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2747_Corrigendum2.pdf",
          LinkName: <>Corrigendum II <br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2747_Corrigendum1.pdf",
          LinkName: <>Corrigendum I <br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2747.pdf",
          LinkName: <>Tender Document <br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Download Start Date and Time: 22.09.2026, 12:00 Hrs<br />
            Pre-bid Meeting: 25.09.2026, 15:00 Hrs<br />
            Bid Submission Start Date and Time: 22.09.2026, 12:00 Hrs<br />
            Bid End Date/ Time: <s>13.10.2026, 18:00 Hrs</s> 21.10.2026 18:00 hrs<br />
            Technical Bid Opening Date/ Time: <s>14.10.2026, 18:30 Hrs</s> 22.10.2026 18.30 hrs<br />


          </>,
        },


      ],
      OpenDate: "22.09.2026, 12:00 Hrs",
      EndDate: " 21.10.2026, 18:00 Hrs",
    },
    {
      Title: "Operations and Maintenance of 100 kLD Sewage Treatment Plant, 275 kLD Sewage Treatment Plant, 325 kLD Sewage Treatment Plant, 55 kLD Domestic Water Treatment Plant & 600 kLD Domestic Water Treatment Plants in IIT Tirupati - e-Tender No: IITT/EU/EE(C)/26-27/006, Dated: 17.06.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27006_Corrigendum2.pdf",
          LinkName: <>CORRIGENDUM 2 <br /></>,
        },

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27006_Corrigendum1.pdf",
          LinkName: <>CORRIGENDUM 1 <br /></>,
        },

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27006.pdf",
          LinkName: <>NOTICE INVITING TENDER <br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Online Publication & Tender Document Download Date & Time: 17.09.2026, 15:00 Hrs<br />
            Bid Submission Start Date & Time: 17.09.2026, 15:00 Hrs<br />
            Pre-Bid Meeting: 23-09-2026, 10:30 Hrs.<br />
            Bid Submission End Date & Time: 08.10.2026, 15:00 Hrs<br />
            Technical Bid Opening Date & Time: 09.10.2026, 15:30 Hrs.<br />


          </>,
        },


      ],
      OpenDate: "17-09-2026, 15:00 Hrs",
      EndDate: " 08-10-2026, 15:00 Hrs",
    },
    {
      Title: "Notice Inviting Tenders for Mechanical Operation & Maintenance Services in IIT Tirupati - e-Tender No: IITT/EU/EE(C)/26-27/005, Dated: 17.06.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27005_Corrigendum2.pdf",
          LinkName: <>Corrigendum-2 <br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27005_Corrigendum1.pdf",
          LinkName: <>Corrigendum-1 <br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27005.pdf",
          LinkName: <>NOTICE INVITING TENDER <br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Online Publication & Tender Document Download Date & Time: 17.09.2026, 15:00 Hrs<br />
            Bid Submission Start Date & Time: 17.09.2026, 15:00 Hrs<br />
            Pre-Bid Meeting: 23.09.2026, 11:00 Hrs<br />
            Bid Submission End Date & Time: 08.10.2026, 15:00 Hrs<br />
            Technical Bid Opening Date & Time: 09.10.2026, 15:30 Hrs<br />


          </>,
        },


      ],
      OpenDate: "17-09-2026, 15:00 Hrs",
      EndDate: " 08-10-2026, 15:00 Hrs",
    },
    {
      Title: "Notice Inviting Tenders for Electrical Operations and Maintenance Services in IIT Tirupati - e-Tender No: IITT/EU/EE(C)/26-27/004  dated 16.09.2026.",
      Documents: [
{
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27004_Corrigendum2.pdf",
          LinkName: <>Corrigendum-2 <br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27004_Corrigendum1.pdf",
          LinkName: <>Corrigendum-1 <br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27004.pdf",
          LinkName: <>NOTICE INVITING TENDER <br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEUEE(C)26-27004_SLDs.pdf",
          LinkName: <>SLD <br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Online Publication & Tender Document Download Date & Time : 16.09.2026, 15:00 Hrs.<br />
            Bid Submission Start Date & Time : 16.09.2026, 15:00 Hrs.<br />
            Pre-Bid Meeting : 23.09.2026, 10:00 Hrs. <br />
            Bid Submission End Date & Time : 07.10.2026, 15:00 Hrs.<br />
            Technical Bid Opening Date & Time : 08.10.2026, 15:00 Hrs<br />


          </>,
        },


      ],
      OpenDate: "16-09-2026, 15:00 Hrs",
      EndDate: " 07-10-2026, 15:00 Hrs",
    },
    {
      Title: "Supply Installation Testing and Commissioning of Composite 3D Printer - GeM Bid No: GEM/2026/B/8017241 dated 11.09.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/GEM2026B8017241_TER.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/GEM2026B8017241.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Start Date: 11/09/2026<br />
            Bid End Date/ Time: 03/10/2026 18:00 Hrs<br />
            Bid Opening Date/ Time: 04/10/2026 18:00 Hrs <br />

          </>,
        },


      ],
      OpenDate: "11.09.2026",
      EndDate: " 03/10/2026 18:00 Hrs",
    },
    {
      Title: "procurement of  NetSim Cyber - GeM Bid No: GEM/2026/B/8022077 dated 11.09.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/GEM2026B8022077.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Start Date: 11.09.2026<br />
            Bid End Date/ Time:  21.09.2026, 17:00 Hrs<br />
            Bid Opening Date/ Time:  22.09.2026, 17:30 Hrs <br />

          </>,
        },


      ],
      OpenDate: "11.09.2026",
      EndDate: " 21.09.2026, 17:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of 3D Printer for Fabrication of Microreactors and Microfluidic Devices with Accessories and Software - Tender No. IITT/CH/2026-27/31 dated 11.09.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCH2026-2731.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 11.09.2026 11:00 Hrs<br />
            Pre-bid meeting date & time : 16.09.2026 11:00 Hrs<br />
            Bid submission start date & time : 23.09.2026 09:00 Hrs<br />
            Bid submission close date & time : 21.10.2026 18:00 Hrs<br />
            Opening of Technical bids : 22.10.2026 18:30 Hrs <br />

          </>,
        },
        {
          Link: "  https://meet.google.com/ecx-gesb-wwz",
          LinkName: <>Pre-Bid Meeting Link - https://meet.google.com/ecx-gesb-wwz <br /></>,
        },

      ],
      OpenDate: "23.09.2026 09:00 Hrs",
      EndDate: " 21.10.2026 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of FPGA Development Boards, Robotics Kits, and Design Software - Tender No. IITT/CS/2026-27/41 dated 09.09.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2741_PreBidMinutes.pdf",
          LinkName: <>Pre-Bid Meeting Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2741.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 09.09.2026 18:00 Hrs<br />
            Pre-bid Meeting : 15.09.2026 10:30 Hrs<br />
            Bid submission start date & time : 09.09.2026 18:30 Hrs<br />
            Bid submission close date & time : 30.09.2026 18:00 Hrs<br />
            Opening of Technical bids : 01.10.2026 18:30 Hrs <br />

          </>,
        },

      ],
      OpenDate: "09.09.2026 18:30 Hrs",
      EndDate: " 30.09.2026 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of GPU based Servers And associated Items - Tender No. IITT/CS/2026-27/37 dated 04.09.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2737_Pre_bid_Minutes.pdf",
          LinkName: <>Pre-bid Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2737_Corrigendum1.pdf",
          LinkName: <>Corrigendum 1<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2737.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders 04.09.2026 18:00 Hrs<br />
            Pre-bid Meeting : 11.09.2026 11:30 Hrs<br />
            Bid submission start date & time : 21.09.2026 18:00 Hrs<br />
            Bid submission close date & time : 20.10.2026 18:00 Hrs<br />
            Opening of Technical bids : 21.10.2026 18:30 Hrs <br />

          </>,
        },

      ],
      OpenDate: "21.09.2026 18:00 Hrs",
      EndDate: " 20.10.2026 18:00 Hrs",
    },
    {
      Title: "Procurement of Open Pluggable Specification (OPS) Compute Device - GeM Bid No: GEM/2026/B/7915580 dated 04.09.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/GEM2026B7915580.pdf",
          LinkName: <>GeM Bid Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Start Date: 04.09.2026<br />
            Bid End Date/ Time:  25.09.2026, 17:00 Hrs<br />
            Bid Opening Date/ Time:   26.09.2026, 17:00 Hrs <br />

          </>,
        },

      ],
      OpenDate: "04.09.2026",
      EndDate: " 25.09.2026, 17:00 Hrs",
    },
    {
      Title: "Notice Inviting Tender for the Supply and Installation of GPU based Workstations at Indian Institute of Technology Tirupati - Tender No. IITT/CS/2026-27/38 dated 01.09.2026.",
      Documents: [


        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2738_TER.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2738_premin.pdf",
          LinkName: <>Pre-bid Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2738_Corr1.pdf",
          LinkName: <>Corrigendum I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2738.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 01.09.2026 18:30 Hrs <br />
            Pre- Bid Meeting : 04.09.2026 11.00 Hrs <br />
            Bid submission start date & time : 07.09.2026 18:30 Hrs <br />
            Bid submission close date & time : 21.09.2026 18:00 Hrs <br />
            Opening of Technical bids : 22.09.2026 18:30 Hrs <br />

          </>,
        },

      ],
      OpenDate: "01.09.2026 18:30 Hrs",
      EndDate: " 21.09.2026 18:00 Hrs",
    },
    {
      Title: "Supply, installation, testing, commissioning and training of the Atomic Force Microscope Tender No. IITT/CIF/2026-27/42 dated 01.09.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCIF2026-2742.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 01-09-2026 18.00 hrs<br />
            Bid submission start date & time : 01-09-2026 18.00 hrs<br />
            Bid submission close date & time : 29-09-2026 18.00 hrs<br />
            Opening of Technical bids : 30-09-2026 18.30 hrs <br />

          </>,
        },

      ],
      OpenDate: "01-09-2026 18.00 hrs",
      EndDate: " 29-09-2026 18.00 hrs",
    },
    {
      Title: "Notice Inviting Tender for Providing Comprehensive Group Term Life Insurance (GTLI) Policy for Regular Employees of Indian Institute of Technology Tirupati. Tender No. IITT/EST/2026-27/43 dated 31.08.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEST2026-2743.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 31.08.2026<br />
            Bid submission time : 14 days from the date of issue of Tender Notice<br />
            Bid submission close date & time : 15.09.2026, 16:00 Hrs.<br />
            Date & time of opening of bids : 15.09.2026, 16:30 Hrs. <br />

          </>,
        },

      ],
      OpenDate: "31.08.2026 18:00 Hrs",
      EndDate: " 15.09.2026, 16:00 Hrs",
    },
    {
      Title: "Supply and Installation of Server. Tender No. IITT/CE/2026-27/40 dated 31.08.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2740_TER.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2740.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 31.08.2026 18:00 Hrs<br />
            Bid submission start date & time : 31.08.2026 18:00 Hrs<br />
            Bid submission close date & time : 21.09.2026 18:00 Hrs<br />
            Opening of Technical bids : 22.09.2026 18:30 Hrs <br />

          </>,
        },

      ],
      OpenDate: "31.08.2026 18:00 Hrs",
      EndDate: " 21.09.2026 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Super Resolution Fluorescence Microscope (SRFM). Tender No. IITT/CIF/2026-27/36",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCIF2026-2736PrebidMinutes.pdf",
          LinkName: <>Pre-bid Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCIF2026-2736Corrigendum1.pdf",
          LinkName: <>Corrigendum I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCIF2026-2736.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Download Start Date and Time: 25.08.2026, 18:00 Hrs<br />
            Pre-bid Meeting: 31.08.2026, 11:00 Hrs<br />
            Technical Bid Opening Date/ Time:  23.09.2026, 18:30 Hrs<br />
          </>,
        },

      ],
      OpenDate: "25.08.2026, 18:00 Hrs",
      EndDate: " 22.09.2026, 18:00 Hrs",
    },

    {
      Title: "Procurement of Battery-operated Scissor Lift (1 No). GEM/2026/B/7924768, Dt. 18/08/2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/GEM2026B7924768.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Start Date: 18.08.2026, 15:17 Hrs<br />
            Pre-bid Meeting: 24.08.2026, 15:00 Hrs<br />
            Bid End Date/ Time: 08.09.2026, 15:00 Hrs<br />
            Bid Opening Date/ Time:  08.09.2026, 15:30 Hrs<br />
          </>,
        },

      ],
      OpenDate: "18.08.2026, 15:17 Hrs",
      EndDate: " 08.09.2026, 15:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, and Commissioning of Computer Workstations. CPPP Tender No: IITT/EE/2026-27/39, Dt. 17/08/2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEE2026-2739_Corrigendum1.pdf",
          LinkName: <>Corrigendum 1<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEE2026-2739.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 17.08.2026 12:30 Hrs<br />
            Pre-Bid Meeting : 19.08.2026 15:00 Hrs<br />
            Bid submission start date & time : 21.08.2026 09:00 Hrs<br />
            Bid submission close date & time : 11.09.2026 18:00 Hrs<br />
            Opening of Technical bids : 14.09.2026 09:00 Hrs<br />
          </>,
        },

      ],
      OpenDate: "17.08.2026 12:30 Hrs",
      EndDate: " 11.09.2026 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning and Training of Portable XRF with calibration kits and accessories. CPPP Tender No: IITT/EE/2026-27/33, Dt. 13/08/2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEE2026-2733.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 13.08.2026 17:00 Hrs<br />
            Prebid Meeting 18.08.2026 11.30 Hrs<br />
            Bid submission start date & time 21.08.2026 17:00 Hrs<br />
            Bid submission close date & time 18.09.2026 17:00 Hrs<br />
            Opening of Technical bids 21.09.2026 10:00 Hrs<br />
          </>,
        },

      ],
      OpenDate: "13.08.2026 17:00 Hrs",
      EndDate: " 18.09.2026 17:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning and training of Two port Glove Box with Refrigerator. CPPP Tender No: IITT/CSRC/CY/2026-27/04, Dt. 12/08/2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCSRCCY2026-2704_Prebitmeeting.pdf",
          LinkName: <>Pre-Bid Meeting Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCSRCCY2026-2704_C2.pdf",
          LinkName: <>Corregendum-II<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCSRCCY2026-2704_C1.pdf",
          LinkName: <>Corregendum-I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITT-CSRC-CY-2026-27-04.pdf",
          LinkName: <>Tender Document<br /></>,
        }
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders:- 12/08/2026, 18:00 Hrs<br />
            Pre Bid Date: 19/08/2026, 12:00 Hrs<br />
            Technical Bids Opening Date/Time:  <s>17/09/2026, 18:30 Hrs</s> 19/09/2026, 18:30 Hrs
          </>,
        },

      ],
      OpenDate: "26/08/2026, 18:00 Hrs",
      EndDate: <><s>16/09/2026, 18:00 Hrs</s> 18/09/2026, 18:00 Hrs<br /></>,
    },
    {
      Title: "Notice inviting tender for the Supply and installation of Simulia ABAQUS Software Extended for Academic Research - Tender No. IITT/CE/2026-27/35 dated 04.08.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2735_Corrigendum1.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2735.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 04.08.2026 18:30 Hrs<br />
            Bid submission start date & time : 04.08.2026 18:30 Hrs<br />
            Bid submission close date & time : 12.09.2026 18:30 Hrs<br />
            Opening of Technical bids : 14.09.2026 10:30 Hrs
          </>,
        },



      ],
      OpenDate: "04.08.2026 18:30 Hrs",
      EndDate: "12.09.2026 18:30 Hrs",
    },
    {
      Title: "GeM Bid for Gym Equipment - Gem Bid No GEM/2026/B/7879744 dated 05.08.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/GEM2026B7879744.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 05.08.2026<br />
            Bid Pre Bid Date/Time: 12.08.2026 11:00:00<br />
            Bid Due Date / Time:  26.08.2026 16:00:00<br />
            Bid Opening Date / Time:  26.08.2026 16:30:00
          </>,
        },



      ],
      OpenDate: "05.08.2026",
      EndDate: "26.08.2026 16:00:00 Hrs",
    },
    {
      Title: "Notice inviting tender for the Supply and Installation of Desktop Computers(200 Nos) - Tender No. IITT/CC/2026-27/34 dated 04.08.2026.",
      Documents: [


        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2734_PTER.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2734_Corrigendum2.pdf",
          LinkName: <>corrigendum 2<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2734_Corrigendum1.pdf",
          LinkName: <>corrigendum 1<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2734.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 04.08.2026 18:30 Hrs<br />
            Bid submission start date & time : 04.08.2026 18:30 Hrs<br />
            Bid submission close date & time : 26.08.2026 10:00 Hrs <br />
            Opening of Technical bids : 27.08.2026 10:30 Hrs<br />"Representations, if any, towards the technical disqualification, may be sent to purchase@iittp.ac.in with subject "Representation against technical evaluation of bid  IITT/CC/2026-27/34" before 5:00 PM, 10 Sept 2026."
          </>,
        },



      ],
      OpenDate: "04.08.2026 18:30 Hrs",
      EndDate: "26.08.2026 10:00 Hrs",
    },
    {
      Title: "Notice inviting tender for the Design, Supply, Installation, Testing, Commissioning, and Maintenance of 800 TFlops Hybrid CPU-GPU HPC Cluster at IIT Tirupati. - Tender No. IITT/CC/2026-27/26 dated 04.08.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2726_corr7.pdf",
          LinkName: <>Corrigendum VII<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2726_corr6.pdf",
          LinkName: <>Corrigendum VI<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2726_prebid_minutes.pdf",
          LinkName: <>Pre-Bid Meeting Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2726_Corrigendum5.pdf",
          LinkName: <>Corrigendum V<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2726_Corrigendum4.pdf",
          LinkName: <>Corrigendum IV<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2726_Corrigendum3.pdf",
          LinkName: <>Corrigendum III<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2726_Corrigendum2.pdf",
          LinkName: <>Corrigendum II<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2726_Corrigendum1.pdf",
          LinkName: <>Corrigendum I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2726.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 04.08.2026 16:00 Hrs<br />
            Pre bid Meeting : 24.08.2026 11:00 Hrs <br />
            Bid submission start date & time : 21.09.2026, 09:00 Hrs<br />
            Bid submission close date & time : 30.10.2026, 18:30 Hrs <br />
            Opening of Technical bids : 02.11.2026, 09:00 Hrs<br />
          </>,
        },



      ],
      OpenDate: "21.09.2026 09:00 Hrs",
      EndDate: "30.10.2026, 18:30 Hrs",
    },
    {
      Title: "Notice inviting tender for the Supply and installation of GPU based workstation. - NIQ No: IITT/CS/2026-27/32 dated 04.08.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCS2026-2732.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 04.08.2026 18:00 Hrs<br />
            Bid submission start date & time : 04.08.2026 18:00 Hrs<br />
            Bid submission close date & time : 18.08.2026 18:00 Hrs<br />
            Opening of Technical bids : 19.08.2026 18:30 Hrs<br />
          </>,
        },



      ],
      OpenDate: "04.08.2026 18:00 Hrs",
      EndDate: "18.08.2026 18:00 Hrs",
    },

    {
      Title: "Notice inviting tender for the supply, installation, testing, and commissioning of laboratory furniture including fume hood. - NIQ No: IITT/CY/2026-27/09 dated 21.07.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2709_Corrigendum6.pdf",
          LinkName: <>Corrigendum VI<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2709_prebid_minutes.pdf",
          LinkName: <>Pre-bid Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2709_Corrigendum5.pdf",
          LinkName: <>Corrigendum V<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2709_Corrigendum4.pdf",
          LinkName: <>Corrigendum IV<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2709_Corrigendum3.pdf",
          LinkName: <>Corrigendum III<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2709_corr2.pdf",
          LinkName: <>Corrigendum II<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2709_Corrigendum1.pdf",
          LinkName: <>Corrigendum I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2709.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 21.07.2026 09:00 Hrs<br />
            Pre-Bid Meeting : 31.07.2026 11:00 Hrs <br />
            Bid submission start date & time : 07.09.2026, 09:00 Hrs<br />
            Bid submission close date & time : 12.10.2026, 18:00 Hrs<br />
            Opening of Technical bids : 13.10.2026, 18:30 Hrs<br />
          </>,
        },



      ],
      OpenDate: "21.07.2026 09:00 Hrs",
      EndDate: "12.10.2026, 18:00 Hrs",
    },
    {
      Title: "Notice Inviting Quotation for Construction of Two Natural Turf Cricket Practice Pitches Including Gravel Drainage Layer, Root Zone Preparation, Pitch Clay Layer, Bermuda Grass Turfing and Providing Waterproof Pitch Cover Sheet (30 m × 30 m) at IIT Tirupati. - NIQ No: IITT/NIQ/2026-27/Civil/007 dated 15.07.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTNIQ2026-27Civil007_Corrigendum1.pdf",
          LinkName: <>Corrigendum 1<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTNIQ2026-27Civil007_Section_and_Layout_Sketch.pdf",
          LinkName: <>Section and Layout Sketch<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTNIQ2026-27Civil007.pdf",
          LinkName: <>NIQ Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>
          </>,
        },



      ],
      OpenDate: "15.07.2026 10:00 Hrs",
      EndDate: "27.07.2026 3.00 PM",
    },

    {
      Title: "Supply, Installation, Testing, Commissioning and Training of Differential Scanning Calorimeter (Low volume). - CPPP Tender No. IITT/CH/2026-27/20 dated 13.07.2026.",
      Documents: [


        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCH2026-2720_TER.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCH2026-2720_Corrigendum_1.pdf",
          LinkName: <>Corrigendum 1<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2720.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 13.07.2026 18:00 Hrs<br />
            Pre-Bid Meeting : 21.07.2026 11:00 Hrs <br />
            Bid submission start date & time : 28.07.2026 10:00 Hrs<br />
            Bid submission close date & time : 18.08.2026 10:00 Hrs<br />
            Opening of Technical bids : 19.08.2026 10:30 Hrs<br />
          </>,
        },
        {
          Link: "  https://meet.google.com/ovz-gfie-ppf",
          LinkName: <>Pre-Bid Meeting Link - https://meet.google.com/ovz-gfie-ppf <br /></>,
        },


      ],
      OpenDate: "28.07.2026 10:00 Hrs",
      EndDate: "18.08.2026 10:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Network Attached Storage (40TB expandable+ High end work Station). - CPPP Tender No. IITT/CE/2026-27/24 dated 10.07.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCE2026-2724_TER.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCE2026-2724.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 10.07.2026 18:00 Hrs<br />
            Bid submission start date & time : 10.07.2026 18:30 Hrs<br />
            Bid submission close date & time : 31.07.2026 18:00 Hrs<br />
            Opening of Technical bids : 03.08.2026 10:00 Hrs<br />
          </>,
        },


      ],
      OpenDate: "10.07.2026 15.00 Hrs",
      EndDate: "31.07.2026 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning and Training of 1560 nm Laser system. - CPPP Tender No. IITT/CSRC/PH/2026-27/001 dated 10.07.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCSRCPH2026-27001_TE.pdf",
          LinkName: <>Technical Evaluation<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCSRCPH2026-27001.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 09.07.2026 09.00 Hrs<br />
            Prebid meeting date & time : 10.07.2026 15.00 Hrs<br />
            Bid submission start date & time : 10.07.2026 15.00 Hrs<br />
            Bid submission close date & time : 01.08.2026 18.00 Hrs<br />
            Opening of Technical bids : 03.08.2026 18.30 Hrs<br />
          </>,
        },


      ],
      OpenDate: "10.07.2026 15.00 Hrs",
      EndDate: "01.08.2026 18.00 Hrs",
    },

    {
      Title: "Supply, Installation, Testing, Commissioning and training of Superconducting Nanowire Single Photon Detector (SNSPD) system. - CPPP Tender No. IITT/CSRC/PH/2026-27/002 dated 09.07.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCSRCPH2026-27002_TE.pdf",
          LinkName: <>Technical Evaluation<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCSRCPH2026-27002_Pre-Bid_Meeting_Minutes.pdf",
          LinkName: <>Pre-Bid Meeting Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCSRCPH2026-27002_Corrigendum.pdf",
          LinkName: <>Corrigendum I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCSRCPH2026-27002.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 09.07.2026 09.00 Hrs<br />
            Prebid meeting date & time : 15.07.2026 11.00 Hrs<br />
            Bid submission start date & time : 28.07.2026 09:00 hrs<br />
            Bid submission close date & time : 19.08.2026 18:00 hrs<br />
            Opening of Technical bids : 20.08.2026 18.30 hrs<br />
          </>,
        },
        {
          Link: "https://meet.google.com/xyb-fxhg-szw",
          LinkName: <>Pre-Bid Meeting Link - https://meet.google.com/xyb-fxhg-szw <br /></>,
        },

      ],
      OpenDate: "28.07.2026 09.00 Hrs",
      EndDate: "19.08.2026 10.00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Customised Glove Box System with Coupled Accessories for Electrochemical Device Fabrication and Testing. - CPPP Tender No. IITT/CY/2026-27/28 dated 03.07.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2728_TER.pdf",
          LinkName: <>Technical evaluation report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2728_corrigendumIV.pdf",
          LinkName: <>Corrigendum IV<br /></>,
        }, {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2728_Prebidminutes.pdf",
          LinkName: <>Pre-bid meeting Minutes<br /></>,
        }, {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2728_corrigendumIII.pdf",
          LinkName: <>Corrigendum III<br /></>,
        }, {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2728_corrigendumII.pdf",
          LinkName: <>Corrigendum II<br /></>,
        }, {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCY2026-2728_Corrigendum.pdf",
          LinkName: <>Corrigendum I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCY2026-2728.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 03.07.2026 18:00 Hrs<br />
            Pre-bid meeting date & time : 10.07.2026 11:00 Hrs<br />
            Bid submission start date & time : 17.07.2026 10:00 Hrs<br />
            Bid submission close date & time : 07.08.2026 18:00 Hrs<br />
            Opening of Technical bids : 10.08.2026 10:30 Hrs<br />
          </>,
        },

      ],
      OpenDate: "17.07.2026 10:00 Hrs",
      EndDate: "07.08.2026 18:00 Hrs",
    },
    {
      Title: "Testing and Supply of High Accuracy Pressure Transducer - CPPP Tender No. IITT/CH/2026-27/29 dated 26.06.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2729.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 26.06.2026 09:00 Hrs<br />
            Pre-bid meeting date & time : 02.07.2026 11:00 Hrs<br />
            Bid submission start date & time : 06.07.2026 09:00 Hrs<br />
            Bid submission close date & time : 03.08.2026 10:00 Hrs<br />
            Opening of Technical bids : 04.08.2026 10:30 Hrs<br />
          </>,
        },

      ],
      OpenDate: "06.07.2026 09:00 Hrs",
      EndDate: "03.08.2026 10:00 Hrs",
    },

    {
      Title: "Supply, Installation, Testing, Commissioning and Training Computer Controlled Water Cooling Tower and Packing Characteristic Accessory. CPPP Tender No. IITT/CH/2026-27/16 dated 23.06.2026.",
      Documents: [

       
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2716_corrigendum1.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2716_minutes.pdf",
          LinkName: <>Pre-bid minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2716.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 23.06.2026 18:00 Hrs
            Pre Bid Meeting : 30.06.2026 11:00 Hrs
            Bid submission start date & time : 07.07.2026 10:00 Hrs
            Bid submission close date & time : 28.07.2026 10:00 Hrs
            Opening of Technical bids : 29.07.2026 10:30 Hrs<br />
          </>,
        },
        {
          Link: "https://meet.google.com/tst-ajrw-tdd",
          LinkName: <>Pre-Bid Meeting Link - https://meet.google.com/tst-ajrw-tdd<br />"Representations, if any, towards the technical disqualification, may be sent to purchase@iittp.ac.in with subject "Representation against technical evaluation of bid IITT/CH/2026-27/16" before 12:00 PM,  19 October 2026."</>,
        },
      ],
      OpenDate: "07.07.2026 10:00 Hrs",
      EndDate: "28.07.2026 10:00 Hrs",
    },

    {
      Title: "Procurement of Thickness Measurement System. CPPP Tender No. IITT/EE/2026-27/27 dated 22.06.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2727_Pre_bid_Minutes.pdf",
          LinkName: <>Pre-bid Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2727.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication / Download of Tenders : 19.06.2026 18:30 Hrs<br />
            Pre- Bid Meeting : 25.06.2026 15:00 Hrs<br />
            Bid Start Date: 02.07.2026, 09:00 Hrs<br />
            Bid End Date / Time: 30.07.2026, 18:00 Hrs<br />
            Bid Opening Date / Time:  31.07.2026, 18:30 Hrs<br />
            Pre-Bid Meeting Link - https://meet.google.com/ttw-kckd-dbg
          </>,
        },
      ],
      OpenDate: "22.06.2026 18:30 Hrs",
      EndDate: "30.07.2026 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Computer Controlled Crystallisation Unit with Continuous Feed Accessory. Tender No. IITTCH2026-2718.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2718.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCH2026-2718_Technical_evaluation_report.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 19.06.2026 18:00 Hrs<br />
            Pre- Bid Meeting 29.06.2026 11:00 Hrs<br />
            Bid submission start date & time 06.07.2026 18:00 Hrs<br />
            Bid submission close date & time 27.07.2026 18:00 Hrs<br />
            Opening of Technical bids 28.07.2026 : 18:30 Hrs



          </>,
        },
      ],
      OpenDate: "06.07.2026 18:00 Hrs",
      EndDate: "27.07.2026 18:00 Hrs",
    },
    {
      Title: "NOTICE INVITING EXPRESSION OF INTEREST (EOI) FOR GROUP HEALTH INSURANCE POLICY FOR IIT TIRUPATI STUDENTS. EOI Reference Number: IITT/SAT/2026-27/048 Dated 19-06-2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTSAT2026-27048_Corrigendum1.pdf",
          LinkName: <>Corrigendum 1<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTSAT2026-27048.pdf",
          LinkName: <>EOI (Expression of Interest)<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTSAT2026-27048_Annexure_VIII.xlsb",
          LinkName: <>Annexure VIII<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTSAT2026-27048_Annexure_IX.xlsb",
          LinkName: <>Annexure IX<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTSAT2026-27048_Annexure_X.pptx",
          LinkName: <>Annexure X<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTSAT2026-27048_Annexure_XI.xls",
          LinkName: <>Annexure XI<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTSAT2026-27048_Annexure_XII.pdf",
          LinkName: <>Annexure XII<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTSAT2026-27048_Annexure_XIII.xlsx",
          LinkName: <>Annexure XIII<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of EOI : 19.06.2026 16:00 hrs<br />
            Pre-Bid Meeting : 23.06.2026 11:30 hrs<br />
            Bid Submission start date & time : 24.06.2026 10:00 hrs<br />
            Bid Submission close date & time : 13.07.2026 17:00 hrs<br />
            Technical Bid Opening Date & Time : 14.07.2026 10:00 hrs<br />
            Financial Bid Opening Date & Time : Will be notified after technical evaluation
          </>,
        },

      ],
      OpenDate: "24.06.2026 10:00 hrs",
      EndDate: "13.07.2026 17:00 hrs",
    },

    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Isothermal Microcalorimetry System.Tender No. IITT/CH/2026-27/23 Dated 12.06.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2723_Pre_bid_Minutes.pdf",
          LinkName: <>Pre-bid Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2723_Corrigendum1.pdf",
          LinkName: <>Corrigendum 1<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2723_Corrigendum2.pdf",
          LinkName: <>Corrigendum 2<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2723.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 12.06.2026 09:00 Hrs<br />
            Pre-bid meeting date & time : 24.06.2026 11:00 hrs<br />
            Bid submission start date & time : 01.07.2026 09:00 hrs<br />
            Bid submission close date & time : 29.07.2026 09:00 hrs<br />
            Opening of Technical bids : 30.07.2026 10.00 hrs </>,
        },
        {
          Link: " https://meet.google.com/zab-ddgb-qox",
          LinkName: <>Pre-bid Meeting link<br /></>,
        },
      ],
      OpenDate: "01.07.2026 09:00 hrs",
      EndDate: "29.07.2026 09:00 hrs",
    },

    {
      Title: "Supply, Installation, Testing, Commissioning and Training of Differential Scanning Calorimeter, Tender No. IITT/CH/2026-27/17.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2717_Pre_Bid_Minutes.pdf",
          LinkName: <>Pre-Bid Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2717_Corrigendum3.pdf",
          LinkName: <>Corrigendum III<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2717_Corrigendum2.pdf",
          LinkName: <>Corrigendum II<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2717_Corrigendum1.pdf",
          LinkName: <>Corrigendum I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2717.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication/Download of Tenders : 11.06.2026 18:30 Hrs<br />
            Pre-Bid Meeting : 18.06.2026 11:00 Hrs<br />
            Bid submission start date & time : 09.07.2026 09:00 hrs<br />
            Bid submission close date & time : 30.07.2026 18:00 hrs<br />
            Opening of Technical bids : 31.07.2026 18.30 hrs


          </>,
        },
      ],
      OpenDate: "09.07.2026 09:00 hrs",
      EndDate: "30.07.2026 18:00 hrs",
    },
    {
      Title: "Supply, Delivery, Assembly, and Installation of Furniture for Student Hostels at IIT Tirupati. CPPP Bid No: IITT/SA/2026-27/25 dated 10.06.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTSA2026-2725.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Download Start Date and Time: 10.06.2026, 18:00 Hrs<br />
            Bid Submission Start Date and Time: 10.06.2026, 18:00 Hrs<br />
            Bid End Date/ Time: 24.06.2026, 10:00 Hrs<br />
            Technical Bid Opening Date/ Time: 25.06.2026, 10:30 Hrs
          </>,
        },
      ],
      OpenDate: "10.06.2026, 18:00 Hrs",
      EndDate: "24.06.2026, 10:00 Hrs",
    },
    {
      Title: "Supply, installation, testing and commissioning of CST Studio Software. CPPP Bid No:IITT/EE/2026-27/22  dated 10.06.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEE2026-2722_TER.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2722.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Download Start Date and Time: 10.06.2026, 18:30 Hrs<br />
            Bid Submission Start Date and Time: 10.06.2026, 18:30 Hr<br />
            Bid End Date/ Time: 01.07.2026, 18:30 Hrs<br />
            Technical Bid Opening Date/ Time: 02.07.2026, 18:30 Hrs
          </>,
        },
      ],
      OpenDate: "10.06.2026, 18:30 Hrs",
      EndDate: "01.07.2026, 18:30 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Next Generation Firewall System. CPPP Tender No: IITT/CC/2026-27/15 dated 08.06.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-2715_PTER.pdf",
          LinkName: <>Provisional Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCC2026-271506_Corr6.pdf",
          LinkName: <>Corrigendum 6<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCC2026-2715_Corr5.pdf",
          LinkName: <>Corrigendum 5<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCC2026-2715_Pre_bid_Minutes.pdf",
          LinkName: <>Pre-bid Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCC2026-2715_Corr4.pdf",
          LinkName: <>Corrigendum 4<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCC2026-2715_Corr3.pdf",
          LinkName: <>Corrigendum 3<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCC2026-2715_Corrigendum2.pdf",
          LinkName: <>Corrigendum 2<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCC2026-2715_Corrigendum1.pdf",
          LinkName: <>Corrigendum 1<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCC2026-2715.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Pre-Bid Meeting Date:- 15.06.2026, 11:00 Hrs<br />
            Bid submission start date & time : 13.07.2026 09:00 hrs<br />
            Bid submission close date & time : 08.08.2026 18:00 hrs <br />
            Opening of Technical bids:  10.08.2026 10.00 hrs <br/> Representations, if any, towards the technical disqualification, may be sent to purchase@iittp.ac.in with subject "Representation against technical evaluation of bid  IITT/CC/2026-27/15" before 6:00 PM, 30 Sept 2026.
          </>,
        },
      ],
      OpenDate: "06.07.2026 09:00 hrs",
      EndDate: "08.08.2026 18:00 hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Gas Panels for Mass Transfer Apparatus (1 No). CPPP Tender No: IITT/CH/2026-27/19 dated 05.06.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCH2026-2719_Technical_evaluation_report.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/tenders/2026/IITTCH2026-2719.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication / Download of Tenders: 05.06.2026, 18:00 Hrs<br />
            Bid Submission Start Date and Time:  05.06.2026, 18:00 Hrs<br />
            Bid End Date / Time:  26.06.2026, 18:00 Hrs<br />
            Opening of Technical bids:  29.06.2026, 18:00 Hrs
          </>,
        },
      ],
      OpenDate: "05.06.2026, 18:00 Hrs",
      EndDate: "26.06.2026, 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and training of Dynamic Shear Rheometer. CPPP Tender No: IITT/CH/2026-27/12 dated 05.06.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2712_Corrigendum_I.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2712_Pre_BID_Minutes.pdf",
          LinkName: <>Pre-BID Meetings Minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2712.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication / Download of Tenders: 05.06.2026, 18:00 Hrs<br />
            Pre-bid meeting: 10.06.2026, 11:30 Hrs<br />
            Bid Submission Start Date and Time:  17.06.2026, 18:00 Hrs<br />
            Bid End Date / Time:  08.07.2026, 18:00 Hrs<br />
            Opening of Technical bids:  09.07.2026, 18:30 Hrs<br />
            Pre-Bid Meeting will be conducted on 10.06.2026, 11.30 hrs in Hybrid (online and offline) mode.<br />
            For offline mode, the venue address is " Administration Building, Indian Institute of Technology Tirupati, Yerpedu – Venkatagiri Road, Yerpedu Post,Tirupati District, Andhra Pradesh, Pincode - 517619 ". The bidders may join online using the link: https://meet.google.com/arg-mhxm-xkc
          </>,
        },
      ],
      OpenDate: "05.06.2026, 18:00 Hrs",
      EndDate: "08.07.2026, 18:00 Hrs",
    },
    {
      Title: "Providing and fixing of structural truss framework on multi functional stage at IIT Tirupati. NIQ No: IITT/PC/NIQ/2026-27/CIVIL/006, Dt. 03.06.2026.",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL006_Corrigendum_I.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        }, {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL006_Tender.pdf",
          LinkName: <>NIQ Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL006_Drawing.pdf",
          LinkName: <>Drawing<br /></>,
        },

      ],
      eProcurementLinks: [

        {
          Link: "#",
          LinkName: <>NIQ Submission Start date: 03.06.2026 <br />
            Last Date for Submission of Sealed Quotations: 22-06-2026 up to 15.00 PM</>,
        },
      ],
      OpenDate: "03.06.2026",
      EndDate: "22-06-2026 up to 15:00 Hrs",
    },
    {
      Title: "Painting of Internal walls in all Hostels and guest house in south campus at IIT Tirupati. CPPP Tender No. IITT/EU/EE(C)/26-27/003  dated 26.05.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUEE(C)26-27003_Tender.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUEE(C)26-27003.pdf",
          LinkName: <>Tender Details<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUEE(C)26-27003_BOQ.xls",
          LinkName: <>BoQ Sheet<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Start Date and Time: 26.05.2026<br />
            Pre-Bid Meeting date : 02-06-2026<br />
            Bid End Date / Time: 08.06.2026, 15:00 Hrs<br />
            Bid Opening Date / Time: 09.06.2026, 15:30 Hrs</>,
        },
      ],
      OpenDate: "26.05.2026",
      EndDate: "08.06.2026 15:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning of 10KVA Air Cooled Auto Variable Transformer. CPPP Tender No. IITT/EE/2026-27/21 dated 22.05.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEE2026-2721_TEC.pdf",
          LinkName: <>Technical Evaluation<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCW2026-2702.pdf",
          LinkName: <>CPPP Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Start Date and Time: 22.05.2026, 10:30 Hrs<br />
            Bid End Date/ Time: 12.06.2026, 10:30 Hrs<br />
            Bid Opening Date/ Time: 13.06.2026, 11:00 Hrs<br /> Representations, if any, towards the technical disqualification, may be sent to purchase@iittp.ac.in with subject "Representation against technical evaluation of bid  IITT/EE/2026-27/21" before 12:00 PM, 23 August 2026.</>,
        },
      ],
      OpenDate: "22.05.2026",
      EndDate: "12.06.2026 10:30 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and training of CNC Turnmill center. CPPP Tender No. IITT/CW/2026-27/02 dated 21.05.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCW2026-2702_Tender_evaluation_results.pdf",
          LinkName: <>Tender Evaluation Results<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCW2026-2702_Corrigendum_II.pdf",
          LinkName: <>Corrigendum II<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCW2026-2702_Corrigendum_I.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCW2026-2702_Prebidminutes.pdf",
          LinkName: <>Pre-bid minutes<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCW2026-2702.pdf",
          LinkName: <>CPPP Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Date and time of Online Publication / Download of Tenders: 21.05.2026, 18:00 Hrs<br />
            Bid Start Date and Time: 05.06.2026, 18:00 Hrs<br />
            Bid End Date/ Time: 09.07.2026 18.00 hrs<br />
            Bid Opening Date/ Time: 10.07.2026 18.30 hrs
            Pre-Bid Meeting will be conducted on 29.05.2026, 12.00 hrs in Hybrid (online and offline) mode.<br />
            <br />
            For offline mode, the venue address is " Administration Building, Indian Institute of Technology Tirupati, Yerpedu – Venkatagiri Road, Yerpedu Post,Tirupati District, Andhra Pradesh, Pincode - 517619 ". The bidders may join online using the link: https://meet.google.com/qpp-vjbb-nxu</>,
        },
      ],
      OpenDate: "21.05.2026",
      EndDate: "09.07.2026 18.00 hrs",
    },
    {
      Title: "Supply and installation of Simulia ABAQUS Software Extended for Academic Research Tender No. IITT/CE/2026-27/08 dated 19.05.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCE2026-2708_Corrigendum_I.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCE2026-2708.pdf",
          LinkName: <>CPPP Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date/ Time:  19.05.2026 18:30<br />
            Bid submission close date & time: 22-06-2026 18:30 hrs.<br />
            Opening of Technical bids: 23-06-2026 18:30 hrs</>,
        },
      ],
      OpenDate: "19.05.2026",
      EndDate: "22-06-2026 18:30 hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Two Port Glove Box with 03 years comprehensive warranty, CPPP Tender No: IITT/CH/2026-27/14 dated 15.05.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCH2026-2714_Technical_Evaluation.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2714.pdf",
          LinkName: <>CPPP Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date/ Time:  08.06.2026, 10:00 Hrs<br /></>,
        },
      ],
      OpenDate: "15.05.2026",
      EndDate: "05.06.2026, 18:00 Hrs",
    },
    {
      Title: "Providing and fixing External wayfinding signages at IIT Tirupati. NIQ No: IITT/PC/NIQ/2026-27/Civil/004, Dt. 15.05.2026.",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27Civil004_Corrigendum_1.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27Civil004.pdf",
          LinkName: <>NIQ Document<br /></>,
        },

      ],
      eProcurementLinks: [

        {
          Link: "#",
          LinkName: <>NIQ Submission Start date: 15.05.2026 <br />
            Original Submission Deadline: 22.05.2026 at 15:00 hrs<br />
            Extended Submission Deadline: 29.05.2026 up to 15:00 Hrs.<br />
            Further, the bid opening will be conducted as per the revised schedule on 29.05.2026 at 15:30 hrs.</>,
        },
      ],
      OpenDate: "15.05.2026",
      EndDate: "22.05.2026 up to 15:00 Hrs",
    },
    {
      Title: "Supply and Installation of Gas Panel Assembly for the VPSA unit. CPPP Tender No: IITT/CSRC/CH//2026-27/003, Dt. 11/05/2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCSRCCH2026-27003_Technical_Evaluation.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCSRCCH2026-27003.pdf",
          LinkName: <>CPPP Tender<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCSRCCH2026-27003_BOQ_954591.xls",
          LinkName: <>BoQ Sheet<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Download Start Date and Time: 11.05.2026, 18:00 Hrs<br />
            Bid End Date / Time: 01.06.2026, 18:00 Hrs<br />
            Bid Opening Date / Time: 02.06.2026, 18:30 Hrs</>,
        },
      ],
      OpenDate: "11-05-2026",
      EndDate: "01/06/2026, 18:00 Hrs",
    },
    {
      Title: "Procurement of Computer Workstation. CPPP Tender No: IITT/EE/2026-27/07, Dt. 11/05/2026",
      Documents: [
        // {
        //   Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2707_C1.pdf",
        //   LinkName: <>Corrigendum-I<br /></>,
        // },
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEE2026-2707_Technical_Bid.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2707_Corrigendum_1.pdf",
          LinkName: <>Corrigendum I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2707_Corrigendum_2.pdf",
          LinkName: <>Corrigendum II<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2707.pdf",
          LinkName: <>CPPP Tender<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <><b>Representations, if any, towards the technical disqualification, may be sent to purchase@iittp.ac.in with subject "Representation against technical evaluation of bid  IITT/EE/2026-27/07" before 12:00 PM, 27 July 2026.</b><br />
            Bid Download Start Date and Time: 11.05.2026<br />
            Bid End Date / Time: 01.06.2026, 18:00 hrs<br />
            Bid Opening Date / Time: 02.06.2026, 18:30 Hrs</>,
        },
      ],
      OpenDate: "11-05-2026",
      EndDate: "01/06/2026, 18:00 Hrs",
    },

    {
      Title: "Procurement of Muffle Furnace. GeM Bid No: GEM/2026/B/7491621, Dt. 11/05/2026",
      Documents: [
         {
          Link: "https://files.iittp.ac.in/2026/tenders/GEM2026B7491621_TER.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7491621.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Download Start Date and Time: 11.05.2026<br />
            Bid End Date / Time: 01.06.2026, 12:00 Hrs<br />
            Bid Opening Date and Time: 01.06.2026, 12:30 Hrs
          </>,
        },
      ],
      OpenDate: "11-05-2026",
      EndDate: "01/06/2026, 12:00 Hrs",
    },
    {
      Title: "Procurement of Thermal Mass Flow Controller-07 Nos. GeM Bid No: GEM/2026/B/7514653, Dt. 11/05/2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7514653_Technical_evaluation.pdf",
          LinkName: <>Technical evaluation Statement<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7514653.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Download Start Date and Time: 11.05.2026<br />
            Bid End Date / Time: 01.06.2026, 12:00 Hrs<br />
            Bid Opening Date and Time: 01.06.2026, 12:30 Hrs
          </>,
        },
      ],
      OpenDate: "11-05-2026",
      EndDate: "01/06/2026, 12:00 Hrs",
    },

    {
      Title: "Supply, Installation, Testing and Commissioning of 3kva 415/415v 3ph Transformer with Multiple Vector Group Air Cool Combined Unit [20 Nos]. CPPP Tender No: IITT/EE/2026-27/11, Dt. 05/05/2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2711_08.pdf",
          LinkName: <>CPPP Tender<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Download Start Date and Time: 05.05.2026, 18:30 Hrs<br />
            Bid Submission Start Date and Time: 05.05.2026, 18:30 Hrs<br />
            Bid End Date / Time: 26.05.2026, 18:00 Hrs<br />
            Technical Bid Opening Date / Time: 27.05.2026, 18:30 Hrs</>,
        },
      ],
      OpenDate: "05-05-2026",
      EndDate: "26/05/2026, 18:00 Hrs",
    },

    {
      Title: "Supply, Installation, Testing, Commissioning and Training of Control of Continuous Stirred Tank Reactor with Service Unit. CPPP Tender No: IITT/CH/2026-27/10, Dt. 08/05/2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2710_Technical_evaluation_report.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2710.pdf",
          LinkName: <>CPPP Tender<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Download Start Date and Time: 08.05.2026, 18:00 Hrs<br />
            Bid Submission Start Date and Time: 08.05.2026, 18:30 Hrs<br />
            Bid End Date / Time: 29.05.2026, 18:00 Hrs<br />
            Technical Bid Opening Date / Time: 01.06.2026, 10:00 Hrs</>,
        },
      ],
      OpenDate: "08-05-2026",
      EndDate: "29/05/2026, 18:00 Hrs",
    },

    {
      Title: "Procurement of Computer Workstation. CPPP Tender No: IITT/CH/2026-27/13, Dt. 07/05/2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCH2026-2713_TE_CS.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2713.pdf",
          LinkName: <>CPPP Tender<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date / Time: 29/05/2026, 18:30 Hrs<br /></>,
        },
      ],
      OpenDate: "07-05-2026",
      EndDate: "28/05/2026, 18:00 Hrs",
    },

    {
      Title: "Providing and laying vitrified tiles over existing flooring (Tile-on-Tile) in south campus Abheri and Kedar hostels at IIT Tirupati. NIQ No: IITT/PC/NIQ/2026-27/CIVIL/005, Dt. 07.05.2026.",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL005.pdf",
          LinkName: <>NIQ Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL005_Drawings.pdf",
          LinkName: <>Drawings<br /></>,
        },
      ],
      eProcurementLinks: [

        {
          Link: "#",
          LinkName: <>NIQ Submission Start date: 07.05.2026 <br />Last Date for Submission of Sealed Quotations: 13.05.2026 up to 15:00 Hrs.<br /></>,
        },
      ],
      OpenDate: "07.05.2026",
      EndDate: "13.05.2026 up to 3.00 PM",
    },


    {
      Title: "Procurement of SITC of Servo hydraulic computer-controlled flexure testing machine (100 KN) capacity-01 No. GeM Bid No: GEM/2026/B/7492800, Dt. 06/05/2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7492800_TEC.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7492800.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date/ Time: 27/05/2026, 17:30 Hrs<br /></>,
        },
      ],
      OpenDate: "06-05-2026",
      EndDate: "27/05/2026, 17:00 Hrs",
    },
    {
      Title: "Procurement of SITC of 15. Ton Double Girder Electric Overhead Travelling (EOT) Crane-02 Nos. GeM Bid No: GEM/2026/B/7446027, Dt. 30/04/2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/2026/tenders/GEM2026B7446027_TE.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7446027_C1.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7446027.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date/ Time: 21/05/2026, 18:30 Hrs<br /></>,
        },
      ],
      OpenDate: "30-04-2026",
      EndDate: "21/05/2026, 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, and Commissioning of 3KVA 415/415V 3PH Transformer with Multiple Vector Group Air cool Combined Unit. CPPP Bid No: IITT/EE/2026-27/11 dated 05.05.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2711.pdf",
          LinkName: <>CPPP Tender<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Technical Bid Opening Date/ Time: 27.05.2026, 18:30 Hrs<br /></>,
        },
      ],
      OpenDate: "05.05.2026",
      EndDate: "26.05.2026, 18:00 Hrs",
    },
    {
      Title: "Procurement of Laptop GEM Bid No: GEM/2026/B/7470424 dated 29.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7470424.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Download Start Date and Time: 29.04.2026<br />
            Bid End Date / Time: 08.05.2026, 18:00 Hrs<br />
            Bid Opening Date / Time: 08.05.2026, 18:30 Hrs</>,
        },
      ],
      OpenDate: "29.04.2026",
      EndDate: "08.05.2026, 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning and Training of Microwave plasma assisted atomic emissions spectrometer (MP-AES) CPPP Bid No: IITT/CH/2026-27/06 dated 29.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2706.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Download Start Date and Time: 29.04.2026, 10:00 Hrs<br />
            Bid End Date / Time: 20.05.2026, 10:00 Hrs<br />
            Bid Opening Date / Time: 21.05.2026, 10:30 Hrs</>,
        },
      ],
      OpenDate: "29.04.2026",
      EndDate: "20.05.2026, 10:00 Hrs",
    },
    {
      Title: "Procurement of Continuous Ambient Air Quality Monitoring System with Co, NO2, O3 and PM2.5 and shelter facility (CAAQMS) -01 No, GeM Bid No. GEM/2026/B/7448963 dated 24.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7448963.pdf",
          LinkName: <>BID Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7448963-C1.pdf",
          LinkName: <>Corrigendum-1<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date/ Time:   15.05.2026, 17:30 Hrs</>,
        },
      ],
      OpenDate: "24.04.2026",
      EndDate: "15.05.2026, 17:00 Hrs",
    },
    {
      Title: "Civil AMC for Carpentry, Plumbing, Masonry, External development works, and day-to-day maintenance works in IIT Tirupati, Yerpedu (M), Tirupati (Dt). Andhra Pradesh NIT No: IITT/EU/EE(C)/26-27/002 dated 20.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUEE-C-26-27002_Corrigendum1.pdf",
          LinkName: <>Corrigendum - I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUEE(C)26-27002.pdf",
          LinkName: <>NIT Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUEE(C)26-27002_Tendernotice.pdf",
          LinkName: <>Tender Details<br /></>,
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUEE(C)26-27002_NIT002FinancialBidPercentageRate.xls",
          LinkName: <>Financial Bid Percentage Rate<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Value of the work : Value of work : 1,23,71,426/-<br />
            Bid Submission Start date: 10-04-2026<br />
            Bid Submission end date : 30-04-2026<br />
            Prebid meeting date : 22-04-2026<br />
            Mode: Through CPP portal<br /></>,
        },
      ],
      OpenDate: "10.04.2026",
      EndDate: "30.04.2026",
    },

    {
      Title: "Supply, Installation, Testing, and Commissioning of Packed Bed Catalytic Reactor. CPPP Bid No: IITT/CH/2026-27/01 dated 17.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2701_Technical_evaluation_report.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2026-2701.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Download Start Date and Time: 17.04.2026, 17:00 Hrs<br />
            Bid Submission Start Date and Time: 17.04.2026, 18:00 Hrs<br />
            Bid End Date/ Time: 08.05.2026, 18:00 Hrs<br />
            Technical Bid Opening Date/ Time: 09.05.2026, 18:30 Hrs</>,
        },
      ],
      OpenDate: "17.04.2026",
      EndDate: "08.05.2026, 18:00 Hrs",
    },
    {
      Title: "Development of courtyards to develop sports facilities for the students in both Malhar and DES hostel in IIT Tirupati. NIQ No: IITT/PC/NIQ/2026-27/CIVIL/003 dated 16.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL003.pdf",
          LinkName: <>NIQ Document<br /></>,
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL003_Drawings.pdf",
          LinkName: <>Drawing<br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>NIQ Submission Start date: 16-04-2026<br />
            Last Date for Submission of Sealed Quotations: 23.04.2026 up to 15:00 Hrs.<br />
          </>,
        },
      ],
      OpenDate: "16.04.2026",
      EndDate: "23.04.2026, 15:00 Hrs",
    },
    {
      Title: "Development of Calisthenic Gym in Des Hostel at IIT Tirupati. NIQ No: IITT/PC/NIQ/2026-27/CIVIL/002 dated 16.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL002.pdf",
          LinkName: <>NIQ Document<br /></>,
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL002_Drawing.pdf",
          LinkName: <>Drawing<br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>NIQ Submission Start date: 16-04-2026<br />
            Last Date for Submission of Sealed Quotations: 23.04.2026 up to 15:00 Hrs.<br />
          </>,
        },
      ],
      OpenDate: "16.04.2026",
      EndDate: "23.04.2026, 15:00 Hrs",
    },
    {
      Title: "Repainting of Internal walls at Kendriya Vidyalaya 9KV) School at IIT Tirupati. NIQ No: IITT/PC/NIQ/2026-27/CIVIL/001 dated 16.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ2026-27CIVIL001.pdf",
          LinkName: <>NIQ Document<br /></>,
        },


      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>NIQ Submission Start date: 16-04-2026<br />
            Last Date for Submission of Sealed Quotations: 23.04.2026 up to 15:00 Hrs<br />
          </>,
        },
      ],
      OpenDate: "16.04.2026",
      EndDate: "23.04.2026, 15:00 Hrs",
    },
    {
      Title: "Annual Maintenance Contract for Horticulture – Landscape Gardening with micro irrigation system at IIT Tirupati, Yerpedu- Venkatagiri road, Tirupati District, Andhra Pradesh. NIT No: ITT/EU/EE(C)/Horti/26-27/001 dated 07.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/ITTEUEE(C)Horti26-27001_Tender.pdf",
          LinkName: <>NIT Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/ITTEUEE(C)Horti26-27001.pdf",
          LinkName: <>Tender Details<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/ITTEUEE(C)Horti26-27001_Drawing.pdf",
          LinkName: <>Drawing<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/ITTEUEE(C)Horti26-27001_BOQ.xls",
          LinkName: <>BOQ<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Value of the work :Rs. 98,95,893/-  inclusive of applicable Taxes<br />
            Bid Submission Start date: 07-04-2026<br />
            Bid Submission end date : 28-04-2026<br />
            Prebid meeting date : 17-04-2026<br />
            Mode: Through CPP portal<br /></>,
        },
      ],
      OpenDate: "07.04.2026",
      EndDate: "28.04.2026",
    },
    {
      Title: "Procurement of Solar Simulator. GeM Bid No: GEM/2026/B/7249240 dated 08.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7249240_Technical_Evaluation_Report.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7249240.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date / Time:  08.04.2026<br />
            Bid End Date / Time:  29.04.2026, 18:00 Hrs<br />
            Bid Opening Date / Time:   29.04.2026, 18:30 Hrs</>,
        },
      ],
      OpenDate: "08.04.2026",
      EndDate: "29.04.2026, 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning and training of Portable XRF with calibration kits and accessories. CPPP Tender No: IITT/EE/2026-27/05 dated 08.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTEE2026-2705_Cancellationnotice.pdf",
          LinkName: <>TENDER CANCELLATION NOTICE<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2705.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Download Start Date and Time:  08.04.2026, 17:00 Hrs<br />
            Bid End Date / Time:  29.04.2026, 17:00 Hrs<br />
            Bid Opening Date / Time:  30.04.2026, 17:30 Hrs<br /></>,
        },
      ],
      OpenDate: "08.04.2026",
      EndDate: "29.04.2026, 17:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning and training of Atomic Force Microscope. CPPP Tender No: IITT/CIF/2026-27/04 dated 07.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/2026/tenders/IITTCIF2026-2704_Tender_cancellation_notice.pdf",
          LinkName: <>TENDER CANCELLATION NOTICE<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCIF2026-2704_Corrigendum_I.pdf",
          LinkName: <>Corrigendum - I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCIF2026-2704.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Date and time of Online Publication / Download of Tenders: 07.04.2026, 18.00 Hrs<br />
            Bid Start Date and Time:  17.04.2026, 10:00 Hrs<br />
            Bid End Date / Time:  15.05.2026, 10:00 Hrs<br />
            Bid Opening Date / Time:  18.05.2026, 10:30 Hrs<br />
            Pre-Bid Meeting will be conducted on 14-04-2026, 11.00 hrs in Hybrid (online and offline) mode.<br />
            For offline mode, the venue address is " Administration Building, Indian Institute of Technology Tirupati, Yerpedu – Venkatagiri Road, Yerpedu Post,Tirupati District, Andhra Pradesh, Pincode - 517619 ". The bidders may join online using the link: https://meet.google.com/ddw-otxj-njj
          </>,
        },
      ],
      OpenDate: "07.04.2026",
      EndDate: "15.05.2026, 10:00 Hrs",
    },
    {
      Title: "Procurement of the Thickness Measurement System. CPPP Tender No: IITT/EE/2026-27/03 dated 07.04.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEE2026-2703.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Download Start Date and Time:  07.04.2026<br />
            Bid End Date / Time:  28.04.2026, 18:00 Hrs<br />
            Bid Opening Date / Time:  29.04.2026, 18:30 Hrs<br /></>,
        },
      ],
      OpenDate: "07.04.2026",
      EndDate: "28.04.2026, 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning and Training of Freeze Dryer. CPPP Tender No: IITT/CH/2025-26/19 dated 17.03.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/Technical_evaluation_report.pdf",
          LinkName: <>Technical evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2025-2619.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Download Start Date and Time:  17.03.2026, 18:00 Hrs<br />
            Bid End Date / Time:  08.04.2026, 18:00 Hrs<br />
            Bid Opening Date / Time:  08.04.2026, 18:30 Hrs<br /></>,
        },
      ],
      OpenDate: "17.03.2026",
      EndDate: "08.04.2026, 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, and Commissioning of Gas-Solid Equilibrium Measurement Apparatus. CPPP Tender No: IITT/CH/2025-26/11 dated 16.03.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2025-2611.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: <>Bid Download Start Date and Time:  16.03.2026, 18:00 Hrs<br />
            Bid Submission Start Date and Time:  16.03.2026, 18:00 Hrs<br />
            Bid End Date / Time:  13.04.2026, 18:00 Hrs<br />
            Technical Bid Opening Date / Time:  14.04.2026, 18 :30 Hrs<br /></>,
        },
      ],
      OpenDate: "16.03.2026",
      EndDate: "13.04.2026, 18:00 Hrs",
    },
    {
      Title: "Procurement of Supply, Installation, Testing and Commissioning of Benchtop Residual Gas Analyser (01 No). CPPP Tender No: IITT/CH/2025-26/12 dated 16.03.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCH2025-2612.pdf",
          LinkName: <>CPPP Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "16.03.2026",
      EndDate: "14.04.2026, 18:00 Hrs",
    },

    {
      Title: "Procurement of Size Reduction Equipment (Cryo Grinding Unit) - GeM Bid No: GEM/2026/B/7335979",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM-2026B7335979.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date/ Time:  31.03.2026, 17:30 Hrs<br /></>,
        },
      ],
      OpenDate: "10.03.2026",
      EndDate: "31.03.2026, 17:00 Hrs",
    },
    {
      Title: "Procurement of LIQUID LIQUID EXTRACTION UNIT. GeM Bid No: GEM/2026/B/7299991 dated 09.03.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM-2026B7299991.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date/ Time:  30.03.2026, 20:30 Hrs<br /></>,
        },
      ],
      OpenDate: "09.03.2026",
      EndDate: "30.03.2026, 20:00 Hrs",
    },
    {
      Title: "Hiring Transportation Services to IIT Tirupati on a contract basis. CPPP Bid No: IITT/ADMIN/2025-26/14 dated 07.03.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/CPPP-IITTADMIN2025-2614.pdf",
          LinkName: <>Tender Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Technical Bid Opening Date/ Time: 03.04.2026, 14:30 Hrs<br /></>,
        },
      ],
      OpenDate: "07.03.2026, 18:00 Hrs",
      EndDate: "02.04.2026, 12:00 Hrs",
    },
    {
      Title: "Procurement of Fuel Cell Test Rig. GeM Bid No: GEM/2026/B/7247273 dated 06.03.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7247273.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "06.03.2026",
      EndDate: "27.03.2026, 16:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing and Commissioning of Ventilation system at 600KLD and 55KLD Water Treatment Plant. NIQ No: IITT/EU/E&M/NIQ/2025-26/005 dated 03.03.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26005_Corrigendum_2.pdf",
          LinkName: <>Corrigendum-II<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26005_Corrigendum-1.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26005.pdf",
          LinkName: <>NIQ Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26005_55KLD_WTP_Layout.pdf",
          LinkName: <>55KLD WTP Layout Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26005_600KLD_WTP_Layout.pdf",
          LinkName: <>600KLD WTP Layout Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26005_Annexure-I.pdf",
          LinkName: <>Annexure-I Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26005_Annexure-II.pdf",
          LinkName: <>Annexure-II Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26005_Annexure-III.pdf",
          LinkName: <>Annexure-III Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26005_Annexure-IV.pdf",
          LinkName: <>Annexure-IV Document<br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "03.03.2026",
      EndDate: "30.03.2026, 15:00 Hrs (Extended)",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning of the Universal multi-Wheel Tracker including all accessories. CPPP Tender No: IITT/CE/2025-26/13 dated 02.03.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCE2025-2613.pdf",
          LinkName: <>Tender Document<br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "02.03.2026",
      EndDate: "23.03.2026, 18:00 Hrs",
    },
    {
      Title: "Supply, Installation, Testing, Commissioning, and Training of Liquid Nitrogen Plant. CPPP Tender No: IITT/CIF/2025-26/10 dated 27.02.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCIF2025-2610_Response_sheet_against_representation.pdf",
          LinkName: <>Responses to the Representations<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCIF2025-2610_TE_Report.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCIF2025-2610.pdf",
          LinkName: <>Tender Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCIF2025-2610_corrigendum_I.pdf",
          LinkName: <>Corrigendum-I<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCIF2025-2610_corrigendum_2.pdf",
          LinkName: <>Corrigendum-II<br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Representations, if any, towards the technical disqualification, may be sent to purchase@iittp.ac.in with subject "Representation against technical evaluation of bid  IITT/CIF/2025-26/10" before 12:00 PM, 26 May 2026.</>,
        },
      ],
      OpenDate: "27.02.2026",
      EndDate: "30.03.2026, 10:00 Hrs",
    },

    {
      Title: "Procurement of Wireless Corrosion Rate Analyzer System. CPPP Tender No: IITT/CE/2025-26/09 dated 19.02.2026",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCE2025-2609_Technical_Evaluation_Report.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCE2025-2609.pdf",
          LinkName: <>Tender Document<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCE2025-2609_Corrigendum_I.pdf",
          LinkName: <>Corrigedum<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "19.02.2026",
      EndDate: "12.03.2026, 18:00 Hrs",
    },
    {
      Title: "Procurement of Electric Forklift (3 Tonnes) GeM Bid No: GEM/2026/B/718877 dated 09.02.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B718877_Technical_compliance_report.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM-2026-B-718877.pdf",
          LinkName: <>BID Document<br /></>,
        },

      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Bid Opening Date : 27.02.2026, 14:30 Hrs<br /></>,
        },
      ],
      OpenDate: "09.02.2026",
      EndDate: "27.02.2026, 14:00 Hrs",
    },
    {
      Title: "Procurement of a Multi-zone high-temperature CVD tube furnace. GeM Bid No: GEM/2026/B/7145834 dated 03.02.2026",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7145834_TCR.pdf",
          LinkName: <>Technical Evaluation Report<br /></>,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7145834.pdf",
          LinkName: <>BID Document<br /></>,
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <>Representations, if any, towards the technical disqualification, may be sent to purchase@iittp.ac.in with subject "Representation against technical evaluation of bid GeM Bid No: GEM/2026/B/7145834" before 11:30 AM, 24 May 2026.<br /></>,
        },
        {
          Link: "#",
          LinkName: <>Bid Opening Date:   24.02.2026, 18:30 Hrs<br /></>,
        },
      ],
      OpenDate: "03.02.2026",
      EndDate: "24.02.2026, 18:00 Hrs",
    },
    {
      Title:
        "Tender for the Supply and installation of High Performance Computer Workstation - 04 No. - CPPP Tender No: IITT/CE/2025-26/08",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCE2025-2608_TechEval.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/Tender_IITT_CE_2025-26_08.pdf",
          LinkName: "Tender Document",
        }, {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTCE2025-2608_Corrigendum-1.pdf",
          LinkName: "Corrigendum - I",
        },

      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: <><i>Representations, if any, towards the technical disqualification, may be sent to purchase@iittp.ac.in with subject "Representation against technical evaluation of bid  IITT/CE/2025-26/08" before 12:00 PM, 24 April 2026.</i></>,
        },
        {
          Link: "#",
          LinkName: <>Opening of Technical bits : <br /><s>18-02-2026 @ 18:30 hrs</s><br />24-02-2026 @ 15:00 hrs</>,
        },
      ],
      OpenDate: "03-02-2026",
      EndDate: <><s>17-02-2026 @ 18:00 hrs</s><br />23-02-2026 @ 15:00:00</>,
    },
    {
      Title:
        "NIQ for the Supply and installation of filter media (Resin) in Softener for ESS-2 Chiller Plant in IIT Tirupati. - NIQ Tender No: IITT/EU/E&M/NIQ/2025-26/005",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITT-EU-E&M-NIQ-2025-26_005_NIQ.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITT-EU-E&M-NIQ-2025-26_005_Annexure-1.pdf",
          LinkName: "Annexure-1",
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "03-02-2026",
      EndDate: "10-02-2026 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Supply, Fabrication of Return Duct and Erection of Existing Duct and Providing and Fixing of False Ceiling at IIT Tirupati. - NIQ Tender No: IITT/EU/E&M/NIQ/2025-26/004",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26004_New.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&M NIQ2025-26004_Annexure-1.pdf",
          LinkName: "Annexure-1",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&M NIQ2025-26004_Annexure-2.pdf",
          LinkName: "Annexure-2",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&M NIQ2025-26004_Annexure-3.pdf",
          LinkName: "Annexure-3",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&M NIQ2025-26004_Annexure-4.pdf",
          LinkName: "Annexure-4",
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "02-02-2026",
      EndDate: "12-02-2026 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Supply and Installation of filters in Pressure Sand Filter (PSF) & Softener for WTP-2,55KLD plant in IIT Tirupati. - NIQ Tender No: IITT/PC/NIQ/20226/001",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ20226001.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTPCNIQ20226001_Annexures.pdf",
          LinkName: "Annexures",
        },


      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "30-01-2026",
      EndDate: "06-02-2026 @ 15:00 hrs",
    },

    {
      Title:
        "NIQ for the Supply, Installation, Testing and Commissioning (SITC) of 20 HP VRF / VRV system with 2 No’s 5HP Ductable type indoor units to IIT Tirupati. - NIQ Tender No: IITT/EU/E&M/NIQ/2025-26/003",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26003_New.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26003_Annexure-1.pdf",
          LinkName: "Annexure-1",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26003_Annexure-2.pdf",
          LinkName: "Annexure-2",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26003_Annexure-3.pdf",
          LinkName: "Annexure-3",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/IITTEUE&MNIQ2025-26003_Annexure-4.pdf",
          LinkName: "Annexure-4",
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "30-01-2026",
      EndDate: "06-02-2026 @ 15:00 hrs",
    },

    {
      Title:
        "Procurement of equipments for Rock Mechanics Laboratory - GEM BID No: GEM/2026/B/7075826",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7075826_Evaluation_Report.pdf",
          LinkName: "Tender Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2026/GEM2026B7075826.pdf",
          LinkName: "BID Document",
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "12-01-2026",
      EndDate: "02-02-2026 @ 16:00 hrs",
    },
    {
      Title:
        "Supply, installation, testing and commissioning of Four Port Battery Research Glove Box - Tender No: IITT/CSRC/CH/2025-26/06",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2606_Technical_Evaluation.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2606.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2606_Published_Tender.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "05-12-2025",
      EndDate: "27-12-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIT for disposal and sale of carton boxes, empty plastic bottles, waste papers, old newspapers/magazines/books, pallets of wood, etc in IIT Tirupati. - NIT Tender No: IITT/P&S/Disposal/2025-26/01",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTP&SDisposal2025-2601_Corrigendum_I.pdf",
          LinkName: "Corrigendum - I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTP&SDisposal2025-2601.pdf",
          LinkName: "NIT Document",
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "26-11-2025 @ 17:00 Hrs",
      EndDate: "20-01-2026 @ 15:00 Hrs (Extended)",
    },
    {
      Title:
        "NIQ for the Supply of wind breaker for tennis court, flag poles and 12 mm plywood sheet to IIT Tirupati. - NIQ Tender No: IITT/PC/NIQ/2025-26/013",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26013.pdf",
          LinkName: "Tender Document",
        },

      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "11-11-2025",
      EndDate: "14-11-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIT for Providing and Fixing of the Internal & External Wayfinding Signages at IIT Tirupati - NIT No: IITT/EU/EE(C)/2025–26/003",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUEE(C)2025–26003_Corrigendum_1.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUEE(C)2025–26003_Corrigendum_2.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUEE(C)2025–26003_Corrigendum_3.pdf",
          LinkName: "Corrigendum-III",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUE(C)202526003_Technical_BID.pdf",
          LinkName: "NIT Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUE(C)202526003_Tender_Details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "31-10-2025",
      EndDate: "19-11-2025 @ 15:00 hrs (Extended)",
    },
    {
      Title:
        "NIQ for the Construction of pathway in front of multi-functional stage near AB-1 at IIT Tirupati. - NIQ Tender No: IITT/PC/NIQ/2025-26/012",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26012_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26012_Tender_Drawing.pdf",
          LinkName: "Drawing",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "27-10-2025",
      EndDate: "03-11-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Construction of subsurface drainage in play ground area near indoor stadium south campus at IIT Tirupati. - NIQ Tender No: IITT/PC/NIQ/2025-26/011",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26011_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26011_Tender Drawing.pdf",
          LinkName: "Drawing",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "23-10-2025",
      EndDate: "30-10-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Execution of external and internal painting works for the ground floor of the indoor stadium at IIT Tirupati for inter IIT sports meet-2025. - NIQ Tender No: IITT/PC/NIQ/2025-26/010",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26010_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26010_Tender_Drawing.pdf",
          LinkName: "Drawing",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "23-10-2025",
      EndDate: "30-10-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Supply and Installation of Dugout seating in the ground at IIT Tirupati for the inter IIT sports meet - 2025. - NIQ Tender No: IITT/PC/NIQ/2025-26/009",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26009_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26009_Tender_Drawing.pdf",
          LinkName: "Drawing",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "23-10-2025",
      EndDate: "30-10-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Supply and Fixing of ground fencing in the cricket ground area at IIT Tirupati. - NIQ Tender No: IITT/PC/NIQ/2025-26/008",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26008_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26008_Tender_Drawing.pdf",
          LinkName: "Drawing",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "23-10-2025",
      EndDate: "30-10-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Construction of Isolated footings and aluminum partition at CIF ground floor right wing chemistry department in IIT Tirupati. - NIQ Tender No: IITT/PC/NIQ/2025-26/007",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26007_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26007_Drawing.pdf",
          LinkName: "Drawing",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "07-10-2025",
      EndDate: "14-10-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Supply and Installation of 600 GSM Coir Mat System Including Slope Preparation, Soil Spreading, Anchoring, and Plantation for Slope Stabilisation and Erosion Control at Tennis Court, IIT Tirupati. - NIQ Tender No: IITT/EU/HORT/NIQ/2025-26/001",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHORTNIQ2025-26001.pdf",
          LinkName: "NIQ Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHORTNIQ2025-26001_Annexure-1.xlsx",
          LinkName: "Annexure- I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHORTNIQ2025-26001_Drawing.pdf",
          LinkName: "Drawing",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHORTNIQ2025-26001_Photo.jpg",
          LinkName: "Photo",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "06-10-2025",
      EndDate: "10-10-2025 @ 15:30 hrs",
    },
    {
      Title:
        "NIQ for the Construction of Open Calisthenic Gym near indoor stadium at IIT Tirupati. - NIQ Tender No: IITT/PC/NIQ/2025-26/006",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26006_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26006_Reference_layout.pdf",
          LinkName: "Reference layout",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "03-10-2025",
      EndDate: "10-10-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Construction of cabin space with brick masonry and aluminium partition for the thermal engineering laboratory in lab-1 at south campus, at IIT Tirupati. - NIQ Tender No: IITT/PC/NIQ/2025-26/005",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26005_Corrigendum_3.pdf",
          LinkName: "Corrigendum-III",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26005_Corrigendum_II.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26005_Corrigendum_I.pdf",
          LinkName: "Corrigendum-I",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26005_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26005_Drawing.pdf",
          LinkName: "Drawing Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "01-10-2025",
      EndDate: "14-11-2025 @ 15:00 hrs (Extended)",
    },
    {
      Title:
        "Supply Installation Testing and Commissioning of Makers Lab Equipment - Gem Bid No: GEM/2025/B/6733380",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6733380_TEC.pdf",
          LinkName: "Technical Evaluation Sheet",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6733380.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "30-09-2025",
      EndDate: "22-10-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Weightlifting platform and related equipment - Gem Bid No:GEM/2025/B/6713996",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6713996_TER.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6713996.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "Representations against technical disqualification must be submitted through the GeM portal within the stipulated time frame of 48 hours.",
        },
      ],
      OpenDate: "25-09-2025",
      EndDate: "16-10-2025 @ 18:00 hrs",
    },
    {
      Title:
        "NIQ for the Construction of Inspection External Chambers - 13 No's at Flow meters installed in TWS lines to detect leakages at IIT Tirupati. - NIQ Tender No: IITT/PC/NIQ/2025-26/004",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26004_Corrigendum_1.pdf",
          LinkName: "Corrigendum - I",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26004_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26004_Location_Plan.pdf",
          LinkName: "Location Plan Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26004_DWG.pdf",
          LinkName: "Drawing Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "22-09-2025",
      EndDate: "07-10-2025 @ 15:00 hrs (Extended)",
    },
    {
      Title:
        "Notice Inviting PAC Tender for the Supply and Installation of NI Data Acquisition System - Tender No: IITT/CSRC/PH/2025-26/06",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCPH2025-2606_TER.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCPH2025-2606_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCPH2025-2606_CPP_tender.pdf",
          LinkName: "CPP Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "20-09-2025 @ 9:00 hrs",
      EndDate: "04-10-2025 @ 09:00 hrs",
    },
    {
      Title:
        "Procurement of a 7-seater Electric Car - GeM Bid No: GEM/2025/B/6674596",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6674596.pdf",
          LinkName: "Bid Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "12-09-2025",
      EndDate: "03-10-2025 @ 20:00 hrs",
    },
    {
      Title:
        "NIT for Geo-Technical Investigation works for Phase B building locations at IIT Tirupati. - NIT No: IITT/EU/EE(C)/2025–26/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUEE(C)2025–26001_Corrigendum_I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUEE(C)2025–26001_Tenderdocument.pdf",
          LinkName: "NIT Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUEE(C)2025–26001_Drawings.pdf",
          LinkName: "Drawing Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUEE(C)2025–26001_Tender_details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "04-09-2025",
      EndDate: "19-09-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for Construction of Bicycle parking area at LHC building in IIT Tirupatii. - NIQ No: IITT/PC/NIQ/2025-26/003",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26003.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26003.pdf",
          LinkName: "NIQ Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26003_Annexure_1.pdf",
          LinkName: "Annexure-1 Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "01-09-2025",
      EndDate: "17-09-2025 @ 15:00 hrs (Extended)",
    },
    {
      Title:
        "Hiring of Manpower Outsourcing Services (Fixed Remuneration) for 3 Years - Gem Bid No:GEM/2025/B/6613646",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6613646_Pre_Bid_Minutes.pdf",
          LinkName: "Pre-BID Meetings Minutes",
        },
        // {
        //   Link: "",
        //   LinkName: " Pre-Bid Meeting: 08-09-2025; 14:00:00 Hrs",
        // },
        // {
        //   Link: "",
        //   LinkName: "Venue: Board Room, Career Development Centre",
        // },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6613646.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "28-08-2025",
      EndDate: "18-09-2025 @ 17:00 hrs",
    },
    {
      Title:
        "Tender for the Supply, installation, testing and commissioning of Planetary Micro Mill-01 No. - CPPP Tender No: IITT/CSRC/CH/2025-26/05",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2605_Tender.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2605_Tender_Details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "01-08-2025",
      EndDate: "23-08-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Tender for the Supply, installation, testing and commissioning of Four Port Battery Research Glove Box-01 No. - CPPP Tender No: IITT/CSRC/CH/2025-26/04",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2604_Cancellation_Corrigendum.pdf",
          LinkName: "Tender process is hereby cancelled, due to administrative reasons. A revised tender will be uploaded shortly",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2604_Representations.pdf",
          LinkName: "Reply for Representation",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2604_Tech_Evaluation.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2604_Tender.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCH2025-2604_Tender_Details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "01-08-2025",
      EndDate: "23-08-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for Surface Preparation and Painting of Firefighting Pipelines and Apparatus at IIT Tirupati. - NIQ No:  IITT/EU/E&M/NIQ/2025-26/001",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUE&MNIQ2025-26001.pdf",
          LinkName: "NIQ Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "25-07-2025",
      EndDate: "01-08-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for Supply, Loading, unloading and loading of Filtration media in pressure Sand Filters (PSF), Activated Carbon Filters (ACF) in 325-KLD,275-KLD and 110-KLD Sewage Treatment Plant. - NIQ No:  IITT/PC/NIQ/2025-26/011",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26011.pdf",
          LinkName: "NIQ Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "16-07-2025",
      EndDate: "30-07-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Inviting Expression of Interest (EoI) to operate Unisex Hair Salon and Spa in IIT Tirupati. - EOI No: IITT/SAT/2025-26/068",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26068_Salon_EOI.pdf",
          LinkName: "EOI Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",

        },
      ],
      OpenDate: "14-07-2025",
      EndDate: "21-07-2025 @ 17:00 hrs",
    },
    {
      Title:
        "Inviting Expression of Interest (EoI) for Empanelment of Taxi Service Providers to IIT Tirupati. - EOI No: IITT/Admin/2025-26/03",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTADMIN2025-2603_Technical_evaluation_report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTAdmin2025-2603_EoI.pdf",
          LinkName: "EOI Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",

        },
      ],
      OpenDate: "10-07-2025",
      EndDate: "31-07-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Comprehensive AMC for Playground and Sports fields Maintenance Works in IIT Tirupati, Yerpedu (M), Tirupati (Dt). - NIT No: IITT/EU/Hort/2025-26/002",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHort2025-26002.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHort2025-26002_document.pdf",
          LinkName: "NIT Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHort2025-26002_Drawing.pdf",
          LinkName: "Drawing",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHort2025-26002_BOQnew.xls",
          LinkName: "BOQ",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app?page=FrontEndTendersByOrganisation&service=page",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "04-07-2025",
      EndDate: "19-07-2024 @ 18:00 hrs",
    },
    {
      Title:
        "Tender for the Supply, installation, testing and commissioning of Transmission System Assembly. - CPPP Tender No: IITT/CSRC/CE/2025-26/02",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2602_Technical_Evalaution_Report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2602_Corrigendum_I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2602_Tender.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2602_Published_Tender.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "02-07-2025",
      EndDate: "30-07-2025 @ 15:00 hrs (Extended)",
    },
    {
      Title:
        "Notice Inviting Expression of Interest (EOI) For for Group  Health Insurance Policy of IIT Tirupati Students. - EOI No: IITT/SAT/2025-26/056",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26056_Stage_I_Evaluation_Report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26056.pdf",
          LinkName: "EOI Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26056_Pre_bid_meeting_minutes.pdf",
          LinkName: "Pre-Bit minutes 2025-26",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26056_Corrigendum.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/ITTSAT2025-2656_corrigendum-2.pdf",
          LinkName: "Corrigendum-II",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26056_AnnexureXI-ClaimRatio_2022-23.pdf",
          LinkName: "Annexure XI Claim Ratio 2022-23",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26056_AnnexureXII-ClaimDump_2022-23.xlsx",
          LinkName: "Annexure XII Claim dump 2022-23",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/ITTSAT2025-2656_Annexure_VII_(a)_Latest_Claim_Analysis_Report_2024-25.xls",
          LinkName: "Annexure VII (a) -Latest  Claim analysis report 2024-25",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/ITTSAT2025-2656_Annexure_VII_(b)_Latest_Claim_Analysis_Report_2024-25.xls",
          LinkName: "Annexure VII (b) -Latest  Claim dump 2024-25",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26056_AnnexureXIII-ClaimDump_2023-24.xlsx",
          LinkName: "Annexure XIII Claim dump 2022-23",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "23-05-2025",
      EndDate: "03-07-2025 @ 17:00 hrs",
    },
    {
      Title:
        "SITC of Dynamic Actuators and 1000 kN Servo- Hydraulic UTM- Optional Accessories and AMC & SITC of Dynamic Actuators and 1000 kN Servo- Hydraulic UTM. - GeM Bid No: GEM/2025/B/6339850",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6339850_Representations_Received.pdf",
          LinkName: "Reply for Representation received",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6339850_Technical_Evalaution_Report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6339850.pdf",
          LinkName: "Bid Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "18-06-2025",
      EndDate: "16-07-2025 @ 15:00 hrs (Extended)",
    },
    {
      Title:
        "Tender for the Supply, installation, testing and commissioning of study tables (165 Nos). - CPPP Tender No: IITT/HM/2025-26/2",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTHM2025-262_Tender_evaluation_report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTHM2025-262.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTHM2025-262_tender_details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "12-06-2025",
      EndDate: "26-06-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Tender for the Supply, installation, testing and commissioning of Computer Workstation - 01 No. - CPPP Tender No: IITT/CSRC/EE/2025-26/03",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCEE2025-2603_Technical_Evaluation_Report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCEE2025-2603_Corrigendum_1.pdf",
          LinkName: "Corrigendum - I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCEE2025-2603.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCEE2025-2603_Tender_Details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "09-06-2025",
      EndDate: "08-07-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for the Construction of Multifuntional stage infront of Academic Building-1 at IIT Tirupati. - NIQ No: IITT/PC/NIQ/2025-26/002",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26002_Corrigendum_I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26002_new.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "26-05-2025",
      EndDate: "04-06-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Notice Inviting Expression of Interest (EOI) For Operating Unisex Hair Salon and Spa Services in IIT Tirupati. - EOI No: IITT/SAT/2025-26/031",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT205-26031_Tender_cancellation_notice.pdf",
          LinkName: "Tender Cancellation Notice",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26031_Corrigendum_I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTSAT2025-26031.pdf",
          LinkName: "EOI Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "22-05-2025",
      EndDate: "11-06-2025 @ 17:00 hrs",
    },
    {
      Title:
        "NIQ for Construction Storage room in WTP-1, MS Path way for STP-1 and Plumbing line for STP-1 collection tank to SBR-1 & 2 - NIQ No: IITT/PC/NIQ/2025-26/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26001.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "16-05-2025",
      EndDate: "30-05-2025 @ 15:30 hrs",
    },
    {
      Title:
        "Inviting Expression of Interest (EoI) for operating the In-house Pharmacy outlet at the Health Centre, IIT Tirupati. - EOI No: IITT/Admin/2025-26/01",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTAdmin2025-2601_TE_Report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTAdmin2025-2601Corr-I.pdf",
          LinkName: "Corrigendum-I",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTAdmin2025-2601.pdf",
          LinkName: "EOI Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName:
            "Representations against technical evaluation, if any, may be forwarded to purchase@iittp.ac.in no later than 06:00 PM, 17 July 2025. Representations received beyond this period will not be entertained.",
        },
        {
          Link: "",
          LinkName:
            "Clarifications regarding the tender document, including terms and conditions, may be sent to ar_genadmin1@iittp.ac.in by keeping a copy to purchase@iittp.ac.in within 7 days from the date of publication of this bid, i.e., before 05:00 PM, 23-05-2025 (Friday).",
        },
      ],
      OpenDate: "16-05-2025",
      EndDate: "12-06-2025 @ 17:00 hrs (Extended)",
    },
    {
      Title:
        "Supply of the study table (165 Nos). - Gem Bid No: GEM/2025/B/6208509",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6208509_cancellation_notice.pdf",
          LinkName: "Tender Cancellation Notice",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6208509.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "15-05-2025",
      EndDate: "05-06-2025 @ 13:00 hrs",
    },
    {
      Title:
        "NIQ for OLTC Service & Oil Filtration of 33/11 kV, 5 MVA Transformers (2 nos). - NIQ No: IITT/PC/NIQ/2025-26/002",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26002_Corrigendum_1.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2025-26002.pdf",
          LinkName: "NIQ Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "30-04-2025",
      EndDate: "07-05-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Annual Maintenance Contract for Horticulture – Landscape Gardening with micro irrigation system at IIT Tirupati, Yerpedu- Venkatagiriroad, Tirupati District, A.P. - Tender No: IITT/EU/HORT/2025-26/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHORT2025-26001_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHORT2025-26001_NIT.pdf",
          LinkName: "NIT Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHORT2025-26001_Corrigendum_1.pdf",
          LinkName: "Corrigendum -I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTEUHORT2025-26001_Scope_of_work_Drawing.pdf",
          LinkName: "Scope of Drawing",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
      ],
      OpenDate: "03-04-2025",
      EndDate: "27-04-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Supply, installation, testing and commissioning of Electric Motor (500 KW)-01 No., & Variable Frequency Drive (VFD)-01 No. - CPPP Tender No: IITT/CSRC/CE/2025-26/01",
      Documents: [

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2601_TE.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2601_Corrigendum-II.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2601_Corrigendum_1.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2601_Tender.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2601_Tender_Details.pdf",
          LinkName: "Tender Details Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "For Item  No.1: Electric Motor (500 KW) -01 No., The Tender process is hereby cancelled, due to administrative reasons. A revised enquiry will be uploaded shortly.",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTCSRCCE2025-2601_PO.pdf",
          LinkName: "For Item No.2:  Variable Frequency Drive (VFD)-01 No.,Purchase Order issued to M/s. M/s Mactrol Motion Control Pvt. Ltd., Ghazibad. Po Copy attached",
        },
      ],
      OpenDate: "04-04-2025",
      EndDate: "09-05-2025 @ 15:00 hrs",
    },
    {
      Title: "Supply of Real Time PCR. - Gem Bid No: GEM/2025/B/6077741",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6077741.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "25-03-2025",
      EndDate: "23-04-2025 @ 14:00 hrs (Extended)",
    },
    {
      Title:
        "Supply Installation Testing and Commissioning of Porous Radiant Burner-36 Nos. - Gem Bid No: GEM/2025/B/5947863",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B5947863.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "25-03-2025",
      EndDate: "24-04-2025 @ 14:00 hrs (Extended)",
    },
    {
      Title:
        "Supply Installation Testing and Commissioning of Dynamic Shear Rheometer-01 No. - Gem Bid No: GEM/2025/B/6078176",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6078176.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "25-03-2025",
      EndDate: "22-04-2025 @ 18:00 hrs (Extended)",
    },
    {
      Title:
        "Supply Installation Testing and Commissioning of Computer Workstation (Server Q2)-01 No. - Gem Bid No: GEM/2025/B/6048438",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6048438.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "17-03-2025",
      EndDate: "29-04-2025 @ 09:00 hrs (Extended)",
    },
    {
      Title:
        "Hiring Security Manpower Services. - Gem Bid No: GEM/2025/B/6024182",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6024182_Award_of_Contract.pdf",
          LinkName: "Award of Contract",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6024182_Re-Evaluation_Report.pdf",
          LinkName: "Responses to Representations Received",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6024182_Final_Technical_Compliance_Statement.pdf",
          LinkName: "Technical Evaluation Statement",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B602418201_Pre_bid_minutes_and_corrigendum.pdf",
          LinkName: "Pre-Bid Minutes and Corrigendum",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B6024182.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName:
            "Pre-Bid Meeting: 13/03/2025 Venue: Administration Building, IIT Tirupati. Time: 11: 00 am",
        },
      ],
      OpenDate: "07-03-2025",
      EndDate: "28-03-2025 @ 12:00 hrs",
    },
    {
      Title:
        "Tender for operating E-Rickshaws on contract basis in IIT Tirupati. - Tender No: IITT/ADMIN/2024-25/11",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTADMIN2024-2511_TE.pdf",
          LinkName: "Technical Evaluation",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTADMIN2024-2511.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=SCwpJenLntz76Me4%2BV6rNTA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "03-03-2025",
      EndDate: "31-03-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Tender for Running Cafeterias in South Campus, Lecture Hall Complex (LHC) And Academic Building 1 (Dry Kitchen) in IIT Tirupati. - Tender No: IITT/HOME/2024-25/10",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTHOME2024-2510_Technical_Evaluation_Report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTHOME2024-2510_Corrigendum_I.pdf",
          LinkName: "Corrigendum - I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTHOME2024-2510.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=Slze4J2KvtLoEAG7tw4jX0Q%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "14-02-2025",
      EndDate: "05-03-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Tender for Running Food Court in North Campus And Coffee Shop In Admin Building In IIT Tirupati. - Tender No: IITT/HOME/2024-25/09",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTHOME2024-2509_Technical_Evaluation_Report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTHOME2024-250_New.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=Sl14jmYIEUMZ0EdyXsmps0Q%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "14-02-2025",
      EndDate: "07-03-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for Supply of Skilled Manpower and materials for Waterproofing works (Cementitious grouting and Bore packing) inside the toilets of South Campus Hostels at IIT Tirupati. - NIQ No: IITT/PC/NIQ/2024-25/012",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2024-25012_Corrigendum_1.pdf",
          LinkName: "Corrigendum-1",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2024-25012.pdf",
          LinkName: "NIQ Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "10-02-2025",
      EndDate: "06-03-2025 @ 15:00 hrs (Extended)",
    },
    {
      Title:
        "Supply Installation Testing and Commissioning of High-Performance Liquid Chromatography with Fluorescence Detector-01 No. - Gem Bid No: GEM/2025/B/5900980",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B5900980.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "05-02-2025",
      EndDate: "26-02-2025 @ 16:00 hrs",
    },
    {
      Title:
        "Supply of office stationary items. - Gem Bid No: GEM/2025/B/5834333",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B5834333_Tender_evaluation_report.pdf",
          LinkName: "Tender Evaluation Report",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B5834333.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "31-01-2025",
      EndDate: "05-03-2025(Extended) @ 18:00 hrs",
    },

    {
      Title:
        "Supply of Real Time PCR - 01 No. - Gem Bid No: GEM/2025/B/5886670",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B5886670.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "31-01-2025",
      EndDate: "21-02-2025 @ 13:00 hrs",
    },

    {
      Title:
        "NIQ for Supplying and Fixing of False ceiling Hostel-F in south campus at IIT Tirupati. - NIQ No: IITT/PC/NIQ/2024-25/011",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2024-25011_Tender_Document_Drawing.pdf",
          LinkName: "NIQ Tender Document and Drawing",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "28-01-2025",
      EndDate: "10-02-2025 @ 15:00 hrs",
    },

    {
      Title:
        "Supply of Octagonal Table-01 No. - Gem Bid No: GEM/2024/B/5753819",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2024B5753819.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "27-01-2025",
      EndDate: "17-02-2025 @ 16:00 hrs",
    },

    {
      Title:
        "NIQ for 'Supply of Signage boards make ACP Sheet with Reflective Sheeting Printing (Speed Limit 30 Km/h 24x18 inch) -10No’s, (Speed Limit 20 Km/h 24x18 inch) - 80No’s, (Signage Boards on the main road opposite to main gate (4 Feet X 2 Feet)-4No’s, School Ahead Board (1.5 Feet X 1.5 Feet), MS Square Pipe 71No’s and Star Flex Blackout Eco Solvent Print 2No’s to IIT Tirupati.  - NIQ No: IITT/PC/NIQ/2024-25/010",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/IITTPCNIQ2024-25010.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "20-01-2025",
      EndDate: "03-02-2025 @ 15:00 hrs",
    },
    {
      Title: "Supply of Passive Components. - Gem Bid No: GEM/2025/B/5813101",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B5813101_AOC.pdf",
          LinkName: "Award of Contract",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B5813101_Technical_compliance_statement.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2025B5813101.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "15-01-2025",
      EndDate: "05-02-2025 @ 18:00 hrs",
    },
    {
      Title: "Supply of Computer Systems. - Gem Bid No: GEM/2024/B/5671439",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2024B5671439_Award_of_Contract.docx",
          LinkName: "Award of Contract",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2024B5671439_Technical_compliance_statement.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2024B5671439.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "02-01-2025",
      EndDate: "23-01-2025 @ 10:00 hrs",
    },
    {
      Title: "Supply of Passive Components. - Gem Bid No: GEM/2024/B/5725943",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2024B5725943_Tender_cancellation_notice.pdf",
          LinkName: "Tender cancelled due to administrative reasons",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2024B5725943.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "02-01-2025",
      EndDate: "23-01-2025 @ 11:00 hrs",
    },
    {
      Title:
        "Supply Installation Testing and Commissioning of High-Performance Liquid Chromatography with Fluorescence Detector-01 No. - Gem Bid No: GEM/2024/B/5753702",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2024B5753702.png",
          LinkName:
            "Due to administrative reasons the bid has been cancelled. Retender for the same will be published",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2025/GEM2024B5753702.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "02-01-2025",
      EndDate: "23-01-2025 @ 12:00 hrs",
    },
    {
      Title:
        "Supply, installation, testing and commissioning of Electric Motor (500 KW)-01 No. - Tender No: IITT/CE/2024-25/06",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCE2024-2506_Cancellation.pdf",
          LinkName:
            "Due to administrative reasons, the Tender process is hereby cancelled. A revised tender will be uploaded shortly.",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCE2024-2506.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCE2024-2506_Tender_Details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "12-12-2024",
      EndDate: "02-01-2025 @ 15:00 hrs",
    },
    {
      Title:
        "Supply, installation, testing and commissioning of BEVEL HELICAL GEAR BOX (500 KW) - 01 No. - Tender No: IITT/CSRC/CE/2024-25/05",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCSRCCE2024-2505_TE.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCSRCCIE2024-2549_Corrigendum_1.pdf",
          LinkName: "Corrigendum - I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCSRCCE2024-2505.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/ITTCSRCCE2024-2505_Tender_Details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "11-12-2024",
      EndDate: "08-01-2025 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for 'Supply and fixing of Mirrors in South Campus Boys & Girls Hostels at IT Tirupati Campus. - NIQ No: IITT/PC/NIQ/2024-25/009",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQ2024-25009.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "04-12-2024",
      EndDate: "12-12-2024 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for Supply and Fixing of Concertina Coils Fencing for Enhancing Security at Compound Wall Boundaries at IT Tirupati Campus. - NIQ No: IITT/PC/NIQ/2024-25/008",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQ2024-25008.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "04-12-2024",
      EndDate: "12-12-2024 @ 15:00 hrs",
    },
    {
      Title:
        "Item No. 1: Supply, installation, testing and commissioning of Spherical Roller Bearing-02 Nos., Item No. 2: Supply, installation, testing and commissioning of Thrust bearing-01 No.,  - Tender No: IITT/CE/2024-25/04",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/Technical_Evaluation_IITTCE2024-2504.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCE2024-2504_Corrigendum_1.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/ITTCE2024-2504_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/ITTCE2024-2504_Tender_Details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "13-11-2024",
      EndDate: "10-12-2024 @ 15:00 hrs",
    },

    {
      Title:
        "Supply of Major Electrical Consumables to IIT Tirupati - Tender No: IITT/EU/2024-25/08",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEU2024-2508_Technical_Evalution_Report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEU2024-2508_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEU2024-2508_Tender_Details.pdf",
          LinkName: "Tender Details",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app;jsessionid=194AF4BE757C91E4CFE533C70B69C2CB.eprocgep1?page=CommonErrorPage&service=page",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "12-11-2024",
      EndDate: "03-12-2024 @ 18:00 hrs",
    },

    {
      Title:
        "Supply of Network Access Storage-01 No., - Gem Bid No: GEM/2024/B/5417010",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5417010_Bid_Due_date_extension.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5417010.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "11-11-2024",
      EndDate: "23-12-2024 @ 10:00 hrs",
    },

    {
      Title:
        "NIT for Comprehensive AMC for Playground and Sports fields Maintenance Works in IIT Tirupati, Yerpedu (M), Tirupati (Dt). - NIT NO: IITT/EU/Hort/2024-25/002",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUHort2024-25002.pdf",
          LinkName: "NIT Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUHort2024-25002_Tnder_Details.pdf",
          LinkName: "Tender Details",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUHort2024-25002_Tendernotice.pdf",
          LinkName: "Tender Notice",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUHort2024-25002_Annexure_1.PDF",
          LinkName: "Annexure-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUHort2024-25002_BOQ_876169.xls",
          LinkName: "BoQ",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
      ],
      OpenDate: "07-11-2024",
      EndDate: "25-11-2024 @ 15:00 hrs",
    },

    {
      Title:
        "Supply, installation, testing and commissioning of Universal Testing Machine for Compression, Tension and Penetration-01 No. - CPPP Tender Ref No. IITT/CH/2024-25/03",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCH2024-25_03.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/CPPP_IITTCH2024-25_03.pdf",
          LinkName: "CPPP Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          LinkName: (
            <>
              Date of opening of bids: <br />
              05-11-2024 @ 15:00 hrs
            </>
          ),
        },
      ],
      OpenDate: "14-10-2024 @ 18.00 hrs",
      EndDate: "04-11-2024 @ 15.00 hrs",
    },
    {
      Title:
        "Notice Inviting Tender for Electrical, Mechanical Operations and Maintenance Services at IIT Tirupati - Tender No: IITT/EU/E&M/TENDER/2024-25/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/ITTEUE&MTENDER2024-25001.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/ITTEUE&MTENDER2024-25001_BOQ_870953.xls",
          LinkName: "BoQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUE&MTENDER2024-25001_Addendum_1.pdf",
          LinkName: "Addendum-1 Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "02-10-2024 @ 15.00 hrs",
      EndDate: "23-10-2024 @ 15.00 hrs",
    },
    {
      Title:
        "Notice Inviting Tender for Operations and Maintenance (Non-Comprehensive) of 100 kLD Sewage Treatment Plant, 275 kLD Sewage Treatment Plant, 325 kLD Sewage Treatment Plant, 55 kLD Domestic Water Treatment Plant & 600 kLD Domestic Water Treatment Plants at IIT Tirupati - Tender No: IITT/EU/STP&WTP/TENDER/2024-25/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUSTP&WTPTENDER2024-25001.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUSTP&WTPTENDER2024-25001_BOQ_870958.xls",
          LinkName: "BoQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUSTP&WTPTENDER2024-25001_OEMTechnicalSupportingDocuments.pdf",
          LinkName: "OEM Technical Supporting Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITT_EU_STP-WTP_TENDER_2024-25_001.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUSTP&WTPTENDER2024-25001_Corrigendum_2.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUSTP&WTPTENDER2024-25001_Addendum_1.pdf",
          LinkName: "Addendum-1 Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "02-10-2024 @ 15.00 hrs",
      EndDate: "23-10-2024 @ 15.00 hrs",
    },

    {
      Title: "Supply of Television. - Gem Bid No: GEM/2024/B/5405534",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/Tender_cancellation_notice_GEM2024B5405534.pdf",
          LinkName: "Cancelled due to administrative reasons",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5405534_Television_Evaluation.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5405534.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "19-09-2024",
      EndDate: "10-10-2024 @ 18:00 hrs",
    },

    {
      Title:
        "NIQ for 'Supply and Installation for the Replacement of Damaged Doors in Toilets' at South Campus Hostels in IIT Tirupati. - NIQ No: IITT/PC/NIQ/2024-25/007",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQ2024-25007.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "18-09-2024",
      EndDate: "25-09-2024 @ 15:00 hrs",
    },

    {
      Title:
        "Supply of High Temperature Horizontal Single Zone Calcination Tubular Furnace-01 No., - Gem Bid No: GEM/2024/B/5357067",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5357067.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "10-09-2024",
      EndDate: "01-10-2024 @ 18:00 hrs",
    },

    {
      Title: "Supply of Spectrometer-01 No., - Gem Bid No: GEM/2024/B/5367924",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5367924.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "10-09-2024",
      EndDate: "01-10-2024 @ 18:00 hrs",
    },

    {
      Title: "Procurement of A4 Paper reams - Gem Bid No: GEM/2024/B/5250095",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5250095.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "10-09-2024",
      EndDate: "20-09-2024 @ 16:00 hrs",
    },

    {
      Title:
        "NIQ for Supply and Replacement of Damaged 1000 Litre Hot Water Tanks (including Heater Elements) and Toughened Glasses for Solar Hot Water Systems at Hostels – Abheri & Basant - NIQ No: IITT/PC/NIQ/E&M/001/2024-25",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQE&M0012024-25.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQE&M0012024-25_Annexure-I.pdf",
          LinkName: "Annexure-I Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQE&M0012024-25_Annexure-II.pdf",
          LinkName: "Annexure-II Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQE&M0012024-25_Annexure-III.pdf",
          LinkName: "Annexure-III Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "05-09-2024",
      EndDate: "12-09-2024 @ 15:00 hrs",
    },

    {
      Title: "Supply of Laser Profilometer - Gem Bid No: GEM/2024/B/5273901",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5273901.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "04-09-2024",
      EndDate: "25-09-2024 @ 14:00 hrs",
    },

    {
      Title:
        "Supply of Supply, installation, testing and commissioning of Supply, installation, testing and commissioning of Bevel Helical Gear Box (550 KW) -01 No., and Electric Motor (550 KW)-01 No. - CPPP Tender Ref No. IITT/CE/2024-25/02",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCE2024-2502_Cancellation_CPPP.pdf",
          LinkName:
            "Due to administrative reasons, the Tender process is hereby cancelled. A revised tender will be uploaded shortly.",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCE2024-2502_Corri_I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCE2024-2502_Tender_Document.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCE2024-2502.pdf",
          LinkName: "CPPP Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "30-08-2024",
      EndDate: "08-10-2024 @ 15:00 hrs",
    },
    {
      Title:
        "NIT for Empanelment of Advertising Agencies to IIT Tirupati - NIT No: IITT/GA/2024-25/07",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTGA2024-2507_Technical_Evaluation_Report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTGA2024-2507Corr-IV.pdf",
          LinkName: "Corrigendum-IV",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTGA2024-2507Corr-III.pdf",
          LinkName: "Corrigendum-III",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTGA2024-2507Corr-II.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTGA2024_2507Corr-I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTGA2024-2507.pdf",
          LinkName: "NIT Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app;jsessionid=C9E962FD93B8C9046ED6BB87721E3C1C.eprocgep1?page=CommonErrorPage&service=page",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "27-08-2024",
      EndDate: "05-10-2024 @ 15:00 hrs",
    },

    {
      Title: "Supply of Spectrometer-01 No. - Gem Bid No: GEM/2024/B/5305205",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5305205_BID_Cancellation.png",
          LinkName: "BID Cancellation",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5305205.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName:
            "Due to administrative reasons the bid has been cancelled. Retender for the same will be published with revised specifications.",
        },
      ],
      OpenDate: "20-08-2024",
      EndDate: "10-09-2024 @ 18:00 hrs",
    },

    {
      Title:
        "NIQ for Providing and Fixing the MS Grills for the Windows at Academic & Hostel Zones at IIT Tirupati - NIQ No: IITT/PC/NIQ/2024-25/006",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQ2024-25006.PDF",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "16-08-2024",
      EndDate: "26-08-2024 @ 15:00 hrs",
    },
    {
      Title:
        "NIQ for Applying Rust Protection Paint over MS Pergolas and Mesh Structures Including Surface Preparation, Cleaning and Removal of Old Paint at IIT Tirupati South Campus - NIQ No: IITT/PC/NIQ/2024-25/005",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQ2024-25005.PDF",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "16-08-2024",
      EndDate: "30-08-2024 @ 15:00 hrs",
    },

    {
      Title: "Supply of IPPBX Hardware Server - Gem Bid No: GEM/2024/B/5258184",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5258184.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: (
            <>
              Date of opening of bids: <br />
              29-08-2024 @ 15:30 hrs
            </>
          ),
        },
      ],
      OpenDate: "08-08-2024",
      EndDate: "29-08-2024 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of High Magnification Digital Microscope - Gem Bid No: GEM/2024/B/5176114",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5176114.jpg",
          LinkName: "Extended bid details",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5176114.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "06-08-2024",
      EndDate: "04-09-2024 @ 12:00 hrs (Extended)",
    },

    {
      Title:
        "NIQ for Providing and Applying Paint to the GFRG External Walls of the Guest House & Maintenance offices at IIT Tirupati South Campus. - NIQ No: IITT/PC/NIQ/2024-25/003",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQ2024-25003.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "02-08-2024",
      EndDate: "12-08-2024 @ 15:00 hrs",
    },

    {
      Title:
        "Supply of Computer Workstation-01 No. - Gem Bid No: GEM/2024/B/5179344",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5179344.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5179344_Bid_Cancelled.png",
          LinkName:
            "Due to Technical Disqualification of bidders the bid has been cancelled. Retender for the same will be published with revised specifications.",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5179344-C1.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      OpenDate: "26-07-2024",
      EndDate: "16-08-2024 @ 18:00 hrs",
    },
    {
      Title:
        "NIQ for Providing and fixing of the Aluminum partition in the darkroom & minor painting work for internal walls at UG Physics lab at LHC at IIT Tirupati - NIQ No: IITT/PC/NIQ/2024-25/004",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQ2024-25004.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "",
          LinkName: "",
        },
      ],
      OpenDate: "25-07-2024",
      EndDate: "02-08-2024 @ 15:00 hrs",
    },
    {
      Title:
        "Notice Inviting Tender (NIT) for Pest Control Services on Contract Basis at IIT Tirupati - NIT No: IITT/ADMIN/2024-25/06",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2506.pdf",
          LinkName: "NIT Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2506_Award_of_contract.pdf",
          LinkName: "Award of Contract",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2506_Pre_bid_meeting_Minutes.pdf",
          LinkName: "Pre Bid Meeting Minutes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2506_Corri1.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=SUcwENWuTmj8ruAlC4FmUbQ%3D%3D",
          LinkName: "Link-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/Total_Pest_Control_TER.pdf",
          LinkName: "Technical Evaluation Report",
        },
      ],
      OpenDate: "19-07-2024",
      EndDate: "12-08-2024 @ 15:00 hrs",
    },
    {
      Title:
        "Supply, installation, testing and commissioning of Server-04 Nos. - Tender NO: CSRC/PR/CY/2023-24/138 & CPPP Tender Ref No. IITT/CY/2024-25/01",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/CSRCPRCY2023-24138.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/CSRCPRCY2023-24138_Date_Corrigendum.pdf",
          LinkName: "Date Corrigendum Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/CSRCPRCY2023-24138_Technical_Corrigendum.pdf",
          LinkName: "Technical Corrigendum Document",
        },
      ],
      OpenDate: "12-07-2024",
      EndDate: "31-07-2024 @ 15:00 hrs",
    },
    {
      Title: "Supply of Server - 02 Nos. - Gem Bid NO: GEM/2024/B/5112996",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5112996.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "12-07-2024",
      EndDate: "16-08-2024 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Tubular Furnace-01 No. - Gem Bid No: GEM/2024/B/4982830",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4982830_cancellation.png",
          LinkName:
            "1. Due to Technical Disqualification of bidders the bid has been cancelled. Retender for the same will be published with revised specifications.",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4982830.pdf",
          LinkName: "2. BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "04-07-2024",
      EndDate: "25-07-2024 @ 18:00 hrs",
    },
    {
      Title:
        "NIT for Empanelment of Taxi Service Providers to IIT Tirupati. - NIT No: IITT/ADMIN/2024-25/05",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2505_Technical_evaluation_report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/EOI_Taxi_Services_2024-05.pdf",
          LinkName: "NIT Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "01-07-2024",
      EndDate: "05-10-2024 @ 15:00 hrs (Extended)",
    },
    {
      Title:
        "NIQ document for the Supply and application of polyurethane sealant for the gaps between the PUFF sheet and connecting walls at Lab 1 and Lab 2 in IIT Tirupati South Campus NIQ No: IITT/PC/NIQ/2024-25/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQ2024-25002.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "28-06-2024",
      EndDate: "05-07-2024 @ 15:00 hrs",
    },

    {
      Title:
        "NIQ document for Providing and fixing GI gutter for the puff rooftop at both sides and PVC sheet for louvres at Lab1 & 2 in  IIT Tirupati NIQ No: IITT/PC/NIQ/2024-25/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPCNIQ2024-25001.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "28-06-2024",
      EndDate: "05-07-2024 @ 15:00 hrs",
    },
    {
      Title:
        "NIT document for the Construction of NATPaVed Lab and Heavy Structural Engineering Lab, Testing Track, including Civil, Electrical, Plumbing and Allied Service Like Roads, Street Lighting Works, Septic Tank, Drains, Minor Horticulture Development etc. - NIT No: IITT/EU/NEE(C)/2024-25/003",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/NIT003_NATPaveDlabTenderdocument.pdf",
          LinkName: "1. NIT Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/NIT003_Tender_Details.pdf",
          LinkName: "2. Tender Details",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/NIT003_Drawings.pdf",
          LinkName: "3. Drawings",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/NIT003_BOQ_855093.xls",
          LinkName: "4. BoQ",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "27-06-2024",
      EndDate: "18-07-2024 @ 15:00 hrs",
    },
    {
      Title:
        "NIT for for disposing of Metal Scrap, Mild Steel Components (Rod, Square, Plates) and Carpentry at IIT Tirupati. - NIT NO: IITT/Stores/Disp./Scrap/2024-25/04",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTStoresDisp.Scrap2024-2504_9_6_24.pdf",
          LinkName: "NIT Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/Corrigendum24-25_04.pdf",
          LinkName: "Corrigendum",
        },
      ],
      eProcurementLinks: [
        {
          Link: "#",
          LinkName: "Date of opening of bids: 22.07.2024 at 11.00 hrs",
        },
      ],
      OpenDate: "07-06-2024",
      EndDate: "19-07-2024 @ 17:00 hrs",
    },
    {
      Title:
        "NIT for Group Health Insurance Policy for IIT Tirupati Students. - NIT NO: IITT/HoME/2024-25/03",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTHoME2024-2503.pdf",
          LinkName: "1. NIT Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/2024-25_03-prebid-minutes.pdf",
          LinkName: "2. Pre Bid Meeting Minutes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTHoME2024-2503_Corrigendum-II.pdf",
          LinkName: "3. Corrigendum - II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTHoME2024-2503_Annexure_VIII_(a)-Existing_Policy.pdf",
          LinkName: "4. Annexure VIII (a) - Existing Policy",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTHoME2024-2503_Annexure_VIII_(b)-Claim_Dump2023-24_5_7_2024.xlsx",
          LinkName: "5. Annexure VIII (b) - Claim Dum 2023-24",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTHoME2024-2503_Annexure_VIII_(c)-Claim_Dump_2022-23.xlsx",
          LinkName: "6. Annexure VIII (c) - Claim Dump 2022-23",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTHoME2024-2503_Annexure_VIII_(d)-Claim_ratio_2022-23.pdf",
          LinkName: "7. Annexure VIII (d) - Claim Ratio 2022-23",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=SGydJn3jd1slj4cmF8c9hxg%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "07-06-2024",
      EndDate: "08-07-2024 @ 15:00 hrs",
    },
    {
      Title:
        "Hiring of Manpower Outsourcing Services (Fixed Remuneration) - Gem Bid No: GEM/2024/B/5021782",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5021782.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B5021782_Technical_Evaluation_Final.pdf",
          LinkName: "Technical Evaluation Report",
        },
        // {
        //     "Link": " - ",
        //     "LinkName": "Pre Bid Meeting: 18-6-204 (Tuesday) at 15:00:00"
        // }
      ],
      OpenDate: "06-06-2024",
      "Pre Bid Meeting": "18-6-204",
      EndDate: "27-06-2024 @ 13:00 hrs",
    },

    {
      Title:
        "NIT for Providing Mechanized Housekeeping Services on Contract Basis - NIT NO: IITT/ADMIN/2024-25/02",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2502_Stage_II_Evaluation_Report.pdf",
          LinkName: "Stage II Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2502_Final_Technical_Evaluation_Report.pdf",
          LinkName: "Stage I Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2502_Pre-bid-minutes_with_queries.pdf",
          LinkName: "Pre Bid Meeting Minutes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2502_Corrigendum3.pdf",
          LinkName: "Corrigendum - III",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2502_Corri2.pdf",
          LinkName: "Corrigendum - II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2502_Corri-1.pdf",
          LinkName: "Corrigendum - I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2502.pdf",
          LinkName: "NIT Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=S6jQIjRs%2BOYh%2BV9KDZ6OTRA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "10-05-2024",
      EndDate: "18-06-2024 @ 15:00 hrs",
    },
    {
      Title:
        "Selection of Agency for Sale of carton boxes, empty plastic bottles, waste papers, old newspapers/magazines/books, wooden pallets, etc in IIT Tirupati. - NIT NO: IITT/ADMIN/2024-25/01",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTADMIN2024-2501_Updated.pdf",
          LinkName: "NIT Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "09-05-2024",
      EndDate: "05.07.2024 @ 15.00 hrs",
    },
    {
      Title:
        "Civil AMC for Carpentry, Plumbing, Masonry, External development works, and day-to-day maintenance works in IIT Tirupati, Yerpedu (M), Tirupati (Dt). Andhra Pradesh. - Tender NO: IITT/EU/EE(C)/24-25/002",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTEUEE(C)24-25002.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "19-04-2024",
      EndDate: "09-05-2024 @ 15:00 hrs",
    },
    {
      Title:
        "Supply and Installation of Venetian Blinds (Dual – Zebra – Roller Blinds) and Cloth Curtains for Windows at various locations in Academic Buildings at IIT Tirupati, Yerpedu – Venkatagiri Road, Yerpedu Post, Tirupati District, A. P - NIT NO: IITTP/EU/EE(C)/2024-25/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTPEUEE(C)2024-25001.pdf",
          LinkName: "NIT Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "12-04-2024",
      EndDate: "02-05-2024 @ 15:00 hrs",
    },

    {
      Title:
        "Supply of SITC of Coriolis Mass Flow Controller-02 Nos. - Gem Bid No: GEM/2024/B/4834664",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4834664.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "10-04-2024",
      EndDate: "01-05-2024 @ 18:00 hrs",
    },
    {
      Title: "Supply of Vacuum Pump-01 No. - Gem Bid No: GEM/2024/B/4820914",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4820914.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "03-04-2024",
      EndDate: "24-04-2024 @ 12:00 hrs",
    },
    {
      Title:
        "Supply of High Performance Computing Cluster-04 Nos. - Gem Bid No: GEM/2024/B/4820127",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4820127.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "02-04-2024",
      EndDate: "23-04-2024 @ 12:00 hrs",
    },
    {
      Title:
        "Supply of Electro Organic Synthesizer-01 No. - Gem Bid No: GEM/2024/B/4799380",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4799380.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "02-04-2024",
      EndDate: "23-04-2024 @ 13:00 hrs",
    },
    {
      Title: "Supply of Server-01 No. - Gem Bid No: GEM/2024/B/4780913",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4780913.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "19-03-2024",
      EndDate: "09-04-2024 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Bucket Mop Wringer Trolley - Gem Bid No: GEM/2024/B/4768898",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4768898_Tender_cancellation_notice.pdf",
          LinkName: "Tender Cancellation Notice",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4768898.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "18-03-2024",
      EndDate: "15-04-2024 @ 13:00 hrs",
    },

    {
      Title: "Supply of Scissor Lift Ladder - Gem Bid No: GEM/2024/B/4769329",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4769329Tender_cancellation_notice.pdf",
          LinkName: "Tender Cancellation Notice",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4769329.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "18-03-2024",
      EndDate: "22-04-2024 @ 11:00 hrs",
    },

    {
      Title:
        "Purchase of Microsoft Campus Agreement - Gem Bid No: GEM/2024/B/4692117",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4692117.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "01-03-2024",
      EndDate: "15-03-2024 @ 17:00 hrs",
    },

    {
      Title:
        "Supply of Rack Mounted Server and Workstation along with Rack - 01 No. - Gem Bid No: GEM/2024/B/4672628",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4672628-C1.pdf",
          LinkName: "Corrigendum - I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4672628.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "23-02-2024",
      EndDate: "15-03-2024 @ 18:30 hrs",
    },

    {
      Title:
        "Supply of Mechanochemical Reactor and Accessories - 01 No. - Gem Bid No: GEM/2024/B/4659542",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4659542.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "23-02-2024",
      EndDate: "15-03-2024 @ 17:30 hrs",
    },

    {
      Title:
        "Supply of Power Supply Unit for Plasma Setup - 01 No. - Gem Bid No: GEM/2024/B/4669392",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4669392.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: "",
        },
      ],
      OpenDate: "22-02-2024",
      EndDate: "14-03-2024 @ 14:30 hrs",
    },

    {
      Title:
        "Supply of Atomic Force Microscope to IIT Tirupati - Tender No: IITT/CI/2023-24/23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCI2023-2423_Tendercancellation.pdf",
          LinkName: "Tender Cancellation Notice",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCI2023-2423.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName:
            "Pre-Bid Meeting: 28/02/2024 Venue: Mechanical Meeting Room, Academic Building II, IIT Tirupati. Time: 12: 10 pm",
        },

        {
          Link: "",
          LinkName: "",
        },
        {
          Link: "https://meet.google.com/ftv-txte-fip",
          LinkName: "Online Link [Click Here]",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=SobTac%2BUp75OBvP%2F2QoDpsQ%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "16-02-2024",
      EndDate: "17-04-2024 @ 15:00 Hrs",
    },

    {
      Title:
        "Supply, installation, testing and commissioning of PRB [Porous Radiant Burner] Operated Ceramic Dryer.      1. Gem Bid No: CSRC / PR / ME / 2023 - 24 / 107 2. CPPP Tender Ref No.IITT / ME / 2023 - 24 / 107",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTME2023-24107.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "16-02-2024",
      EndDate: "08-03-2024 @ 15:00 hrs",
    },

    {
      Title: "Supply of SITC of Server-01 No. - Gem Bid No: GEM/2024/B/4581642",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4581642.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "16-02-2024",
      EndDate: "08-03-2024 @ 16:00 hrs",
    },

    {
      Title:
        "Supply of SITC Of Workstation-01 No. - Gem Bid No: GEM/2024/B/4618648",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4618648.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "16-02-2024",
      EndDate: "08-03-2024 @ 17:00 hrs",
    },

    {
      Title:
        "Empanelment of Advertising Agencies for publication of advertisement in Newspapers for IIT Tirupati - Tender No: IITT/GA/2023-24/26",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTGA2023-2426.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=view&page=PublishedTenderList&service=direct&session=T&sp=SIYdnaAfmoHS2rE1rQ0arikafVb0P7Ez%2BKkmtWdMxt%2BwoU%2B7RSdyMWYGzGDURy7QP",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "15-02-2024",
      EndDate: "07-03-2024 @ 15:00 Hrs",
    },

    {
      Title:
        "Annual Rate Contract for Chemicals, Plasticwares, Reagents, Glasswares, solvents, electronic components, vacuum consumables, and lab wares, optics and opt mechanics, Minor instruments & Minor equipment - Tender No: IITT/CY/2023-24/27",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/Tender_No_IITTC_2023-2427_TES.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCY2023-2427.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCY2023-2427_Pricbid.pdf",
          LinkName: "Price Bid Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=SdooNw82RhRqNWu%2BYQpFDhg%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "14-02-2024",
      EndDate: "13-03-2024 @ 15:00 Hrs",
    },

    {
      Title:
        "Supply of H Bridge Inverter and H Bridge Rectifier - Tender No: IITT/ELE/2023-24/25",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTELE2023-2425.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=SbmcCfyi4yuPV3X0EAM9KmA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "13-02-2024",
      EndDate: "05-03-2024 @ 15:00 Hrs",
    },

    {
      Title:
        "Supply of SiC MOSFET Three Phase Inverter and SiC H Bridge Inverter - Tender No: IITT/ELE/2023-24/24",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTELE2023-2424.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=S1rzHS9hF44fHznD07o2d2g%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "13-02-2024",
      EndDate: "05-03-2024 @ 15:00 Hrs",
    },

    {
      Title:
        "Supply of Item No.1: Supply, installation, testing and commissioning of Asphalt Strain Gauge- 26 Nos. Item No.2 : Supply, installation, testing and commissioning of Earth Pressure Cell -02 Nos. Item No.3 : Supply, installation, testing and commissioning of Asphalt Temperature Sensor-02 Nos. 1. Ref No: 1. CSRC / PR / CE / 2023 - 24 / 112 2. CPPP Tender Ref No.IITT / CE / 2023 - 24 / 112",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITTCE2023-24112.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "02-02-2024",
      EndDate: "23-02-2024 @ 15:00 hrs",
    },

    {
      Title: "Supply of Passive Components Gem Bid No: GEM/2024/B/4547692",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4547692.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "30-01-2024",
      EndDate: "26-02-2024 @ 17:00 hrs",
    },

    {
      Title:
        "Supply of the SITC Of Data Acquisition System Gem Bid No: GEM/2024/B/4520552",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4520552.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "25-01-2024",
      EndDate: "15-02-2024 @ 16:30 hrs",
    },

    {
      Title:
        "Supply of the Ball Mill for Laboratory-01 No. Gem Bid No: GEM/2024/B/4512288",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4512288.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "23-01-2024",
      EndDate: "13-02-2024 @ 17:30 hrs",
    },

    {
      Title: "Supply of the IPPBX Gem Bid No: GEM/2023/B/4467921",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4467921_Cancellation_Notice-IPPBX.pdf",
          LinkName: "Cancellation Notice",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4467921.pdf",
          LinkName: "BOQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "16-01-2024",
      EndDate: "06-02-2024 @ 11:30 hrs",
    },

    {
      Title:
        "Supply of the Computer Workstations Gem Bid No: GEM/2023/B/4470680",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4470680.pdf",
          LinkName: "BOQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "12-01-2024",
      EndDate: "02-02-2024 @ 17:30 hrs",
    },

    {
      Title:
        "Supply of the Computer Workstations Gem Bid No: GEM/2023/B/4470398",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4470398.pdf",
          LinkName: "BOQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "12-01-2024",
      EndDate: "02-02-2024 @ 17:30 hrs",
    },

    {
      Title:
        "Supply of Ultra Sonic Spray Coater-01 No. Gem Bid No: GEM/2024/B/4457621",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2024B4457621.pdf",
          LinkName: "BOQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "12-01-2024",
      EndDate: "02-02-2024 @ 17:00 hrs",
    },

    {
      Title:
        "NIQ document for Refilling of 161 no's of CO2 (4.5kg) , 95 no's of ABC (4KG) and 531 no's of ABC (6kg) Fire Extinguishers at South Campus and at Stage 1C Buildings IIT Tirupati NIQ No: IITT/PC/NIQ/06/2023-24",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ062023-24.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ062023-24_%20BOQ.pdf",
          LinkName: "BOQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "11-01-2024",
      EndDate: "21-1-2024 @ 15:00 hrs",
    },

    {
      Title: "Supply of Probe Sonicator Gem Bid No:GEM/2024/B/4420012",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2024B4420012.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "10-01-2024",
      EndDate: "31-1-2024 @ 17:30 hrs",
    },

    {
      Title:
        "Expression of Interest (EOI) for running Cafeteria at South Campus, IIT Tirupati. EoI No:IITTP/HoME/265/2023",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPHoME2652023.pdf",
          LinkName: "Eol Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: " - ",
          LinkName: " - ",
        },
      ],
      OpenDate: "05-01-2024",
      EndDate: "18-01-2024 @ 17:00 hrs",
    },

    {
      Title:
        "Providing Supply and fixing of SS Perforated trench grating for drains at the New dining block, and MS sheet shed for the boiler along with Internal water supply for the Incubation Centre at Permanent Campus IIT Tirupati NIQ No:IITT/PC/NIQ/004/2023-24",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ0042023-24.pdf",
          LinkName: "1. NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ0042023-24_ Annexure-1.pdf",
          LinkName: "2. Annexure-1",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ0042023-24_pipe-line-plan.pdf",
          LinkName: "3. Pipe Line Plan",
        },
      ],
      eProcurementLinks: [
        {
          Link: "-",
          LinkName: "-",
        },
      ],
      OpenDate: "29-12-2023",
      EndDate: "05-01-2024 @ 15:00 hrs",
    },

    {
      Title:
        "Supply of SITC of Electrochemical Workstation-01 No. Gem Bid No:GEM/2023/B/4273627",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4273627.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "-",
          LinkName: "-",
        },
      ],
      OpenDate: "29-12-2023",
      EndDate: "19-1-2024 @ 15:30 hrs",
    },
    {
      Title:
        "Supply of Electrochemical Workstation Gem Bid No:GEM/2023/B/4361612",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4361612.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "-",
          LinkName: "-",
        },
      ],
      OpenDate: "26-12-2023",
      EndDate: "16-1-2024 @ 17:30 hrs",
    },

    {
      Title:
        "Supply of Data Acquisition System-01 No. Gem Bid No:GEM/2023/B/4275620",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4275620.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "-",
          LinkName: "-",
        },
      ],
      OpenDate: "20-12-2023",
      EndDate: "10-1-2024 @ 17:30 hrs",
    },
    {
      Title:
        "Providing Catering Services to IIT Tirupati - Tender No: IITT/HoME/2023-24/22",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTHoME2023-2422.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=Sg4JAZNMaJIWKJmgbp4wQng%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "20-12-2023",
      EndDate: "18-01-2024 @ 15:00 Hrs",
    },

    //test
    {
      Title:
        "Supply of Two port Vector Network Analyser with Accessories Gem Bid No:GEM/2023/B/4328893",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4328893.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "-",
          LinkName: "-",
        },
      ],
      OpenDate: "18-12-2023",
      EndDate: "8-1-2024 @ 14:30 hrs",
    },
    {
      Title:
        "Supply of Electrochemical Workstation - Ductless Fumehood Gem Bid No:GEM/2023/B/4276785",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4276785.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "-",
          LinkName: "-",
        },
      ],
      OpenDate: "12-12-2023",
      EndDate: "08-01-2024 @ 09:00 hrs",
    },
    {
      Title: "Supply of A3 Printer Gem Bid No:GEM/2023/B/4270886",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4270886.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4270886-C3.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      OpenDate: "01-12-2023",
      EndDate: "04-01-2024 @ 17:00 hrs",
    },
    {
      Title:
        "Supply of Mercury Intrusion Porosimetry -01 No. Gem Bid No:GEM/2023/B/4270667",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4270667.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "-",
          LinkName: "-",
        },
      ],
      OpenDate: "01-12-2023",
      EndDate: "22-12-2023 @ 15:30 hrs",
    },

    {
      Title: "Supply of All In One Gem Bid No:GEM/2023/B/4153423",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4153423.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "-",
          LinkName: "-",
        },
      ],
      OpenDate: "30-11-2023",
      EndDate: "20-12-2023 @ 15:30 hrs",
    },
    {
      Title:
        "Supply of Large scale geosynthetics pullout equipment -01 No. Gem Bid No:GEM/2023/B/4245144",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4245144.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "-",
          LinkName: "-",
        },
      ],
      OpenDate: "29-11-2023",
      EndDate: "20-12-2023 @ 15:30 hrs",
    },

    {
      Title:
        "Supply of Variable Angle Laser Ellipsometer to IIT Tirupati - Tender No: IITT/EU/2023-24/19",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2419.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=S71atywFmpHtAxTaKnLhZfw%3D%3D",
          LinkName: "Link2",
        },
      ],
      OpenDate: "15-11-2023",
      EndDate: "05-12-2023 @ 15:00 Hrs",
    },
    // -----

    {
      Title:
        "EOI for operating in house Pharmacy at Health Centre of IIT Tirupati - EoI Ref. No: IITT/ADMIN/2023-24/21",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTADMIN2023-2421_EOI.pdf",
          LinkName: "EoI Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "14-11-2023 @ 17:00 hrs",
      EndDate: "26-12-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Field Emission Scanning Electron Microscope to IIT Tirupati - Tender No: IITT/CI/2023-24/18",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2418.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2418_Technical-evaluation_report.pdf",
          LinkName: "Technical Evaluation Report",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCI2023-2418Corr-V.pdf",
          LinkName: "Corrigendum-V",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2418_corri4.pdf",
          LinkName: "Corrigendum-IV",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/CORRIGENDUM%20%E2%80%93%20III.pdf",
          LinkName: "Corrigendum-III",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2418_corri2.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCI2023-2418Corr-I.pdf",
          LinkName: "Corrigendum-I",
        },

        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0&page=FrontEndAdvancedSearchResult&service=direct&session=T&sp=S5AkZuYvjH7ERl7X%2BhZCrQg%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "13-11-2023",
      EndDate: "16-01-2024 @ 15:00 Hrs",
    },

    {
      Title:
        "EOI for Providing Taxi Services to IIT Tirupati - BID No: IITTADMIN2023-2420_EOI.pdf",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTADMIN2023-2420Corr-I.pdf",
          LinkName: "Revised BoQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTADMIN2023-2420_EOI.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/IITT-ADMIN-2023-24-20-CancellationNotice.pdf",
          LinkName: "Tender Cancellation Notice",
        },
      ],
      OpenDate: "13-11-2023",
      EndDate: "18-12-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Dip Coating Unit with Hot Chamber-01 No. - 1. Ref No. CSRC/PR/CH/2023-24/84 | 2. CPPP Tender Ref No. IITT/CH/2023-24/84",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCH2023-2484.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "13-11-2023",
      EndDate: "04-12-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Mechanical Waveguide Calibration kit - BID No: GEM/2023/B/4047697",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2024/GEM2023B4047697_Tender_cancellation_notice.pdf",
          LinkName: "Tender cancelled due to administrative reasons",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4047697.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "06-11-2023",
      EndDate: "05-01-2024 @ 17:00 hrs",
    },
    {
      Title: "Supply of Water Purifier unit - BID No: GEM/2023/B/4135395",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4135395_Tender_cancellation_notice.pdf",
          LinkName: "Tender cancelled due to administrative reasons",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4135395.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "02-11-2023",
      EndDate: "09-01-2024 @ 09:00 hrs",
    },
    {
      Title:
        "Supply of Laboratory Furniture-II to IIT Tirupati - Tender No: IITT/EU/2023-24/17",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2417_Tender_Cancel.pdf",
          LinkName: "Tender Cancellation Notice",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2417.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2417Corri-III.pdf",
          LinkName: "Corrigendum-III",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2417Corr-II.pdf",
          LinkName: "Corrigendum-II",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2417Corr-I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SS8lcCyzZE2MwEaqphIkMkg%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "30-10-2023",
      EndDate: "05.12.2023 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of Computer Workstation (4 Nos.) - BID No: GEM/2023/B/4129226",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4129226.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "26-10-2023",
      EndDate: "Extended till 16.11.2023 @ 18:00 hrs",
    },
    {
      Title: "Supply of Computer Workstations - BID No: GEM/2023/B/4127843",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4127843.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "26-10-2023",
      EndDate: "Extended till 16.11.2023 @ 17:00 hrs",
    },

    {
      Title: "Supply of Computer Workstations - BID No: GEM/2023/B/4100757",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4100757.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4100757_Corrigendum-I.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      OpenDate: "26-10-2023",
      EndDate: "11-12-2023 @ 17:00 hrs",
    },
    {
      Title: "Supply of Computer Workstations - BID No: GEM/2023/B/4086892",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4086892.pdf",
          LinkName: "BID Document",
        },
      ],

      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4086892-C3_Corrigendum.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      OpenDate: "20-10-2023",
      EndDate: "17/11/2023 @ 16:00 hrs",
    },
    {
      Title:
        "Supply of Digital Storage Oscilloscope (01 No.) - BID No: GEM/2023/B/4059770",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4059770.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "14-10-2023",
      EndDate: "04-11-2023 @ 13:30 hrs",
    },
    {
      Title: "Supply of Muffle Furnace (01 No.) - BID No: GEM/2023/B/4015303",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4015303.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "6-10-2023",
      EndDate: "27-10-2023 @ 15:30 hrs",
    },
    {
      Title:
        "Supply of Refrigerated Micro - Centrifuge - BID No: GEM/2023/B/4045897",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4045897.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "12-10-2023",
      EndDate: "02-11-2023 @ 15:30 hrs",
    },
    {
      Title:
        "Supply of Thin Film Deposition System (01 No.) - BID No: GEM/2023/B/3986656",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3986656.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "12-10-2023",
      EndDate: "02-11-2023 @ 12:30 hrs",
    },
    {
      Title:
        "Supply of Computer Workstation (5 Nos.) - BID No: GEM/2023/B/4067465",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4067465.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "12-10-2023",
      EndDate: "26-10-2023 @ 15:30 hrs",
    },
    {
      Title: "Supply of Walkie Talkie - BID No: GEM/2023/B/4045823",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4045823.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "11-10-2023",
      EndDate: "01-11-2023 @ 18:30 hrs",
    },

    // final test
    {
      Title:
        "Supply of Computer Workstation (4 Nos.) - BID No: GEM/2023/B/4048316",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4048316.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4048316_Corrigendum_I.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      OpenDate: "09-10-2023",
      EndDate: "23-10-2023 @ 18:30 hrs",
    },
    {
      Title: "Supply of A4 paper (600 reams) - BID No: GEM/2023/B/4038098",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4038098.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "09-10-2023",
      EndDate: "19-10-2023 @ 17:30 hrs",
    },
    {
      Title: "Supply of Computer Workstations - BID No: GEM/2023/B/4044711",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4044711.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B4044711_Corrigendum_I.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      OpenDate: "09-10-2023",
      EndDate: "23-10-2023 @ 18:30 hrs",
    },
    {
      Title:
        "Supply of Variable Angle Laser Ellipsometer to IIT Tirupati - Tender No: IITT/PH/2023-24/16",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPH2023-2416.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
      ],
      OpenDate: "06-10-2023",
      EndDate: "28-10-2023 @ 09:00 AM",
    },
    {
      Title:
        "Electrical, Mechanical Operations and Maintenance Services at IIT Tirupati - Tender No: IITT/EU/EM/TENDER/2023-24/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEUEMTENDER2023-24001.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/BOQ_813818_IITTEUEMTENDER2023-24001.xls",
          LinkName: "BoQ",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEUEMTENDER2023-24001_Corrigendum-II.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEUEMTENDER2023-24001_Corrigendum_I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SEtdlwAsQ2nDXvEVgXLvVhg%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "4-10-2023",
      EndDate: "21-10-2023 @ 10:00 AM",
    },
    {
      Title:
        "Providing Transport Services to IIT Tirupati on Contract Basis - Tender No: IITT/ADMIN/2023-24/15",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTADMIN2023-2415.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/BoQ1_IITTADMIN2023-2415.pdf",
          LinkName: "BoQ",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SHJn%2F1bYKt2K3RKzAyIShVA%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "26-08-2023",
      EndDate: "19-10-2023 @ 15:00 hrs",
    },

    {
      Title: "Supply of All In One - BID No: GEM/2023/B/3931119",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3931119.pdf",
          LinkName: "BID Document",
        },
      ],

      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3931119_Corrigendum-I.pdf",
          LinkName: "Corrigendum-I",
        },
      ],

      OpenDate: "14-09-2023",
      EndDate: "25-09-2023 @ 17:30 hrs",
    },
    {
      Title: "Supply of Kisok - BID No: GEM/2023/B/3871175",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3871175.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "13-09-2023",
      EndDate: "16-10-2023 @ 09:00 hrs",
    },
    {
      Title: "Supply of Atomic Force Microscope - BID No: GEM/2023/B/3870778",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3870778.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "",
          LinkName:
            "Prebid In Hybrid Mode:Offline Meeting Venue: Civil / Mechanical HOD Meeting room at 10: 30AM, DB1, IIT TIRUPATI.",
        },

        {
          Link: "https://meet.google.com/isu-yyfz-fqr",
          LinkName: "Online Zoom Mettings",
        },
      ],
      OpenDate: "31-08-2023",
      EndDate: "21-09-2023 @ 16:30 hrs",
    },
    {
      Title: "Supply of Desktop Computers - BID No: GEM/2023/B/3799875",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3799875.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "30-08-2023",
      EndDate: "12-10-2023 @ 18:30 hrs",
    },
    {
      Title:
        "Supply of Data Acquisition System-01 No. - BID No: GEM/2023/B/3870177",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3870177.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "25-08-2023",
      EndDate: "15-09-2023 @ 17:30 hrs",
    },
    {
      Title: "Supply of Computer Workstation - BID No: GEM/2023/B/3794842",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3794842.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "23-08-2023",
      EndDate: "13-09-2023 @ 15:30 hrs",
    },
    {
      Title: "Supply of Computer Workstation - BID No: GEM/2023/B/3802991",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3802991.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "23-08-2023",
      EndDate: "13-09-2023 @ 13:30 hrs",
    },

    {
      Title:
        "Supply of Laboratory Furniture-II to IIT Tirupati - Tender No: IITT/EU/2023-24/14",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2414.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2414_TCN.pdf",
          LinkName: "Tender Cancellation Notice",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2414Corr-IV.pdf",
          LinkName: "Corrigendum-IV",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2414Corr-III.pdf",
          LinkName: "Corrigendum-III",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2414_Corrigendum-II.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2414_Corrigendum-I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=S5DN3cNebVRKiRIxcPmoScg%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "22-08-2023",
      EndDate: "03-10-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Computer Workstation-01 No - BID No: GEM/2023/B/3810778",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3810778.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "14-08-2023",
      EndDate: "04-09-2023 @ 17:00 hrs",
    },
    {
      Title:
        "Supply of Computer Workstation-01 No - BID No: GEM/2023/B/3794257",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3794257.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "14-08-2023",
      EndDate: "04-09-2023 @ 17:00 hrs",
    },
    {
      Title: "Supply of Computer Workstation - BID No: GEM/2023/B/3801886",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3801886.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "11-08-2023",
      EndDate: "30-08-2023 @ 16:30 hrs",
    },

    {
      Title: "Supply of Computer System - BID No: GEM/2023/B/3797460",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3797460.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "11-08-2023",
      EndDate: "01-09-2023 @ 12:30 hrs",
    },
    {
      Title:
        "Supply of High Shear Planetary Mortar Mixer to IIT Tirupati - Tender No: IITT/CE/2023-24/13",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCE2023-2413.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SVfxbNsShK6aGHMsO0zpfZg%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "09-08-2023",
      EndDate: "23-08-2023 @ 15:00 hrs",
    },

    {
      Title:
        "Supply, Installation, Testing and commissioning of Integrated Multi Measuring Unit with All Accessories - Tender No: IITT/EE/2022-23/252",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITT_EE_2022-23_252.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "04-08-2023",
      EndDate: "25-08-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Two Channel 400 MHz NMR Spectrometer with accessories - Tender No: IITT/CY/2023-24/12",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCY2023-24_12.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink/page=FrontEndViewTender/service=direct/session=T/sp=STIkjWuhBwiFc1iAgr0HMQQ%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "02-08-2023",
      EndDate: "30-08-2023 @ 15:00 hrs",
    },
    {
      Title: "Supply of Computer Workstation - BID No: GEM/2023/B/3743930",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3743930.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "28-07-2023",
      EndDate: "17-08-2023 @ 10:00 am",
    },

    {
      Title: "Supply of RAM - BID No: GEM/2023/B/3732333",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3732333.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "28-07-2023",
      EndDate: "16-08-2023 @ 09:00 hrs",
    },
    {
      Title: "Supply of Sofa / Tea Table - BID No: GEM/2023/B/3623138",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3623138.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "27-07-2023",
      EndDate: "14-08-2023 @ 16:30 hrs",
    },
    {
      Title:
        "Supply of Upright Metallurgical Microscope with Fluorescence. - BID No: GEM/2023/B/3737380",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3737380.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "27-07-2023",
      EndDate: "17-08-2023 @ 13:30 hrs",
    },
    {
      Title:
        "Supply of Solvent Purification System. - BID No: GEM/2023/B/3740383",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3740383.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GeM-Bidding-Corr-5084408-1.pdf",
          LinkName: "Corrigendum-1",
        },
      ],
      OpenDate: "27-07-2023",
      EndDate: "17-08-2023 @ 10:30 hrs",
    },

    {
      Title:
        "Supply of visitor's hostel furniture to IIT Tirupati - Tender No: IITT/EU/2023-24/11",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2411_Stage I Evaluation Report.pdf",
          LinkName: "Stage-I Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2411.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SP5QY68FTGyysuFAEfqJSdA%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "19-07-2023",
      EndDate: "09-08-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Binocular Inverted Fluorescence Microscope with Scientific Digital Camera-01 No. - BID No: GEM/2023/B/3698443",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3698443.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "19-07-2023",
      EndDate: "9-08-2023 @ 16:30 hrs",
    },
    {
      Title:
        "Supply, Installation, Testing and commissioning of DC power supply - Tender No: IITT/EU/2023-24/10",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2410.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SC%2BECNLHhZ7v6N1F2XUFxbg%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "18-07-2023",
      EndDate: "08-08-2023 @ 15:00 hrs",
    },

    {
      Title: "Supply of Soldering Station - BID No: GEM/2023/B/3685804",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3685804.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "18-07-2023",
      EndDate: "8-08-2023 @ 15:00 hrs",
    },
    {
      Title: "Supply of Computer Workstation - BID No: GEM/2023/B/3603616",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3603616.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "14-07-2023",
      EndDate: "25-07-2023 @ 16:30 hrs",
    },
    {
      Title:
        "Supply, Installation, Testing and commissioning of Isothermal Calorimetry - Tender No: IITT/CE/2023-24/09",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCE2023-2409.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SD3GwGlJh7mzM7zCFvwLRjg%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "10-07-2023",
      EndDate: "07-08-2023 @ 15:00 hrs",
    },
    {
      Title: "Supply of Round Table - BID No: GEM/2023/B/3622876",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3622876.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "06-07-2023",
      EndDate: "24-07-2023 @ 16:00 hrs",
    },

    {
      Title: "Supply of Desktop Computers - BID No: GEM/2023/B/3601868",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3601868.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "04-07-2023",
      EndDate: "15-07-2023 @ 13:00 hrs",
    },

    {
      Title:
        "Providing Facility Management Services for the Guest Houses of IIT Tirupati - Tender No: IITT/ADMIN/2023-24/08",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTADMIN2023-2408.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTADMIN2023-2408_Technical-evaluation_report.pdf",
          LinkName: "Technical Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTADMIN2023-2408_Corrigendum-1.pdf",
          LinkName: "Corrigendum-1",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTADMIN2023-2408_Corrigendum_2.pdf",
          LinkName: "Corrigendum-2",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTADMIN2023-2408_Pre_bid_meeting_Minutes.pdf",
          LinkName: "Pre Bid Meeting Minutes",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SdSgugwV1%2FScpTcRyHvnlXQ%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "03-07-2023",
      EndDate: "24-07-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply, Installation, Testing and commissioning of Chemistry laboratory Furniture - Tender No: IITT/EU/2023-24/07",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2407.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2407_Stage-II.pdf",
          LinkName: "Stage-II Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2407_stage-1_evaluation_report.pdf",
          LinkName: "Stage-I Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2407_Corrigendum-I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2407_Corrigendum-II.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2407_Corrigendum-III.pdf",
          LinkName: "Corrigendum-III",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2407_Corrigendum-IV.pdf",
          LinkName: "Corrigendum-IV",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2407_Corrigendum-V.pdf",
          LinkName: "Corrigendum-V",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SOMAEE2wTy9cPYkjGt0UbbQ%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "26-06-2023",
      EndDate: "10-08-2023 @ 15:00 hrs",
    },
    {
      Title: "Purchase of Key holding cabinet - BID No: GEM/2023/B/3424365",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3424365.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "19-06-2023",
      EndDate: "30-06-2023 @ 13:00 hrs",
    },
    {
      Title:
        "Supply, Installation, Testing and commissioning of Furniture - Tender No: IITT/EU/2023-24/06",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2406.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2406_Stage-2_evaluation_report.pdf",
          LinkName: "Stage 2 Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2406-Stage-1_evaluation_Visitor Hostel.pdf",
          LinkName: "Stage 1 Evaluation Report",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=S4i4Wplmt5GUizjcX3Y5ZkA%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "16-06-2023",
      EndDate: "10-07-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply, Installation, Testing and commissioning of Fixed Furniture - Tender No: IITT/EU/2023-24/5",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2405.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2405_Corrigendum-1.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2405_stage-1_evaluation-report_2.pdf",
          LinkName: "Stage-I Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2405_Stage-II_Evaluation.pdf",
          LinkName: "Stage-II Evaluation Report",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SZIywVnRHp%2F%2BZgrWdE4DE2A%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "14-06-2023",
      EndDate: "05-07-2023 @ 15:00 hrs",
    },

    {
      Title:
        "Supply of Computer Workstation-04 Nos. - BID No: GEM/2023/B/3549654",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3549654.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "13-06-2023",
      EndDate: "04-07-2023 @ 18:30 hrs",
    },
    {
      Title:
        "Supply, Installation, Testing, and Commissioning of Two Channel 400 MHZ NMR Spectrometer with Accessories - Tender No: IITT/CY/2023-24/04",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCY2023-2404.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SIzP0VLhJ7jAwxRfNwzGbQw%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "12-06-2023",
      EndDate: "03-07-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Effluent Treatment Plant 30KLD Capacity - Tender No: IITT/CSRC/CHEM/2021-22/177-1",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCSRCCHEM2021-22177-1.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "12-06-2023",
      EndDate: "03-07-2023 @ 13:00 hrs",
    },

    {
      Title: "Supply of Centrifuge - BID No: GEM/2023/B/3521512",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3521512.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "12-06-2023",
      EndDate: "23-06-2023 @ 15:30 hrs",
    },
    {
      Title:
        "Supply of Computer Workstation - 01 no. - BID No: GEM/2023/B/3548070",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3548070.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "09-06-2023",
      EndDate: "30-06-2023 @ 17:30 hrs",
    },
    {
      Title:
        "Supply of Computer Workstation - 01 no. - BID No: GEM/2023/B/3548687",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3548687.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "09-06-2023",
      EndDate: "30-06-2023 @ 17:30 hrs",
    },
    {
      Title:
        "Supply, Installation, Testing and Commissioning of Office Furniture - Tender No: IITT/EU/2023-24/04",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2404.pdf",
          LinkName: "Tender Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2404_Stage-II_Evaluation_Report.pdf",
          LinkName: "Stage-II Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2404_Stage-1_Evaluation_report.pdf",
          LinkName: "Stage-I Evaluation Report",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SOaQ%2B4oyPufKh%2FVEqyWOU0w%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "08-06-2023",
      EndDate: "29-06-2023 @ 15:00 hrs",
    },

    {
      Title: "Supply of All in One PC - BID No: GEM/2023/B/3527021",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3527021.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "03-06-2023",
      EndDate: "14-06-2023 @ 21:00 hrs",
    },
    {
      Title:
        "Supply of Crystallization Process Unit - BID No: GEM/2023/B/3447199",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3447199.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "01-06-2023",
      EndDate: "03-07-2023 @ 21:00 hrs",
    },
    {
      Title:
        'NIQ documents for "Proposal for supply and Installation venetian (Zebra lines) for the windows of Admin Block, DB-01 / DB-02-HOD Offices, DB-01-1019, DB-01-1020 and Library Office at IIT Tirupati Permanent Campus" - NIQ No: IITT/PC/NIQ/03/2023-24',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ032023-24.pdf",
          LinkName: "NIQ Document",
        },
      ],
      OpenDate: "25.05.2023",
      EndDate: "01.06.2023 @ 15.00 hrs.",
    },
    {
      Title:
        'NIT documents for "Minor Civil / MEP Works at various locations in IIT Tirupati Campus" - NIT No: IITT/EU/EE(C)/2023-24/003',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEUEE(C)2023-24003.pdf",
          LinkName: "NIT Document",
        },
      ],
      OpenDate: "18.05.2023",
      EndDate: "01.06.2023 @ 15.00 hrs.",
    },
    {
      Title: "Supply of Server - BID No: GEM/2023/B/3449562",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3449562.pdf",
          LinkName: "BID Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3449562-Corrigendum_1.pdf",
          LinkName: "Corrigendum-1",
        },
      ],
      OpenDate: "23-05-2023",
      EndDate: "20-06-2023 @ 16:30 hrs",
    },
    {
      Title: "Supply of Continuous Rectification - BID No: GEM/2023/B/3427774",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3427774.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "19-05-2023",
      EndDate: "09-06-2023 @ 12:00 hrs",
    },
    {
      Title:
        "Setting up of Geotechnics Testing laboratory - BID No: GEM/2023/B/3456897",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3456897.pdf",
          LinkName: "BID Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3456897_Corrigendum-2.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3456897_Corrigendum-I.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      OpenDate: "19-05-2023",
      EndDate: "09-06-2023 @ 17:00 hrs",
    },

    {
      Title:
        "Supply of Ultrasonic Probe sonicator - BID No: GEM/2023/B/3408177",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3408177.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "17-05-2023",
      EndDate: "07-06-2023 @ 13:00 hrs",
    },
    {
      Title:
        "Supply of 400 MHz Nuclear Magnetic Resonance Spectrometer - BID No: GEM/2023/B/3413585",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3413585.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "16-05-2023",
      EndDate: "06-06-2023 @ 11:00 hrs",
    },
    {
      Title:
        "NIQ documents for 'Installation of Split Type / Cassette Type AC systems and necessary accessories at Hostel -G, Lab -2 (UPS room) and He / N2 Building' - NIQ No: IITT/PC/NIQ/02/2023-24",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ022023-24.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ022023-24_BoQ.pdf",
          LinkName: "BoQ Document",
        },
      ],
      OpenDate: "04.05.2023",
      EndDate: "18.05.2023 @ 15.00 hrs.",
    },
    {
      Title: "Supply of Desktop Computers - BID No: GEM/2023/B/3367520",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3367520.pdf",
          LinkName: "BID Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3367520_Corrigendun-1.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      OpenDate: "04-05-2023",
      EndDate: "01-06-2023 @ 17:00 hrs",
    },
    {
      Title: "Supply of Printer - BID No: GEM/2023/B/3394535",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3394535.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "03-05-2023",
      EndDate: "24-05-2023 @ 18:00 hrs",
    },
    {
      Title:
        "Tender for 'Comprehensive Civil AMC for Carpentry, Plumbing, External Development Works and Day-to-Day Maintenance Works in IIT Tirupati Campus' - NIT No: IITT/EU/EE(C)/2023-24/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEUEE(C)2023-24001_RE.pdf",
          LinkName: "Tender Document",
        },
      ],
      OpenDate: "03-05-2023",
      EndDate: "10-05-2023 @ 15:00 hrs",
    },
    {
      Title: "Supply of Through Flow Dryer - Tender No: IITT/CHEM/2023-24/03",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCHEM2023-2403.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SqI15VGbzlfWSIw5pGRI5hQ%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "03-05-2023",
      EndDate: "25-05-2023 @ 15:00 hrs",
    },

    {
      Title:
        "NIT documents for Catering Services (North Indian Mess) in IIT Tirupati, Yerpedu (M), Tirupati (Dt). - Tender No: IITT/HoME/153/23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTHoME15323.pdf",
          LinkName: "NIT Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/Eproce_IITTHoME15323.pdf",
          LinkName: "eProcurement Document",
        },
      ],
      OpenDate: "02.05.2023",
      EndDate: "24.05.2023 @ 15.00 hrs.",
    },
    {
      Title: "Supply, Installation, Testing and Commissioning of Lab Furniture",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2402.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2402_Stage-II_evaluation_report.pdf",
          LinkName: "Stage-1I Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEU2023-2402_Stage1-evalution lab furniture.pdf",
          LinkName: "Stage-1 Evaluation Report",
        },

        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SvUHHW1o8szDxMviDJRj0Sg%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "01-05-2023",
      EndDate: "25-05-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Comprehensive AMC for Playground and Sports Fields Maintenance Works in IIT Tirupati, Yerpedu (M), Tirupati (Dt).",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEUEE(C)2023-24002.pdf",
          LinkName: "NIT Document",
        },
      ],
      OpenDate: "27.04.2023",
      EndDate: "18.05.2023 @ 15.00 hrs.",
    },
    {
      Title: "Supply of Desktop Computer",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3388321.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "26-04-2023",
      EndDate: "08-05-2023 @ 15:30 hrs",
    },
    {
      Title: "Supply of Manual Ceramic Green Up and Down Board",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3367481.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "26-04-2023",
      EndDate: "17-05-2023 @ 16:30 hrs",
    },
    {
      Title: "Supply of Computer workstation",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3368128.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "26-04-2023",
      EndDate: "17-05-2023 @ 16:30 hrs",
    },
    {
      Title:
        "Supply of Boiler, Piping and Lining - Tender No: IITT/CSRC/CHEM/2021-22/177-3",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCSRCCHEM2021-22177-3.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "26-04-2023",
      EndDate: "17-05-2023 @ 13:00 hrs",
    },
    {
      Title:
        "Supply of Installation, Testing and Commissioning of Immersion Cooler - Tender No: IITT/CSRC/CY/2022-23/249",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCSRCCY2022-23249.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "21-04-2023",
      EndDate: "15-05-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Refrigerators, Freezer, Water Coolers and Water Heaters - BID No: GEM/2023/B/3336116",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3336116.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "20-04-2023",
      EndDate: "11-05-2023",
    },
    {
      Title:
        "Supply of Commercial Cpvc Pipe-IS 15778 (Q3) , Commercial CPVC Pipe Fittings - BID No: GEM/2023/B/3332186",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3332186.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "19-04-2023",
      EndDate: "01-05-2023 @ 18:30:00 hrs",
    },
    {
      Title:
        "Supply of Supply, Installation, Testing, and Commissioning of Immersion Cooler - Tender No: IITT/CY/2022-23/247",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCY2022-23247.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=S25jt%2FFQ7BxjpgOhqCcd2Kw%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "18-04-2023",
      EndDate: "09-05-2023 @ 15:00 hrs",
    },
    {
      Title: "Supply of DC Power Supply - Tender No: IITT/ELE/2023-24/01",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTELE2023-2401.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SI1rJzFbKahquI2wkVxPV2g%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "19-04-2023",
      EndDate: "10-05-2023 @ 15:00 hrs",
    },
    {
      Title: "Supply of Computer Workstation - BID No: GEM/2023/B/3335408",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3335408.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "18-04-2023",
      EndDate: "19-05-2023 @ 15:00 hrs",
    },

    {
      Title: "Supply of Programmable Power Supply - BID No: GEM/2023/B/3335522",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3335522.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "18-04-2023",
      EndDate: "09-05-2023",
    },
    {
      Title:
        "Supply of Zeta / Particle Size Analyser - BID No: GEM/2023/B/3344564",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3344564.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "17-04-2023",
      EndDate: "08-05-2023 @ 15:30 hrs",
    },
    {
      Title:
        'NIQ documents for "Cleaning of Overhead Water Tanks at all South Campus Buildings and Occupied Buildings of Permanent Campus, IIT Tirupati" - NIQ No: IITT/PC/NIQ/01/2023-24',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_01_IITTPCNIQ012023-24.pdf",
          LinkName: "NIQ-01 Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_01_Annexure I - IITTPCNIQ012023-24.pdf",
          LinkName: "1. NIQ-01_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_01_Annexure II - IITTPCNIQ012023-24.pdf",
          LinkName: "2. NIQ-01_Annexure II",
        },
      ],

      OpenDate: "15.04.2023",
      EndDate: "20.04.2023 @ 15.00 hrs.",
    },
    {
      Title: "Supply of Service Books - BID No: GEM/2023/B/3329995",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3329995.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "10-04-2023",
      EndDate: "21-04-2023 @ 15:30 hrs",
    },
    {
      Title:
        "Supply of Software Defined Radio USPR kit with FPGA - Tender No: IITT/CSRC/ELE/2022-23/244",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCSRCELE2022-23244.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "05-04-2023",
      EndDate: "26-04-2023 @ 13:00 hrs",
    },
    {
      Title:
        "Supply of Integrated Multi Measuring Instrument - BID No: GEM/2023/B/3315392",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3315392.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "05-04-2023",
      EndDate: "19-04-2023 @ 13:30 hrs",
    },
    {
      Title: "Supply of Random Access Memory - BID No: GEM/2023/B/3316223",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3316223.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "03-04-2023",
      EndDate: "14-04-2023 @ 17:30 hrs",
    },

    {
      Title: "Supply of Through Flow Dryer - Tender No: IITT/CHEM/2022-23/167",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCHEM2022-23167_TCN.pdf",
          LinkName: "Tender Cancellation Notice",
          glow: true,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCHEM2022-23167.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SwJGvvzQR%2BWnzJuKzqa3tRg%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "03-04-2023",
      EndDate: "24-04-2023 @ 15:00 hrs",
    },
    {
      Title:
        "Supply of Research Syringe Pump-02 Nos. - BID No: GEM/2023/B/3309436",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3309436.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "31-03-2023",
      EndDate: "11-04-2023 @ 17:30 hrs",
    },
    {
      Title:
        "Supply of SiC MOSFET Three Phase Inverter and SiC H Bridge Inverter - Tender No: IITT/ELE/2022-23/278",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTELE2022-23278.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SaFXNUYlRQWi9qnb39FPfpw%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "25-03-2023",
      EndDate: "17-04-2023 @ 15:00 hrs",
    },

    {
      Title: "Supply of Overhead Stirrer - Gem Bid No: GEM/2023/B/3280468",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3280468.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "24-03-2023",
      EndDate: "04-04-2023 @ 13:30 hrs",
    },
    {
      Title: "Supply of CO2 Incubator (HPC) - Gem Bid No: GEM/2023/B/3301352",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3301352.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "24-03-2023",
      EndDate: "04-04-2023 @ 16:30 hrs",
    },
    {
      Title:
        "NIT documents for 'Supply / installation of Venetian Blinds (Zebra Blinds) for windows at various locations in Department Block-01 and Department Block-02 at IIT Tirupati Permanent Campus' - NIT No: IITT/EU/EE(C)/2022-23/005",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTEUEE(C)2022-23005.pdf",
          LinkName: "NIT Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "20.03.2023",
      EndDate: "03.04.2023 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of H Bridge Inverter and H Bridge Rectifier - Tender No: IITT/ELE/2022-23/277",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTELE2022-23277.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink_0/page=FrontEndAdvancedSearchResult/service=direct/session=T/sp=SUv1AZafSb%2F0IyYgbTP5u%2Fg%3D%3D",
          LinkName: "Link-2",
        },
      ],
      OpenDate: "24-03-2023",
      EndDate: "13-04-2023 @ 15:00 hrs",
    },
    {
      Title: "Supply of Boom Lift - Gem Bid No: GEM/2023/B/3272635",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3272635.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "23-03-2023",
      EndDate: "13-04-2023 @ 17:00 hrs",
    },
    {
      Title:
        "Notice Inviting Tender for Catering Services at IIT Tirupati Permanent Campus, Yerpedu. - Tender No: IITT/HoME/136/23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTHoME13623.pdf",
          LinkName: "Tender Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/MRC_IITTHoME13623.pdf",
          LinkName: "Minimum Reasonable Cost (7/6/2023)",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTHoME13623_Corrigendum-I.pdf",
          LinkName: "Corrigendum-I (6/4/2023)",
        },
      ],

      OpenDate: "21-03-2023",
      EndDate: "11-04-2023 @ 5:00 PM",
    },
    {
      Title:
        "Expression of Interest for Food Court in IIT Tirupati Permanent Campus, Yerpedu. - EoI No: IITTP/HoME/137/2023",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPHoME1372023.pdf",
          LinkName: "EoI Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "21-03-2023",
      EndDate: "10-04-2023 @ 5:00 PM",
    },
    {
      Title:
        "Expression of Interest for Stationery cum General Store in IIT Tirupati Permanent Campus, Yerpedu. - EoI No: IIT Tirupati/HoME/101/2023",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IIT TirupatiHoME1012023.pdf",
          LinkName: "EoI Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "17-03-2023",
      EndDate: "06-04-2023 @ 5:00 PM",
    },
    {
      Title: "Supply of Cloth Dryer Stand - Gem Bid No: GEM/2023/B/3261694",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3261694.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "17-03-2023",
      EndDate: "27-03-2023 @ 2:00 PM",
    },
    {
      Title:
        "Supply of Networking/Server Rack - Gem Bid No: GEM/2023/B/3259809",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3259809.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "17-03-2023",
      EndDate: "27-03-2023 @ 5:00 PM",
    },
    {
      Title:
        "Supply of Preparative High Performance Liquid Chromatography - Gem Bid No: GEM/2023/B/3275453",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3275453.pdf",
          LinkName: "BID Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/Corrigendum-2_GEM2023B3275453.pdf",
          LinkName: "Corrigendum-II (17/04/2023)",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/Corrigedum-I_GEM2023B3275453.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "16-03-2023",
      EndDate: "24-04-2023 @ 15:00:00 hrs",
    },

    {
      Title:
        "Supply of Electrochemical Workstation - Gem Bid No: GEM/2023/B/3192322",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3192322.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "15-03-2023",
      EndDate: "31-03-2023 @ 13:30 hrs.",
    },
    {
      Title:
        "Supply of Software defined Radio Device - Gem Bid No: IITT/CSRC/ELE/2022-23/227",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCSRCELE2022-23227.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "14-03-2023",
      EndDate: "04-04-2023 @ 13:00 hrs.",
    },
    {
      Title:
        "Supply of Free Field Microphones - Gem Bid No: IITT/CSRC/ME/2022-23/182",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTCSRCME2022-23182.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "14-03-2023",
      EndDate: "04-04-2023 @ 13:00 hrs.",
    },
    {
      Title:
        "Supply of Multi Product Calibrator - Gem Bid No: GEM/2023/B/3202429",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3202429.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "07-03-2023",
      EndDate: "28-03-2023 @ 09:00 pm.",
    },
    {
      Title:
        "NIQ documents for 'Construction of Gas Bank Shed for Mechanical Laboratory in Department Block-01 at IIT Tirupati Permanent Campus' - NIQ No: IITT/PC/NIQ/60/2022-23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_60_IITTPCNIQ602022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_60_Annexure I -IITTPCNIQ602022-23.pdf",
          LinkName: "1. NIQ-60_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_60_Annexure II -IITTPCNIQ602022-23.pdf",
          LinkName: "2. NIQ-60_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_60_Drawing_IITTPCNIQ602022-23.pdf",
          LinkName: "3. NIQ-60_Drawing",
        },
      ],

      OpenDate: "10.03.2023",
      EndDate: "16.03.2023 @ 15.00 hrs.",
    },
    {
      Title:
        "NIQ documents for 'Site development works for setting up of Pre-fab Containers and Children's Park near the Residential Zone at IIT Tirupati Permanent Campus' - NIQ No: IITT/PC/NIQ/59/2022-23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_59_IITTPCNIQ592022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],

      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_59_Annexure I - IITTPCNIQ592022-23.pdf",
          LinkName: "1. NIQ-59_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_59_Annexure II - IITTPCNIQ592022-23.pdf",
          LinkName: "2. NIQ-59_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_59_Drawing_IITTPCNIQ592022-23.pdf",
          LinkName: "3. NIQ-59_Drawing",
        },
      ],

      OpenDate: "06.03.2023",
      EndDate: "13.03.2023 @ 15.00 hrs.",
    },
    {
      Title: "Supply of Desktop Computers - Gem Bid No: GEM/2023/B/3175221",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3175221.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "03-03-2023",
      EndDate: "16-03-2023 @ 01:00 pm.",
    },

    {
      Title: "Supply of Racks - Gem Bid No: GEM/2023/B/3184378",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3184378.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "03-03-2023",
      EndDate: "13-03-2023 @ 05:00 pm.",
    },
    {
      Title:
        "NIQ documents for 'Construction of Culinary room facilities for four (4) student rooms in Hostel-01 at IIT Tirupati Permanent Campus' - NIQ No: IITT/PC/NIQ/58/2022-23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_58_IITTPCNIQ582022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_58_Annexure I - IITTPCNIQ582022-23.pdf",
          LinkName: "1. NIQ-58_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_58_Annexure II - IITTPCNIQ582022-23.pdf",
          LinkName: "2. NIQ-58_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_58_Culinary Room Details-IITTPCNIQ582022-23.pdf",
          LinkName: "3. NIQ-58_Drawing",
        },
      ],

      OpenDate: "02.03.2023",
      EndDate: "14.03.2023 @ 15.00 hrs.",
    },
    {
      Title:
        "NIQ documents for 'Supply and Installation of Children's Play Equipment / Open Gym Equipment near Residential Quarters at IIT Tirupati Permanent Campus' - NIQ No: IITT/PC/NIQ/57/2022-23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_57_IITTPCNIQ572022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_57_IITTPCNIQ572022-23_Annexure I.pdf",
          LinkName: "1. NIQ-57_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_57_IITTPCNIQ572022-23_Annexure II.pdf",
          LinkName: "2. NIQ-57_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_57_IITTPCNIQ572022-23_Drawing.pdf",
          LinkName: "3. NIQ-57_Drawing",
        },
      ],

      OpenDate: "24.02.2023",
      EndDate: "03.03.2023 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of Laptop / All in One PC - Gem Bid No: GEM/2022/B/3139779",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B3139779.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "21-02-2023",
      EndDate: "03-03-2023 @ 09:00:00 hrs.",
    },
    {
      Title:
        "NIQ documents for 'Supply and Installation of Pre-fabricated containers - 2 nos of size 20' (L) x 8' (W) x 8' (H) near Residential Quarters at IIT Tirupati Permanent Campus' - NIQ No: IITT/PC/NIQ/56/2022-23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_56_IITTPCNIQ562022-23.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_56_IITTPCNIQ562022-23_Annexure- I.pdf",
          LinkName: "1. NIQ-56_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIQ_56_IITTPCNIQ562022-23_Annexure -II.pdf",
          LinkName: "2. NIQ-56_Annexure II",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "21.02.2023",
      EndDate: "28.02.2023 @ 15.00 hrs.",
    },

    {
      Title: "Supply of Oscilloscope - Gem Bid No: GEM/2023/B/3101747",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3101747.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "20-02-2023",
      EndDate: "13-03-2023 @ 17:30:00 hrs.",
    },
    {
      Title:
        "Supply of High Performance Computing System (HPC) - Gem Bid No: GEM/2023/B/3071226",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3071226.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "15-02-2023",
      EndDate: "27-02-2023 @ 13:30:00 hrs.",
    },

    {
      Title:
        "Supply of Phasor Data Concentrator - Gem Bid No: GEM/2023/B/3100684",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3100684.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "15-02-2023",
      EndDate: "01-03-2023 @ 13:30:00 hrs.",
    },
    {
      Title:
        "Supply of High Performance Computing System (HPC) - Gem Bid No: GEM/2023/B/3099535",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B3099535.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "15-02-2023",
      EndDate: "01-03-2023 @ 13:30:00 hrs.",
    },
    {
      Title: "Supply of Tubular Furnace - Gem Bid No: GEM/2023/B/2961811",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GeM-Bidding-4315967_145203.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "03-02-2023",
      EndDate:
        "Bid Due Date/Time: 14-02-2023 11:00:00 Bid Opening Date/Time: 14-02-2023 11:30:00",
    },
    {
      Title: "Supply of Thermal Camera (Tender No: IITT/ELE/2022-23/43)",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/FinalTender_Thermal Camera.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link 1",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink/page=FrontEndViewTender/service=direct/session=T/sp=S4%2F5G0qCzASlML3BY8fVBfw%3D%3D",
          LinkName: "Link 2",
        },
      ],
      OpenDate: "02.02.2023",
      EndDate: "23.02.2023 @15.00 hrs.",
    },
    {
      Title:
        "Supply of 50KN ElectroMechanical Universal Testing Machine - Gem Bid No: GEM/2023/B/2961811",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B2961811.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "01.02.2023",
      EndDate: "01.03.2023",
    },
    {
      Title:
        "Supply of Thermogravimetric analyser with differential scannning calorimetry - Gem Bid No: GEM/2022/B/3026439",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B3026439.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "23.01.2023",
      EndDate: "20.02.2023",
    },
    {
      Title:
        "NIQ documents for 'Construction of Badminton Courts - 4 nos and Calisthenics Park in Hostel 1 / 2 at IIT Tirupati Permanent Campus' - NIQ No: IITT/PC/NIQ/55/2022-23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ552022-23_NIQ_55.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ552022-23_NIQ_55_Annexure I.pdf",
          LinkName: "1. NIQ-55_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ552022-23_NIQ_55_Annexure II.pdf",
          LinkName: "2. NIQ-55_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ552022-23_NIQ_55_Drawings.pdf",
          LinkName: "3. NIQ_55_Drawing",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "20.01.2023",
      EndDate: "01.02.2023 @ 15.00 hrs.",
    },

    {
      Title:
        'NIQ documents for "Construction of raised platforms for CSE / CC labs in Department Block-2 at IIT Tirupati Permanent Campus" - NIQ No: IITT/PC/NIQ/54/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ542022-23_NIQ_54.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ542022-23_NIQ_54_Annexure I.pdf",
          LinkName: "1. NIQ-54_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ542022-23_NIQ_54_Annexure II.pdf",
          LinkName: "2. NIQ-54_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ542022-23_NIQ_54_Drawings.pdf",
          LinkName: "3. NIQ_54_Drawing",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "18.01.2023",
      EndDate: "30.01.2023 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of High Resolution Mass Spectrometry - Gem Bid No: GEM/2023/B/2983497",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B2983497.pdf",
          LinkName: "BLINK 1LINK 1ID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "13.01.2023",
      EndDate:
        "Bid Due Date / Time: 03.02.2023 @ 16:00 hrs Bid Opening Date / Time : 03.02.2023 @ 16:30 Hrs",
    },
    {
      Title:
        'NIQ documents for "Providing / fixing Laboratory Sink with necessary sanitary fittings at Department Block-1 / Department Block-2 in IIT Tirupati Permanent Campus" - NIQ No: IITT/PC/NIQ/53/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ532022-23-NIQ_53.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ532022-23-NIQ_53_Annexure I.pdf",
          LinkName: "1. NIQ-53_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ532022-23-NIQ_53_Annexure II.pdf",
          LinkName: "2. NIQ-53_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ532022-23-NIQ_53_Drawing.pdf",
          LinkName: "3. NIQ_53_Drawing",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "12.01.2023",
      EndDate: "25.01.2023 @ 15.00 hrs.",
    },
    {
      Title:
        'NIQ documents for "Providing FLood Lighting for Playground at South Campus, IIT Tirupati" - NIQ No: IITT/PC/NIQ/52/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ522022-23.pdf",
          LinkName: "NIQ Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ522022-23_Annexure -1.pdf",
          LinkName: "1. NIQ-52_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ522022-23_Annexure -2.pdf",
          LinkName: "2. NIQ-52_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/IITTPCNIQ522022-23_Drawing.pdf",
          LinkName: "3. NIQ_52_Drawing",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "12.01.2023",
      EndDate: "19.01.2023 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of Kitchen Equipment (storage racks) - Gem Bid No: GEM/2023/B/2974758",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B2974758.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "11.01.2023",
      EndDate:
        "Bid Due Date / Time: 01.02.2023 @ 17:00 hrs Bid Opening Date / Time : 01.02.2023 @ 17:30 Hrs",
    },
    {
      Title:
        "Supply of Toxicity Characteristic Leaching Potential Requirement - Gem Bid No: GEM/2023/B/2963395",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B2963395.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "11.01.2023",
      EndDate:
        "Bid Due Date / Time: 30.01.2023 @ 15:00 hrs Bid Opening Date / Time : 30.01.2023 @ 15:30 Hrs",
    },
    {
      Title:
        "Supply of Kitchen Equipment and accessories - Gem Bid No: GEM/2023/B/2969981",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B2969981.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "10.01.2023",
      EndDate: "31-01-2023",
    },

    {
      Title: "Supply of Television TV - Gem Bid No: GEM/2022/B/2946775",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B2946775.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "10.01.2023",
      EndDate: "21-01-2023 @ 15:30 hrs.",
    },
    {
      Title:
        "Supply of Network Attached Storage - Gem Bid No: GEM/2022/B/2933839",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B2933839.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "10.01.2023",
      EndDate: "21-01-2023 @ 17:30 hrs.",
    },
    {
      Title: "Supply of Oculus Rift - Gem Bid No: GEM/2022/B/2933423",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B2933423.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "10.01.2023",
      EndDate: "21-01-2023 @ 17:30 hrs.",
    },
    {
      Title:
        "Supply of Computer Workstation with 2 x Intel(R) Xeon(R) Gold 6230R - Gem Bid No: GEM/2023/B/2946646",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B2946646.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "09.01.2023",
      EndDate:
        "Bid Due Date / Time: 27.01.2023 @ 10:00 hrs Bid Opening Date / Time : 27.01.2023 @ 10:30 Hrs",
    },
    {
      Title:
        "Supply of Computer Workstation with Intel Xeon Silver 4214R processor - Gem Bid No: GEM/2023/B/2944302",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2023B2944302.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "09.01.2023",
      EndDate:
        "Bid Due Date / Time: 25.01.2023 @ 16:00 hrs Bid Opening Date / Time : 25.01.2023 @ 16:30 Hrs",
    },
    {
      Title:
        "Supply of Programmable DC Power Supply - Gem Bid No: GEM/2022/B/2937068",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B2937068.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "06.01.2023",
      EndDate: "24-01-2023 @ 12:00 hrs.",
    },
    {
      Title:
        "Supply of Dry Electro Finishing Machine (Chemically Activated Polymer Particle/Bead Based) - Gem Bid No: IITT/MECH/2022-23/42",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/Final Tender Global-IITTMECH2022-2342.pdf",
          LinkName: "1. Final Tender Global",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/NIT-IITTMECH2022-2342.pdf",
          LinkName: "2. NIT Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "05.01.2023",
      EndDate: "26.01.2023 @ 15.00 Hrs.",
    },

    {
      Title:
        "Supply of Rack Mounted server and workstation along with rack - Gem Bid No: GEM/2022/B/2888735",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B2888735.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "02.01.2023",
      EndDate: "18.01.2023 @ 17:00 Hrs",
    },
    {
      Title:
        "Supply of Far Field Automated Antenna Measurement System and Full Anechoic Chamber - Gem Bid No: GEM/2022/B/2935363",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B2935363.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "02.01.2023",
      EndDate: "23.01.2023",
    },
    {
      Title: "Supply of Laptop NoteBook - Gem Bid No: GEM/2022/B/2868521",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2868521.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "30.12.2022",
      EndDate: "09.01.2023 @ 17:30 hrs",
    },
    {
      Title: "Supply of Workstation - Gem Bid No: GEM/2022/B/2907687",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2907687.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "30.12.2022",
      EndDate: "17.01.2023 @ 13:30 hrs",
    },
    {
      Title: "Supply of Gas Chromatography - Gem Bid No: GEM/2022/B/2830519",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2830519.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "27.12.2022",
      EndDate: "17.01.2023 @ 16:30 hrs",
    },
    {
      Title: "Supply of Computer Node - Gem Bid No: GEM/2022/B/2875671",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2875671.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "27.12.2022",
      EndDate: "11.01.2023 @ 15:30 hrs",
    },
    {
      Title:
        "Supply of High Resolution Mass Spectrometry - Gem Bid No: GEM/2022/B/2905734",
      Documents: [
        {
          Link: "#",
          LinkName: "Due to administrative issues, the BID has been canceled.",
        },
      ],
      OpenDate: "26.12.2022",
      EndDate:
        "Bid Due Date / Time : 16.01.2023 @ 13:00 hrs Bid Opening Date / Time : 16-01-2023 13:30 hrs",
    },

    {
      Title:
        'NIQ documents of "Design, fabrication, assembling and fixing of Powder coated Aluminium Partitions with laminated particleboard and other civil works in Control / Automation Lab (Lab-2) at IIT Tirupati Transit Campus" - NIQ No: IITT/PC/NIQ/51/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTPCNIQ512022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTPCNIQ512022-23_Annexure I - Price Bid.pdf",
          LinkName: "1. NIQ-51_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTPCNIQ512022-23_Annexure II - Schedule of Quantities.pdf",
          LinkName: "2. NIQ-51_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTPCNIQ512022-23_Drawings.pdf",
          LinkName: "3. NIQ_51_Drawing",
        },
      ],
      OpenDate: "21.12.2022",
      EndDate: "28.12.2022 @ 15:00 hrs.",
    },
    {
      Title:
        "Supply of IoT based Temperature Control Unit - Gem Bid No: GEM/2022/B/2880487",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2880487.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "20.12.2022",
      EndDate: "23.01.2023 @ 15:00 hrs (Date Extended)",
    },
    {
      Title:
        "Supply of Dry Electro Finishing Equipment - Gem Bid No: GEM/2022/B/2848996",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2848996.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "19.12.2022",
      EndDate:
        "Bid Due Date / Time : 03-01-2023 @ 13:00 Hrs Bid Opening Date / Time : 03-01-2023 @ 13:30 Hrs",
    },
    {
      Title:
        "Supply of Ground Penetrating Radar - Gem Bid No: GEM/2022/B/2830256",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2830256.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "19.12.2022",
      EndDate:
        "Bid Due Date / Time: 09-01-2023 @ 15:00 hrs Bid Opening Date / Time : 09-01-2023 @ 15:30 Hrs",
    },
    {
      Title:
        "Supply of Analytical Semi - Micro Balances - Gem Bid No: GEM/2022/B/2849345",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2849345.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "19.12.2022",
      EndDate:
        "Bid Due Date / Time: 30.12.2022 @ 14:00 hrs Bid Opening Date / Time : 30.12.2022 @ 14:30 Hrs",
    },
    {
      Title:
        'NIQ documents of "Providing Architectural Consultancy Services for the work of Construction of National Facility for Accelerated Testing of Pavements and Vehicle Dynamics (NATPaVeD) and Heavy Structural Engineering Lab at IIT Tirupati Campus" - NIQ No: IITT/PC/NIQ/50/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_50_IITTPCNIQ502022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_50_IITTPCNIQ502022-23_Corrigendum-I.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_50_Annexure III - Price Bid.pdf",
          LinkName: "1. NIQ-50_Annexure III",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_50_Drg1_IITT_Part Master Plan.pdf",
          LinkName: "2. NIQ_50_Drg1_IITT_Part Master Plan",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_50_Drg2_NATPaVeD Plan 15Dec22.pdf",
          LinkName: "3. NIQ_50_Drg2_NATPaVeD Plan 15Dec22",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_50_Drg3_Structural Lab Plan 15Dec22.pdf",
          LinkName: "4. NIQ_50_Drg3_Structural Lab Plan 15Dec22",
        },
      ],
      OpenDate: "15.12.2022",
      EndDate: "30.12.2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Hiring of Manpower for Security Services - Gem Bid No: GEM/2022/B/2856279",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2856279.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "15.12.2022",
      EndDate:
        "Pre Bid Meeting: 20.12.2022 @ 15:00 hrs at IIT Tirupati Due date : 26.12.2022 @ 15:30 Hrs",
    },

    {
      Title:
        "Supply of Biometric Devices, Portable RFID, Fingerprint access, Electromagnetic Locks, Tripod Turnstile and Software - Gem Bid No: GEM/2022/B/2846375",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2846375.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "15.12.2022",
      EndDate: "Due date: 26-12-2022 18:00:00 Open date: 26-12-2022 18:30:00",
    },
    {
      Title:
        "Supply of Digital Storage Oscilloscope - Gem Bid No: GEM/2022/B/2850090",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2850090.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "14.12.2022",
      EndDate: "03.01.2023",
    },
    {
      Title: "Supply of Laptop - Gem Bid No: GEM/2022/B/2829996",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2829996.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "14.12.2022",
      EndDate: "26.12.2022 @ 14:00 hrs.",
    },
    {
      Title: "Supply of Laptop - Gem Bid No: GEM/2022/B/2835529",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2835529.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "13.12.2022",
      EndDate: "24.12.2022 @ 15:00 hrs.",
    },
    {
      Title:
        "Supply of Metal and Polymer Forming Equipment - Gem Bid No: GEM/2022/B/2848919",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2848919.pdf",
          LinkName: "BID Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2848919_Corrigendum-I.pdf",
          LinkName: "Corrigendum-I (03/01/2022)",
        },
      ],
      OpenDate: "13.12.2022",
      EndDate: "03.1.2023 @ 17:00 hrs.",
    },
    {
      Title:
        'NIQ documents of "Constructions of concrete pedestals for K-Lite Street Light Poles in the playground and near the new classroom and other miscellaneous works at IIT Tirupati Campus" - NIQ No: IITT/PC/NIQ/49/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_49_IITTPCNIQ492022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_49_Annexure I - Price Bid.pdf",
          LinkName: "1. NIQ-49_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_49_Annexure II - Schedule of Quantities.pdf",
          LinkName: "2. NIQ-49_Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_49_Drawings.pdf",
          LinkName: "3. NIQ_49_Drawings",
        },
      ],
      OpenDate: "12.12.2022",
      EndDate: "19.12.2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of High Speed Camera (Q3) - Gem Bid No: GEM/2022/B/2821074",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2821074.pdf",
          LinkName: "BID Document",
        },
      ],
      OpenDate: "12.12.2022",
      EndDate: "30.12.2022 @ 17:00 hrs.",
    },

    {
      Title: "Supply of Tables, Chair & Rack - Gem Bid No: GEM/2022/B/2750092",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2750092.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "08-12-2022",
      EndDate: "29-12-2022 @ 16:00 hrs.",
    },
    {
      Title:
        "Hiring of Manpower for Sanitization Services - Gem Bid No: GEM/2022/B/2808874",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2808874.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-1_GEM2022B2808874.pdf",
          LinkName: "Corrigendum-I (13-12-2022)",
          glow: true,
        },
      ],
      OpenDate:
        "02-12-2022\nPre Bid Meeting: 07-12-2022 @ 15:00 hrs\nIntial Due date: 12-12-2022 16:00:00",
      EndDate:
        "12-12-2022 @ 16:00 hrs.\nRevised Due Date: 20-12-2022 @14:00 Hrs",
    },
    {
      Title: "Supply of Software - Gem Bid No: GEM/2022/B/2810390",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2810390.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "07-12-2022",
      EndDate: "17-12-2023 @ 21:00 hrs.",
    },
    {
      Title:
        "Supply of Audio Visual Equipment with accessoriesr - Gem Bid No: GEM/2022/B/2808594",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2808594.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GeM2022B2808594_Stage-2_evaluation_report.pdf",
          LinkName: "Stage 2 Evalution Report",
          glow: true,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GeM2022B2808594_Stage-1_evaluation_report.pdf",
          LinkName: "Stage 1 Evalution Report",
          glow: true,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum1_GEM2022B2808594.pdf",
          LinkName: "Corrigendum - I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2808594_Corrigendum-II.pdf",
          LinkName: "Corrigendum - II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B2808594-Corrigendum-III.pdf",
          LinkName: "Corrigendum - III",
        },
      ],
      OpenDate: "02-12-2022",
      EndDate: "Extended upto 19-01-2023 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of Nuclear Magnetic Resonance Spectrometer - Gem Bid No: GEM/2022/B/2723746",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2723746.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/Corrigendum-I_GEM2022B2723746.pdf",
          LinkName: "Corrigendum - I (10/01/2023)",
          glow: true,
        },
      ],
      OpenDate: "01-12-2022",
      EndDate:
        "Open date: 22-12-2022 18:30 \nDue date & Time : 18-01-2023 15:00",
    },
    {
      Title: "Supply of Water Purifers - Gem Bid No: GEM/2022/B/2750924",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2750924.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "30-11-2022",
      EndDate: "21-12-2022 @ 15.00 hrs.",
    },

    {
      Title:
        "Supply of Oscilloscope and Robotic Manipulator - Gem Bid No: GEM/2022/B/2720224",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2720224.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "30-11-2022",
      EndDate: "21-12-2022 @ 18.30 hrs.",
    },
    {
      Title: "Supply of Server - Gem Bid No: GEM/2022/B/2741212",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2741212.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "28-11-2022",
      EndDate: "19-12-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of High Performance Liquid Chromatography - Gem Bid No: GEM/2022/B/2782895",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2782895.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "25-11-2022",
      EndDate: "16-12-2022 @ 16.00 hrs.",
    },
    {
      Title:
        'NIQ documents of "Cleaning of Overhead Water Tanks at all Transit Campus Buildings and at Occupied Residential Quarters, IIT Tirupati Permanent Campus" - NIQ No: IITT/PC/NIQ/48/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-48_ IITTPCNIQ482022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_48_Annexure I.pdf",
          LinkName: "1. NIQ-48_Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_48_Annexure II - Schedule of Quantities.pdf",
          LinkName: "2. NIQ-48_Annexure II - Schedule of Quantities",
        },
      ],
      OpenDate: "18-11-2022",
      EndDate: "25-11-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "PR for Empanelment of Newspaper advertisement service - BID No: GEM/2022/B/2629769",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2629769.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/SLA-2729769.pdf",
          LinkName:
            "1. Special Terms and Conditions for Advertisement Service – Newspaper",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/gtc-1665308595.pdf",
          LinkName: "2. General Terms and Conditions on GeM 4.0",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTSOW.pdf",
          LinkName:
            "3. Expression of Interest for Empanelment of Newspaper Advertising Agency",
        },
      ],
      OpenDate: "16-11-2022",
      EndDate: "07-12-2022 @ 11.00 hrs.",
    },
    {
      Title: "Supply of Laptop - BID No: GEM/2022/B/2720989",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2720989.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "14-11-2022",
      EndDate: "30-11-2022 @ 16.00 hrs.",
    },
    {
      Title:
        'NIQ documents of "Refilling of 71 no’s of CO2 (4.5 kg) and 53 no’s of ABC (6 kg) Fire Extinguishers, South Campus, IIT Tirupati" - NIQ No: IITT/PC/NIQ/46/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-46_IITTPCNIQ462022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/BoQ_IITTPCNIQ462022-23.pdf",
          LinkName: "BoQ",
        },
      ],
      OpenDate: "10-11-2022",
      EndDate: "17-11-2022 @ 15.00 hrs.",
    },
    {
      Title:
        'NIQ documents of "Design, fabrication, assembling and fixing of Powder coated Aluminium Partitions with laminated particle board and other civil works in Control & Automation Lab (Lab-2) at IIT Tirupati Transit Campus" - NIQ No: IITT/PC/NIQ/47/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_47_IITTPCNIQ472022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Annexure I_IITTPCNIQ472022-23.pdf",
          LinkName: "Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Annexure II_IITTPCNIQ472022-23.pdf",
          LinkName: "Annexure II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Drawings_IITTPCNIQ472022-23.pdf",
          LinkName: "Drawings",
        },
      ],
      OpenDate: "09-11-2022",
      EndDate: "16-11-2022 @ 15.00 hrs.",
    },
    {
      Title: "Hiring of Manpower Service - BID No: GEM/2022/B/2705438",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2705438.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "09-11-2022",
      EndDate: "30-11-2022 @ 14.00 hrs.",
    },
    {
      Title:
        "Supply of Glove Box With Gas Purification System Integrated - BID No: GEM/2022/B/2700952",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2700952.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "07-11-2022",
      EndDate: "26-11-2022 @ 14.00 hrs.",
    },
    {
      Title:
        "Supply of Mac OS Server with Accessories - BID No: GEM/2022/B/2631369",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2631369.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "07-11-2022",
      EndDate: "28-11-2022 @ 17.00 hrs.",
    },
    {
      Title: "Hiring of Ambulance Service - BID No: GEM/2022/B/2702341",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2702341.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "07-11-2022",
      EndDate: "18-11-2022 @ 17.00 hrs.",
    },
    {
      Title:
        'NIT for "SITE SURVEY, DESIGN, ENGINEERING, SUPPLY, STORAGE, CIVIL WORKS, INSTALLATION, TESTING, AND COMMISSIONING OF 780kwp SOLAR PV PROJECT ON THE ROOFTOP OF VARIOUS ACADEMIC BUILDINGS OF IIT TIRUPATI, INCLUDING OPERATION & MAINTENANCE (O & M) OF THE SYSTEM FOR A PERIOD OF 25 YEARS UNDER RESCO MODEL AFTER OPERATIONAL ACCEPTANCE" - NIT No: IITT/EU/E&M/Tender/2022-23/003',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTEUE&MTender2022-23003.pdf",
          LinkName: "NIT Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=Sx0RAkUOcTy1Gl1f0pVwFvQ%3D%3D",
          LinkName: "LINK-1",
        },
      ],
      OpenDate: "02-11-2022 @ 18.00 hrs",
      EndDate: "26-11-2022 @ 15.00 hrs.",
    },
    {
      Title: "Supply of Audio Visual Equipment - BID No: GEM/2022/B/2682738",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2682738.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Stage_2-GEM2022B2682738.pdf",
          LinkName: "Stage-II Evaluation Report",
          glow: true,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Stage1evalutaion_GeM2022B2682738.pdf",
          LinkName: "Stage-I Evaluation Report",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum_GEM2022B2682738.pdf",
          LinkName: "Corrigendum-I (11/11/2022)",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2682738_Corrigendum-II.pdf",
          LinkName: "Corrigendum-II (30/11/2022)",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2682738_Corrigendum-III.pdf",
          LinkName: "Corrigendum-III (09/12/2022)",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2023/GEM2022B2682738_ Bid due date extension.pdf",
          LinkName: "Corrigendum-IV (19/12/2022)",
        },
      ],
      OpenDate: "28-10-2022",
      EndDate: "26-12-2022 @ 15.00 hrs.",
    },

    {
      Title: "Supply of Laptops - BID No: GEM/2022/B/2651241",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2651241.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "28-10-2022",
      EndDate: "18-11-2022 @ 16.00 hrs.",
    },
    {
      Title: "Supply of Laptops - BID No: GEM/2022/B/2651241",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2651241.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "28-10-2022",
      EndDate: "18-11-2022 @ 16.00 hrs.",
    },
    {
      Title: 'Supply of "Water Coolers" - BID No: GEM/2022/B/26528433',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2652843.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "21-10-2022",
      EndDate: "11-11-2022 @ 17.00 hrs.",
    },
    {
      Title:
        'NIQ for "Providing & fixing Laboratory sink and Curtains for Doors & windows at Quantum technology lab (D1019) in IIT Tirupati Permanent Campus" - NIQ No: IITT/PC/NIQ/45/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ_45-IITTPCNIQ452022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Annexure I-IITTPCNIQ452022-23.pdf",
          LinkName: "Annexure I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Annexure II - Schedule of Quantities-IITTPCNIQ452022-23.pdf",
          LinkName: "Annexure II - Schedule of Quantities",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Drawing-IITTPCNIQ452022-23.pdf",
          LinkName: "Drawing",
        },
      ],

      OpenDate: "20-10-2022",
      EndDate: "26-10-2022 @ 15.00 hrs.",
    },

    {
      Title: "Supply of Wired Active Components - Bid No: GEM/2022/B/2655243",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2655243.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-GEM2022B2655243.pdf",
          LinkName: "Corrigendum-I (04/11/2022)",
        },
      ],

      OpenDate: "19-10-2022",
      EndDate: "09-11-2022 @ 11.00 hrs.",
    },
    {
      Title:
        "Supply of Wireless Active Components - Bid No: GEM/2022/B/2653753",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2653753.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2653753-C6.pdf",
          LinkName: "Corrigendum-I (03/11/2022)",
        },
      ],

      OpenDate: "18-10-2022",
      EndDate: "08-11-2022 @ 17.30 hrs.",
    },
    {
      Title: "Supply of Wifi Access Points - Bid No: GEM/2022/B/2635152",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2635152.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "14-10-2022",
      EndDate: "24-10-2022 @ 15.00 hrs.",
    },

    {
      Title:
        "Supply of Biometric Devices, Portable RFID, Fingerprint access, Electromagnetic Locks, Tripod Turnstile and Software - Bid No: GEM/2022/B/2609547",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2609547.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "06-10-2022",
      EndDate: "27-10-2022 @ 12.00 hrs.",
    },
    {
      Title: "Supply of Prototyping Machine - Bid No: GEM/2022/B/2609121",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2609121.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "06-10-2022",
      EndDate: "27-10-2022 @ 15.00 hrs.",
    },
    {
      Title: "Supply of Freeze Dryer - Bid No: GEM/2022/B/2606544",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2606544.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "04-10-2022",
      EndDate: "25-10-2022 @ 15.00 hrs.",
    },
    {
      Title: "Supply of Desktop Computers - Bid No: GEM/2022/B/2596218",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2596218.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "04-10-2022",
      EndDate: "21-10-2022 @ 15.00 hrs.",
    },
    {
      Title: "Supply of Computer Workstation - Bid No: GEM/2022/B/2534594",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2534594.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "04-10-2022",
      EndDate: "19-10-2022 @ 18.00 hrs.",
    },
    {
      Title:
        "Supply of Computer Workstation & Server - Bid No: GEM/2022/B/2537415",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2537415.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "04-10-2022",
      EndDate: "19-10-2022 @ 18.00 hrs.",
    },
    {
      Title:
        "Supply of Automatic Vapor pressure Analyzer - Bid No: GEM/2022/B/2589881",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2589881.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "30-09-2022",
      EndDate: "20-10-2022 @ 11.00 hrs.",
    },
    {
      Title:
        "Supply of BET Surface Area Analyzer - Autosorb - Bid No: GEM/2022/B/2558229",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2558229.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "29-09-2022",
      EndDate: "12-10-2022 @ 13.00 hrs.",
    },
    {
      Title:
        "Supply of Digital Storage Oscilloscope with inbuilt Function Generator - Bid No: GEM/2022/B/2578421",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GEM2022B2578421.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "29-09-2022",
      EndDate: "17-10-2022 @ 15.00 hrs.",
    },

    {
      Title: "Supply of Computer Workstations - Bid No: GEM/2022/B/2565695",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GeM-Bidding-3819446.pdf",
          LinkName: "BID Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "23-09-2022",
      EndDate: "13-10-2022 @ 12.00 hrs.",
    },
    {
      Title:
        'NIQ documents of "Laying of Irrigation line for Horticultural works at IIT Tirupati, Merlapaka Village, Yerpedu Mandal, A.P." - NIQ No: IITT/PC/NIQ/44/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-44_IITTPCNIQ442022-23.pdf",
          LinkName: "NIQ Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "15-09-2022 @ 12.00 hrs",
      EndDate: "23-09-2022 @ 15.00 hrs.",
    },
    {
      Title:
        'Supply of "4-port Vector Network Analyzer (VNA) working up to 43.5 GHz" - BID No: GEM/2022/B/2531842',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/GeM-Bidding-3783311.pdf",
          LinkName: "Bid Document",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "16-09-2022 @ 12.00 hrs",
      EndDate: "04-10-2022 @ 16.00 hrs.",
    },
    {
      Title:
        'NIT documents of "Annual Electrical Operations and Maintenance Services & Minor Electrical Works at IIT Tirupati, Merlapaka Village, Yerpedu Mandal, Tirupati District, A.P." - NIT No: IITT/EU/E&M/Tender/2022-23/002',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-DNo.IITTEUE&MTender2022-23002.pdf",
          LinkName: "NIT Document",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-NIT no IITTEUE&MTender2022-23002.pdf",
          LinkName: "Corrigendum-I",
          glow: true,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-2-NIT no IITTEUE&MTender2022-23002.pdf",
          LinkName: "Corrigendum-II",
          glow: true,
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SXNsFuK5AdZu9UD9dCMWWpg%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "30.08.2022 @ 12.00 hrs",
      EndDate: "20.09.2022 @ 16.00 hrs.",
    },

    {
      Title:
        'NIQ documents of "Design, Fabrication, Assembling and fixing of powder coated Aluminium partitions with laminated particle board in Departement block 2 at permanent campus & Lab-2 UPS Room in IIT Tirupati South campus." - NIQ No: IITT/PC/NIQ/43/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-43_IITTPCNIQ432022-23.pdf",
          LinkName: "NIQ",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/DB2-FloorDrawings_IITTPCNIQ432022-23.pdf",
          LinkName: "DB2 Floor Drawings",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "18-08-2022 @ 12.00 hrs",
      EndDate: "24-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Notice Inviting Tender for Smart Laundry at IIT Tirupati - Tender No: llTTP/Laundry/2022-23/002",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/llTTPLaundry2022-23002.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "16-08-2022 @ 12.00 hrs",
      EndDate: "26-08-2022 @ 15.00 hrs.",
    },

    {
      Title:
        "Supply of Magnetic Particle Testing Dye Penetrant Testing Kit Welding Table Welding trolly and welding fumes extracting system - Tender No: IITT/MECH/2022-23/41",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTMECH2022-2341.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SzNFda1V3ldvdKdmcHHsvKQ%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "05-08-2022 @ 12.00 hrs",
      EndDate: "25-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        'NIQ document of "Construction of Concrete basketball court and red soil volleyball court in wing 1 at Hostel 1 at the permanent Campus" - NIQ No: IITT/PC/NIQ/42/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-42_IITTPCNIQ422022-23.pdf",
          LinkName: "NIQ",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "03-08-2022 @ 12.00 hrs",
      EndDate: "10-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of Programmable DC Power Supply - Tender No: IITT/ELE/2022-23/40",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTELE2022-2340.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SnhVKN%2Bh2OioifOkYj93RiA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "04-08-2022 @ 12.00 hrs",
      EndDate: "25-08-2022 @ 15.00 hrs.",
    },

    {
      Title: "Supply of Computer Lab Furniture - Tender No: IITT/EU/2022-23/39",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTEU2022-2339.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-1_IITTEU2022-2339.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SM%2FZRA%2FvJ2DzQGAUlLp7WJw%3D%3D",
          LinkName: "Link-II",
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Stage-I%20Evaluation%20report-IITTEU2022-2339.pdf",
          LinkName: "Stage-I Evaluation Report (09/11/2022)",
          glow: true,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Stage-II%20Evaluation%20report-IITTEU2022-2339.pdf",
          LinkName: "Stage-II Evaluation Report (13/01/2023)",
          glow: true,
        },
      ],
      OpenDate: "03-08-2022 @ 12.00 hrs",
      EndDate: "30-08-2022 @ 15.00 hrs.",
    },

    {
      Title:
        'NIT document of "Development and Maintenance of Horticulture – Landscape Gardening works at IIT Tirupati, Merlapaka Village, Yerpedu Mandal, Tirupati District, A.P." - NIT No: IITTP/EU/HORT/T/2022-23/003',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTPEUHORTT2022-23003.pdf",
          LinkName: "NIT",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=view&page=PublishedTenderList&service=direct&session=T&sp=SOncN9WavuxUYHKd9hPIwelzCJ%2Fk7IZKFF92YZPE7%2BAiJ5hiBLvelZ%2FcGzVW8pKcJ",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "02-08-2022 @ 12.00 hrs",
      EndDate: "20-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        'NIQ document of "Removing of Existing Perforated MS lath opening in the Rolling shutters and providing of hand operated Gearbox for existing rolling shutters in Lab1 & Lab2 at IIT Tirupati South Campus" - Tender No: IITT/PC/NIQ/41/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-41-IITTPCNIQ412022-23.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "29-07-2022 @ 12.00 hrs",
      EndDate: "04-08-2022 @ 15.00 hrs.",
    },

    {
      Title: "Supply of Freeze Dryer - Tender No: IITT/CHEM/2022-23/38",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTCHEM2022-2338.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=Su5oFse%2BTDZIMx3ibjAec%2Bw%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "27-07-2022 @ 12.00 hrs",
      EndDate: "16-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of Hot wire anemometer and pressure scanner for low speed wind tunnel - Tender No: IITT/MECH/2022-23/36",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTMECH2022-2336.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigedum-1_IITTMECH2022-2336.pdf",
          LinkName: "Corrigendum-I",
          glow: true,
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=Sht1AKW0x3%2Fj8Em%2FR283W8A%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "25-07-2022 @ 12.00 hrs",
      EndDate: "15-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of Hot wire anemometer and pressure scanner for low speed wind tunnel - Tender No: IITT/MECH/2022-23/36",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTMECH2022-2336.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigedum-1_IITTMECH2022-2336.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      eProcurementLinks: [
        { Link: "https://eprocure.gov.in/eprocure/app", LinkName: "Link-I" },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=Sht1AKW0x3%2Fj8Em%2FR283W8A%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "25-07-2022 @ 12.00 hrs",
      EndDate: "15-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of Micro Particle Image Velocimetry - Tender No: IITT/CHEM/2022-23/37",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTCHEM2022-2337.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SQYhja%2B6apzWXIuTAXD%2FZeA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "25-07-2022 @ 12.00 hrs",
      EndDate: "15-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply of Complete Multidetector Gel permeation/ Size Exclusion Chromatography(GPC/SEC) - Tender No: IITT/CHEM/2022-23/35",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTCHEM2022-2335.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },

        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=S%2B%2B2Nhk%2BXiJwI%2BXS%2BQA1PiQ%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "18-07-2022 @ 12.00 hrs",
      EndDate: "18-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply, installation, testing and commissioning of High Performance Computing (HPC) Cluster 1 Master node, 2 Compute nodes, 2 Network Communication, 1 Server rack and initial software installation - Tender No: IITT/ CSRC/MECH/2021-22/167",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITT%20CSRCMECH2021-22167.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigedum-1_IITT%20CSRCMECH2021-22167.pdf",
          LinkName: "Corrigendum-I",
          glow: true,
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SGrOGR0PqlSRdsZeuABpA2A%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "15-07-2022 @ 12.00 hrs",
      EndDate: "05-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Supply, installation, testing and commissioning of Foam Analyser - Tender No: IITT/ CSRC/CHEM/2021-22/197",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITT%20CSRCCHEM2021-22197.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SvW7J4snW7VP7xAI16xB65A%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "15-07-2022 @ 12.00 hrs",
      EndDate: "05-08-2022 @ 15.00 hrs.",
    },
    {
      Title:
        "Notice Inviting Tender for Providing and Fixing of SS Railing on both sides of the Handicapped Ramp in Open Air Theatre at IIT Tirupati South Campus - Tender No: IITT/PC/NIQ/40/2022-23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTPCNIQ402022-23.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "14-07-2022 @ 15.00 hrs",
      EndDate: "21-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Notice Inviting Tender for Cafeteria at IIT Tirupati - Tender No: llTTP/Cafeteria/2022-23/002",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/llTTPCafeteria2022-23002.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "07-07-2022 @ 15.00 hrs",
      EndDate: "15-07-2022 @ 15.00 hrs",
    },

    {
      Title:
        "Supply of Workstation PC - Tender No: IITT/ CSRC/CHEM/2022-23/141",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITT%20CSRCCHEM2022-23141.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SPrc43R3625AAsIfQ3ezoyg%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "08-07-2022 @ 15.00 hrs",
      EndDate: "29-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Group Term Life Insurance Policy for IIT Tirupati Students - Tender No: IITT/GTIP/2022-23/34",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTGTIP2022-2334.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SgNZVQirUvc7r8glNcgCTjA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "08-07-2022 @ 15.00 hrs",
      EndDate: "18-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        'NIQ document of "Providing and Fixing Acoustic wall panelling work in the EU Meeting Room & fixing MS railing work near the retaining wall in the playground area at IIT Tirupati South campus" - NIQ No: IITT/PC/NIQ/39/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-39_IITTPCNIQ392022-23.pdf",
          LinkName: "NIQ",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "07-07-2022 @ 15.00 hrs",
      EndDate: "13-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of Equipment for Control of level via flowrate control and stirred tank with multivariable control - Tender No: IITT/CHEM/2022-23/33",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTCHEM2022-2333.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SiD65ZclVlZSNwp38ER1knQ%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "07-07-2022 @ 17.00 hrs",
      EndDate: "27-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of Finite Element based customized welding software - Tender No: IITT/ CSRC/MECH/2022-23/139",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITT%20CSRCMECH2022-23139.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-1_IITT%20CSRCMECH2022-23139.pdf",
          LinkName: "Corrigendum-I",
          glow: true,
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=Ssu6Mzn9jJ8fIU90xE0NFfw%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "28-06-2022 @ 18.00 hrs",
      EndDate: "19-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of Dining Tables & Dining Chairs - Tender No: IITT/EU/2022-23/32",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTEU2022-2332.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SThe9nEd08MR84BsbS8G0NA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "28-06-2022",
      EndDate: "26-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Hiring of Bus, Tempo, Truck and Taxi Services - Tender No: IITT/ADMIN/2022-23/31",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTADMIN2022-2331.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigedum1_IITTADMIN2022-2331.pdf",
          LinkName: "Corrigendum-I",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigedum2_IITTADMIN2022-2331.pdf",
          LinkName: "Corrigendum-II",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum3_IITTADMIN2022-2331.pdf",
          LinkName: "Corrigendum-III",
          glow: true,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-4_IITTADMIN2022-2331.pdf",
          LinkName: "Corrigendum-IV",
          glow: true,
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SYFUarAqw7msTW%2F%2BjBOc5sw%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "23-06-2022 @ 17.00 hrs",
      EndDate: "07-07-2022 @ 15.00 hrs",
    },
    {
      Title: "Supply of Workstations - Tender No: IITT/ CSRC/MECH/2022-23/134",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITT%20CSRCMECH2022-23134.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=S4QDSfEC162cmAF3r%2FkQK0A%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "20-06-2022 @ 13.00 hrs",
      EndDate: "11-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of High End Workstation with Intelligent Network Accessories - Tender No: IITT/ CSRC/ELE/2022-23/132",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITT%20CSRCELE2022-23132.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=Sbpu3wDTcqpBVKUpolNuHzw%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "20-06-2022 @ 13.00 hrs",
      EndDate: "11-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        'NIQ document of "Proposal for constructing drain at lawn area in front of the Dining Block in IIT Tirupati South campus" - NIQ No: IITT/PC/NIQ/38/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-IITTPCNIQ382022-23.pdf",
          LinkName: "NIQ",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "09-06-2022 @ 15.00 hrs",
      EndDate: "20-06-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Limited Tender Documents for Shifting of Items from IIT Tirupati Temporary Premises Renigunta To IIT Tirupati Permanent Campus, Yerpedu on Lumpsum basis -Tender No: IITT/ADMIN/2022-23/29",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Limited%20Tender%20Enquiry%20IITTP_IITTADMIN2022-2329.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "08-06-2022 @ 15.00 hrs",
      EndDate: "16-06-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply, Installation, Testing and Commissioning of High Performance Parallel Redundant Ups Systems with Built-In/External Galvanic Isolation Transformers -Tender No: IITT/EU/2022-23/30",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/UPSTender_IITTEU2022-2330.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-1_IITTEU2022-2330.pdf",
          LinkName: "Corrigendum-I",
          glow: true,
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigedum-2_IITTEU2022-2330.pdf",
          LinkName: "Corrigendum-II",
          glow: true,
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },

        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndLatestActiveTenders&service=direct&session=T&sp=ScwU11ewKIFdv0OSM2sRVbQ%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "09-06-2022 @ 15.00 hrs",
      EndDate: "05-07-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of Microfiltration and Ultrafiltration Membrane System -Tender No: IITT/CHEM/2022-23/28",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTCHEM2022-2328.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=S5eE9rXp762hqnxu2ou6G0w%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "01-06-2022 @ 15.00 hrs",
      EndDate: "21-06-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of 50KN Electro Mechanical Universal Testing Machine -Tender No: IITT/MECH/2022-23/26",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTMECH2022-2326.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SFdJWrGdN64WjBkeoGRmlTA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "01-06-2022 @ 15.00 hrs",
      EndDate: "21-06-2022 @ 15.00 hrs",
    },
    {
      Title: "Supply of Thermogravimetry -Tender No: IITT/CY/2022-23/27",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTCY2022-2327.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum1_IITTCY2022-2327.pdf",
          LinkName: "Corrigendum-I",
          glow: true,
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SX8DsjzEjl5gpasBY1CVF0A%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "01-06-2022 @ 15.00 hrs",
      EndDate: "21-06-2022 @ 15.00 hrs",
    },
    {
      Title:
        "NIQ document of 'Providing and Fixing of Speed Limit Board (10Nos), Direction Boards for Home office (02Nos) in IIT Tirupati South campus' - NIQ No: IITT/PC/NIQ/36/2022-23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-IITTPCNIQ362022-23.pdf",
          LinkName: "NIQ",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-36-IITTPCNIQ362022-23.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "27-05-2022 @ 15.00 hrs",
      EndDate: "07-06-2022 @ 15.00 hrs",
    },
    {
      Title:
        'NIQ document of "Aluminium Partition work in New Class Room Second Floor Meeting Room in IIT Tirupati South campus" - NIQ No: IITT/PC/NIQ/37/2022-23',
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-IITTPCNIQ372022-23.pdf",
          LinkName: "NIQ",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/NIQ-37-IITTPCNIQ372022-23.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      eProcurementLinks: [],
      OpenDate: "27-05-2022 @ 15.00 hrs",
      EndDate: "07-06-2022 @ 15.00 hrs",
    },
    {
      Title: "Supply of Computer Workstation -Tender No: IITT/ELE/2022-23/25",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTELE2022-2325.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SGi6A6Mnq4SI%2Bf7LRQy0YSA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "25-05-2022 @ 15.00 hrs",
      EndDate: "15-06-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Providing Flood Lighting for Playground at IIT Tirupati(South campus), Merlapaka (V), Yerpedu (M), Tirupati (Dt) -Tender No: IITT/EU/E&M/Tender/2022-23/001",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTEUEMTender2022-23001.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=S0F49v%2F42jJ%2FPaBiNp1Hgzw%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "17-05-2022 @ 15.00 hrs",
      EndDate: "31-05-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of Components for Determination of Electron Density from Stark Broadening - Tender No: IITT/PHY/2022-23/23",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTPHY2022-2323.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },

        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SSXbRjESarprpJrRq00LLXQ%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "18-05-2022 @ 17.00 hrs",
      EndDate: "08-06-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of Data Acquisition System - Tender No: IITT/ELE/2022-23/22",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTELE2022-2322.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SeKFq53mBsyXhoK8UQXattQ%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "18-05-2022 @ 17.00 hrs",
      EndDate: "08-06-2022 @ 15.00 hrs",
    },
    {
      Title: "Supply of LCR Meter - Tender No: IITT/ELE/2022-23/24",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTELE2022-2324.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-I_IITTELE2022-2324.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },

        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SgZF1pVp1pIhlAsDlnfkBfA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "18-05-2022 @ 17.00 hrs",
      EndDate: "15-06-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of Thermogravimetric analyser with differential scanning calorimetry - Tender No: IITT/CHEM/2022-23/21",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTCHEM2022-2321.pdf",
          LinkName: "Tender",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/Corrigendum-I_IITTCHEM2022-2321.pdf",
          LinkName: "Corrigendum-I",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SgZF1pVp1pIhlAsDlnfkBfA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "13-05-2022 @ 17.00 hrs",
      EndDate: "02-06-2022 @ 15.00 hrs",
    },
    {
      Title:
        "Supply of MAC OS Based Rack Server - Tender No: IITT/CSE/2022-23/20",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTCSE2022-2320.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SyI%2BirsZlJf0OPoeWq2emDA%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "13-05-2022 @ 17.00 hrs",
      EndDate: "02-06-2022 @ 15.00 hrs",
    },
    {
      Title: "Supply of Electrospraying Unit - Tender No: IITT/CHEM/2022-23/19",
      Documents: [
        {
          Link: "https://files.iittp.ac.in/pdfs/tenders/2022/IITTCHEM2022-2319.pdf",
          LinkName: "Tender",
        },
      ],
      eProcurementLinks: [
        {
          Link: "https://eprocure.gov.in/eprocure/app",
          LinkName: "Link-I",
        },
        {
          Link: "https://eprocure.gov.in/eprocure/app?component=%24DirectLink&page=FrontEndViewTender&service=direct&session=T&sp=SOERY5TPQ55douPqNC76BWg%3D%3D",
          LinkName: "Link-II",
        },
      ],
      OpenDate: "13-05-2022 @ 17.00 hrs",
      EndDate: "02-06-2022 @ 15.00 hrs",
    },
  ];

  return (
    <>
      <Header />
      <Breadcrumb title="Home" subtitle="Tenders" />
      <section id="services" className="team-area fix p-relative pt-120 pb-80">
        <div className="container">
          <Row>
            {/* <Col md={3} className='c-left custom-padding-color'>
                            <TendorLeftMenu />
                        </Col> */}

            <Col md={12} className="c-right table-responsive">
              <Col md={3} className="mt-3 mb-3 text-center">
                <TendorLeftMenu />
              </Col>

              <Link
                className="c-link float-end mb-2"
                to="/independent-external-monitors-iems"
              >
                Independent External Monitors (IEMs)
              </Link>

              <table className="table table-striped">
                <tbody>
                  <tr className="c-tablehead ">
                    <th className="text-center">Title</th>
                    <th>Documents</th>
                    <th>eProcurement Link(s)</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                  </tr>
                  {tenderJSON.map((item, index) => (
                    <tr key={index}>
                      <td>{item.Title}</td>
                      <td>
                        <ul>
                          {Array.isArray(item.Documents) &&
                            item.Documents.map((link, linkIndex) => (
                              <li key={linkIndex}>
                                {link.Link.startsWith("http") ? (
                                  <a
                                    className={`c-link ${link.glow ? "glowing-text" : ""
                                      }`}
                                    href={link.Link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {link.LinkName}
                                  </a>
                                ) : (
                                  <Link
                                    className={`c-link ${link.glow ? "glowing-text" : ""
                                      }`}
                                    to={link.Link}
                                    target="_blank"
                                  >
                                    {link.LinkName}
                                  </Link>
                                )}
                              </li>
                            ))}
                        </ul>
                      </td>

                      <td className="text-center">
                        <ul>
                          {Array.isArray(item.eProcurementLinks) &&
                            item.eProcurementLinks.map((link, linkIndex) => (
                              <li key={linkIndex}>
                                <a
                                  className={`c-link ${link.glow ? "glowing-text" : ""
                                    }`}
                                  href={link.Link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {link.LinkName}
                                </a>
                              </li>
                            ))}
                        </ul>
                      </td>
                      <td>{item.OpenDate}</td>
                      <td>{item.EndDate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Col>
          </Row>{" "}
          {/* Row */}
        </div>{" "}
        {/* container */}
      </section>
    </>
  );
}

export default StatementExpenELe;
